// Dansk oversettelse basert på ENG.js
import { ROOM_INFO_TRANSLATIONS } from './roomsInfo';

const DAN = {
  'messenger_v2.call.share_screen': "Del skærm",
  'messenger_v2.call.ongoing': "Gruppeopkald i gang",
  'messenger_v2.call.ongoing_video': "Videoopkald i gang",
  'messenger_v2.call.ongoing_voice': "Taleopkald i gang",
  'messenger_v2.call.more_members': "{count} flere deltagere",
  'messenger_v2.call.mute_sound': "Slå lyd fra",
  'messenger_v2.call.unmute_sound': "Slå lyd til",
  'messenger_v2.call.sound_off': "Lyd slået fra",
  'messenger_v2.call.live_members': "{count} i opkaldet nu",
  'messenger_v2.call.waiting_members': "Venter på deltagere",
  'messenger_v2.call.joining': "Tilslutter…",
  'messenger_v2.call.return_to_call': "Tilbage til opkaldet",
  'messenger_v2.call.rejoin_failed': "Kunne ikke deltage i opkaldet. Prøv igen.",
  'messenger_v2.call.stop_sharing': "Stop deling",
  'messenger_v2.call.share_pending': "Opdaterer skærmdeling",
  'messenger_v2.call.share_unsupported': "Denne browser kan ikke dele skærmen. Du kan stadig se delte skærme.",
  'messenger_v2.call.share_denied': "Skærmdeling blev annulleret, eller tilladelsen blev afvist. Opkaldet er stadig forbundet.",
  'messenger_v2.call.share_failed': "Skærmdeling kunne ikke startes eller stoppes korrekt. Prøv igen.",
  'messenger_v2.call.view_screen': "Vis skærmen for {name}",
  'messenger_v2.call.expand_screen': "Udvid delt skærm",
  'messenger_v2.call.exit_expand_screen': "Afslut udvidet skærm",
  'messenger_v2.pin.pin': 'Fastgør chat',
  'messenger_v2.pin.unpin': 'Frigør chat',
  'messenger_v2.pin.pinned': 'Fastgjort chat',
  'messenger_v2.pin.failed': 'Kunne ikke opdatere fastgjort chat. Prøv igen.',
  'messenger_v2.self.name': '{name} (Dig)',
  'messenger_v2.self.subtitle': 'Send besked til dig selv',
  ...ROOM_INFO_TRANSLATIONS.DAN,
  'tabs.more': 'Mere',
  'header.footer.short.find_grave': 'Find grav',
  'header.footer.short.how': 'Hvordan',
  'header.footer.short.about': 'Om',
  'notifications.general.title': 'Notifikation',
  'notifications.auth.title': 'Autentificering',
  'notifications.requests.title': 'Forespørgsler',
  'notifications.gravesHub.title': 'Graveoversigt',
  'notifications.graves.title': 'Grave',
  'notifications.memoryWall.title': 'Mindevæg',
  'notifications.payments.title': 'Betalinger',
  'notifications.settings.title': 'Indstillinger',
  'notifications.groups.title': 'Grupper',
  'notifications.sparks.title': 'Sparks',
  'notifications.store.title': 'Butik',
  'notifications.purchase.title': 'Køb',
  'notifications.userProfile.title': 'Mit Lys',
  'notifications.messaging.title': 'Beskeder',
  'messenger.header.unseen_messages': 'Beskeder, {count} nye',
  'notifications.messages.title': 'Beskeder',
  'notifications.connectRequests.title': 'Forbindelsesanmodninger',
  'notifications.designSystem.title': 'Designsystem',
  'notifications.subscription.title': 'Abonnement',
  'notifications.comments.title': 'Kommentarer',
  'notifications.familyTree.title': 'Stamtræ',
  notifications_page_title: 'Notifikationer',
  notifications_see_all: 'Se alle',
  worthy_calendar_precision_year: 'År',
  worthy_calendar_precision_month: 'Måned',
  worthy_calendar_precision_date: 'Dato',
  worthy_calendar_precision_heading: 'Vælg datopræcision',
  worthy_calendar_unset: 'Ingen dato valgt',
  worthy_calendar_unset_time: 'Ingen tid valgt',
  worthy_calendar_selection_value: '{iso} ({precision})',
  worthy_calendar_select_month: 'Vælg måned',
  worthy_calendar_select_year: 'Vælg år',
  worthy_calendar_select_day: 'Vælg dag',
  worthy_calendar_previous: 'Forrige',
  worthy_calendar_next: 'Næste',
  worthy_calendar_selected_label: 'Valgt:',
  worthy_calendar_valid_years: 'Gyldige år: {min}–{max}',
  worthy_calendar_choose_date: 'Vælg dato',
  worthy_calendar_choose_time: 'Vælg tid',
  worthy_calendar_choose_datetime: 'Vælg dato og tid',
  worthy_calendar_close: 'Luk',
  worthy_calendar_cancel: 'Annuller',
  worthy_calendar_apply: 'Anvend',
  worthy_calendar_default_label: 'Hændelsesdato',
  worthy_calendar_default_time_label: 'Tidspunkt',
  worthy_calendar_default_datetime_label: 'Dato og tid for hændelsen',
  worthy_calendar_required: 'Vælg venligst en dato',
  worthy_calendar_required_time: 'Vælg venligst et tidspunkt',
  worthy_calendar_required_datetime: 'Vælg venligst dato og tid',
  worthy_calendar_time_heading: 'Vælg tid',
  error_boundary_title: 'Vi opdaterede Netgrav',
  error_boundary_subtitle:
    'Genindlæs siden for at fortsætte. Hvis det bliver ved, så prøv igen om lidt.',
  error_boundary_reload: 'Genindlæs nu',
  error_boundary_show_details: 'Vis detaljer',
  error_boundary_hide_details: 'Skjul detaljer',
  auth_mobileNumber: 'Mobilnummer',
  auth_password: 'Adgangskode',
  auth_passwordPlaceholder: 'Indtast adgangskoden',
  auth_show_password: 'Vis adgangskode',
  auth_hide_password: 'Skjul adgangskode',
  auth_rememberMe: 'Husk mig på denne enhed',
  sign_in: 'Log ind',
  auth_login: 'Log ind',
  auth_get_newsletr: 'Modtag nyheder og opdateringer fra Netgrav',
  auth_notRegistered: 'Har du ikke en konto? ',
  auth_alreadyRegistered: 'Har du allerede en konto? ',
  auth_login_here: 'Log ind',
  register: 'Opret konto',
  auth_register: 'Opret konto',
  'family_tree_guest.eyebrow': 'Familietræ',
  'family_tree_guest.title': 'Se hvordan familien hænger sammen',
  'family_tree_guest.intro':
    'Familietræet giver et fælles sted til at samle mennesker, grave og relationer. Så bliver det lettere at forstå sammenhænge, bevare historier og føre dem videre.',
  'family_tree_guest.primary_cta': 'Log ind for at fortsætte',
  'family_tree_guest.secondary_cta': 'Opret konto',
  'family_tree_guest.note': 'Log ind for at begynde at bygge familiens træ.',
  'family_tree_guest.panel_label': 'Det kan du gøre',
  'family_tree_guest.feature_1':
    'Knyt personer sammen, og se hvordan relationer også opstår undervejs.',
  'family_tree_guest.feature_2': 'Opdag talenter og sanser, som går igen gennem generationerne.',
  'family_tree_guest.feature_3':
    'Familien kan bekræfte det, de genkender, så indsigten bliver tydeligere og mere forankret over tid.',
  'family_tree_guest.feature_1_title': 'Byg og lad træet vokse',
  'family_tree_guest.feature_2_title': 'Talenter og sanser i familien',
  'family_tree_guest.feature_3_title': 'Bekræftet af familien',
  'family_tree_guest.preview_person_name': 'Elias Johansen',
  'family_tree_guest.preview_person_meta': 'Født 1984 • knyttet til familielinjen',
  'family_tree_guest.preview_relation_1': 'Bror',
  'family_tree_guest.preview_relation_2': 'Forælder',
  'family_tree_guest.preview_grave_name': 'Lorense Johansen',
  'family_tree_guest.preview_grave_meta': 'Gravside knyttet til samme familie',
  'family_tree_guest.preview_grave_body':
    'Se, hvordan mennesker og grave hænger sammen i familien over tid.',
  'family_tree_guest.preview_tree_root': 'Elias Johansen',
  'family_tree_guest.preview_tree_root_meta': 'Du kan starte fra én person og bygge udad',
  'family_tree_guest.preview_tree_left': 'Liv Johansen',
  'family_tree_guest.preview_tree_left_meta': 'Mor',
  'family_tree_guest.preview_tree_right': 'Oskar Johansen',
  'family_tree_guest.preview_tree_right_meta': 'Far',
  'family_tree_guest.detail_title': 'Dette kan du gøre i familietræet',
  'family_tree_guest.detail_intro': 'Familietræet binder mennesker, grave og familielinjer sammen.',
  'family_tree_guest.preview_status': 'Talent bekræftet',
  'family_tree_guest.preview_hint': 'Maren genkendte Delegation hos Elias Johansen.',
  auth_forgotPassword: 'Brug for hjælp med din adgangskode?',
  login_phone_verification_message:
    'Login med telefon kræver, at e-mailadressen på kontoen er bekræftet.',
  login_phone_email_verification_message:
    'Bekræft e-mailadressen på kontoen, før du logger ind med telefonnummer. Log ind med din e-mailadresse for at fortsætte.',
  login_send_verification_code: 'Send bekræftelsesmail',
  login_phone_code_sent: 'Bekræftelsesmailen er sendt.',
  login_phone_code_verified: 'E-mailadressen er bekræftet. Logger ind...',
  auth_too_many_attempts: 'For mange loginforsøg. Vent et øjeblik, før du prøver igen.',
  phone_verification_uses_email: 'Telefonbekræftelse sker via e-mail.',
  auth_welcome: 'Velkommen tilbage',
  auth_toNetgrav: 'til netgrav.dk',
  auth_enterPhoneNumber: 'Indtast dit telefonnummer',
  auth_emailOrPhone_label: 'E-mail eller telefonnummer',
  auth_emailOrPhone_placeholder: 'Indtast e-mail eller telefonnummer',
  auth_emailOrPhone_required: 'E-mail eller telefonnummer er påkrævet',
  auth_phone_hint: 'Skriv et lokalt nummer eller brug et internationalt format som +47 45007009.',
  auth_man: 'Mand',
  auth_woman: 'Kvinde',
  auth_other: 'Andet',
  auth_acceptConditions: 'Jeg accepterer at modtage SMS fra Netgrav, og jeg accepterer',
  auth_termsAndCondition: 'vilkår og betingelser',
  auth_next: 'Næste',
  auth_receivedSMS: 'Du vil nu modtage en besked',
  auth_otpCode: 'Indtast OTP-koden',
  auth_received: 'Har du ikke modtaget en engangskode?',
  auth_newOtp: 'Du kan sende en ny engangskode om 00:',
  auth_sendNew: 'Send ny',
  auth_confirm: 'Bekræft',
  confirm: 'Bekræft',
  auth_passwordSentTo: 'Adgangskoden blev sendt til:',
  auth_yourName: 'Dit navn',
  auth_enterFullName: 'Indtast dit navn',
  auth_enterPasswordAgain: 'Indtast adgangskoden igen',
  auth_passwordMessage: 'Brug mindst 7 tegn og 3 af de 4 kategorier:',
  auth_capitalLetter: '⚙︎ Store bogstaver',
  auth_smallLetters: '⚙︎ Små bogstaver',
  auth_digits: '⚙︎ Tal',
  auth_characters: '⚙︎ Specialtegn',
  auth_signupInvitation: 'Du blev inviteret til det bevidste abonnement fra',
  auth_resetPassword: 'Nulstil adgangskode',
  auth_resetPasswordSMS: 'En engangskode er sendt til din mobiltelefon',
  auth_back: 'Tilbage',
  auth_send: 'Send',
  auth_restOtp: 'Indtast engangskoden sendt til {code}{phoneNumber}',
  auth_code: 'Indtast koden',
  auth_confirmPassword: 'Bekræft ny adgangskode',
  auth_newPassword: 'Ny adgangskode',
  auth_notSame: 'Adgangskoderne er ikke ens',
  auth_save: 'Gem',
  'gravesHub.inviteFamily.title': 'Invitér familien til at tage vare på graven',
  'gravesHub.inviteFamily.submit': 'Send invitation',
  'gravesHub.inviteFamily.success':
    'Invitation sendt til {email}. De kan nu hjælpe med at tage vare på graven.',
  'gravesHub.inviteFamily.error': 'Kunne ikke sende invitationen. Prøv igen.',
  'gravesHub.inviteFamily.loading': 'Vent mens vi indlæser siden.',
  settings_profile: 'Profil',
  settings_personalInformation: 'Navn og info',
  settings_payments: 'Betalinger',
  settings_paymentDate: 'Dato',
  settings_paymentStatus: 'Status',
  settings_paymentMethod: 'Betalingsmetode',
  settings_paymentAmount: 'Beløb',
  settings_emptyPayments: 'Der er i øjeblikket ingen betalinger tilgængelige',
  settings_subscription: 'Abonnement',
  settings_members: 'Familie og venner',
  settings_giftInvitations: 'Inviter med en gave',
  settings_notifications: 'Notifikationer',
  settings_security: 'Sikkerhed',
  settings_title: 'Indstillinger',
  settings_back_to_menu: 'Tilbage til indstillinger',
  settings_load_error_title: 'Indstillingerne kunne ikke indlæses',
  settings_load_error_body: 'Kontrollér forbindelsen, og prøv igen.',
  settings_notifications_load_error_title: 'Notifikationerne kunne ikke indlæses',
  settings_notifications_load_error_body: 'Dine notifikationsvalg blev ikke ændret. Prøv igen.',
  settings_password_updated_success: 'Din nye adgangskode er gemt.',
  settings_password_invalid_error: 'Adgangskoden kunne ikke ændres. Kontrollér oplysningerne.',
  account_deletion_requested_success: 'Din anmodning om at slette kontoen er registreret.',
  account_deletion_cancelled_success: 'Sletningen af kontoen er annulleret.',
  account_deletion_update_error: 'Sletningen af kontoen kunne ikke opdateres. Prøv igen.',
  settings_enter_verification_code: 'Indtast verifikationskode',
  settings_verification_code_invalid: 'Koden er ikke korrekt',
  settings_account_information: 'Kontoindstillinger',
  settings_inventory: 'Min samling',
  inventory_section_subtitle: 'End of Time Care i praksis',
  inventory_empty_title: 'Tilføj produkter fra butikken.',
  inventory_empty_description: 'Dit inventar kan bruges på alle grave.',
  inventory_purchase_item: 'Køb vare',
  inventory_purchase_button: 'Gå til butikken',
  settings_contact: 'Kontakt Netgrav',
  settings_password: 'Adgangskode',
  settings_edit: 'Rediger',
  my_light_remove_relation: 'Fjern relation',
  settings_fullName: 'Navn',
  settings_gender: 'Køn',
  settings_occupation: 'Beskæftigelse',
  settings_birthday: 'Fødselsdag',
  settings_email: 'E-mailadresse',
  settings_telephoneNumber: 'Telefonnummer',
  settings_address: 'Adresse',
  settings_language: 'Sprog',
  settings_currency: 'Valuta',
  settings_timeZone: 'Tidszone',
  settings_invalidEmail: 'Ugyldig e-mailadresse',
  settings_cancel: 'Annuller',
  settings_currentPassword: 'Nuværende adgangskode',
  settings_newPassword: 'Indtast ny adgangskode',
  settings_retype: 'Indtast adgangskoden igen',
  confirm_password: 'Bekræft adgangskode',
  settings_billingMethod: 'Betalingsmetode',
  settings_cancelSubscription: 'Annuller abonnement',
  settings_cancel_mySubscription: 'Ja, annuller mit abonnement',
  settings_month: 'måned',
  cancelSubscription_message:
    'Du er ved at afslutte Netgrav {name}-planen. Du kan stadig være her på gratisplanen og starte igen, når du ønsker.',
  reactivateSubscription_message:
    'Du er ved at genaktivere dit abonnement på Netgrav {name}-planen. Dette vil genoprette fuld adgang til alle funktionerne knyttet til denne plan.',
  not_now: 'ikke nu',
  reactivate: 'Ja, genaktivér mit abonnement',
  settings_nextDue: 'Næste betaling forfalder',
  settings_paymentMethods: 'Betalingsmetoder',
  settings_nextBilling: 'Næste automatiske fakturering er',
  settings_mangeMethods: 'Se og administrer din betalingsmetode',
  settings_emptyMethods: 'Der er ingen betalingsmetoder tilføjet endnu',
  settings_vippsHeading: 'Vipps-betalinger og aftaler kommer snart her',
  settings_manageVipps: 'For at se og administrere dine aftaler',
  settings_cardEnd: 'slutter på',
  settings_remove: 'Fjern',
  settings_stop: 'Stop',
  relation_title_for_connection: 'Hvad er relationen fra {firstGrave} til {secondGrave}?',
  relation_direction_title_for_connection: 'Hvad er relationen fra {secondGrave} til {firstGrave}?',
  settings_vippsAgreement: 'Vipps-aftale',
  view_manage_agreements: 'Se og administrer din aftale',
  empty_agreements: 'Ingen Vipps-aftaler blev fundet',
  settings_amount: '{amount}',
  settings_subscriptionHeading: 'Abonnementsadmin',
  settings_subscriptionStatus: 'Status',
  settings_length: 'Længde',
  settings_nextBillingDate: 'Næste faktureringsdato',
  settings_endDate: 'Slutdato',
  settings_reactivateSubscription: 'Reaktiver abonnement',
  settings_freeSubscriptionHeading: 'Kom i gang gratis.',
  months: 'måneder',
  year: 'år',
  month: 'måned',
  years: 'år',
  saved: 'Gemt',
  saved_message: '{name} er gemt.',
  settings_upgrade: 'Opgrader plan',
  settings_subDescription: 'For et meningsfuldt liv',
  settings_for: 'for',
  settings_paymentInfo: 'Betalingsoplysninger',
  settings_cardNumber: 'Kortnummer',
  settings_billingInfo: 'Faktureringsoplysninger',
  settings_name: 'Navn',
  settings_billingEmail: 'E-mail',
  settings_billingCountry: 'Land',
  settings_postCode: 'Postnummer',
  settings_changePlan: 'Skift plan',
  change_plan: 'skift plan',
  change: 'ændre',
  change_members: 'ændre medlemmer',
  settings_noSubscription: 'Du har ingen aktivt abonnement endnu.',
  settings_clickHere: 'klik her',
  settings_getSubscription: 'Få abonnement',
  settings_subscriptionPrice: 'Pris pr. år',
  settings_subscriptionLengths: 'Tilladte længder',
  settings_subscriptionYears: 'År købt',
  settings_subscriptionFrameId: 'Ramme-ID',
  open_menu: 'Åbn menu',
  settings_memberHeading: 'Invitationer',
  settings_receivedMembership: '(Invitationer du har modtaget)',
  settings_emptyMembership: 'Ingen invitationer lige nu.',
  settings_subscribedPlan: 'Dit abonnement er aktiveret. Du kan se eller administrere ',
  settings_updatePlan: 'Dit abonnement er opdateret. Du kan se eller administrere ',
  settings_downgradePlan: 'Dit abonnement er nedgraderet. Du kan se eller administrere ',
  settings_addedMember: 'Nye medlemmer er tilføjet. Du kan se eller administrere ',
  payment_progress: 'Betaling i gang – vent venligst',
  something_wrong: 'Noget gik galt. Prøv igen senere',
  add_validNumber: 'Indtast et gyldigt telefonnummer',
  select_planMessage:
    'For at fortsætte, vælg en plan der passer til dine behov. Vores planer tilbyder fleksibilitet og gode funktioner.',
  settings_memberPage: 'medlemsside',
  settings_your: 'din.',
  settings_enable: 'plan aktiveret',
  free: 'Gratis',
  conscious: 'Conscious',
  consciousPlus: 'Conscious plus',
  settings_membershipOn: '– abonnement aktiveret',
  settings_modalSubheading: 'Størst af alt er kærlighed',
  settings_modalLink: 'Tak fordi du er her',
  settings_memberSubheading: 'Din familieplan.',
  settings_emptyMembers: 'Du har ingen abonnementsmedlemmer',
  settings_memberName: '{name}s familie',
  settings_memberLength: '{length} medlemmer',
  settings_administrator: 'Administrator',
  settings_showMembers: 'Vis medlemmer',
  settings_familyMembers: 'Familie',
  settings_you: 'Dig',
  settings_connect: 'forbind',
  settings_setRelation: 'Indstil relation',
  settings_selectedRelation: 'Vælg relation',
  settings_giftHeading: 'Giv et abonnement til en, du holder af.',
  settings_giftFreeSubscription:
    'Du har en gratis konto. Opgrader for at få alt og invitere flere.',
  settings_seeSubscriptions: 'Opgrader',
  settings_youHave: 'Du har {count} ',
  settings_inviteAgain: 'invitationer tilbage.',
  settings_addMore: 'for at tilføje flere til din plan',
  error_trigger_title: 'Fejlgrænse-test',
  error_trigger_subtitle:
    'Klik på knappen for at udløse en render-fejl og verificere den globale fejlgrænse.',
  error_trigger_button: 'Udløs fejl',
  settings_addMember: 'Tilføj medlem',
  settings_invitedMember: 'Inviterede medlemmer',
  settings_emptyGiftMembers: 'Ingen ubesvarede invitationer',
  settings_inviteTo: 'Klik her for at invitere til familieabonnement',
  settings_pendingSubscription: 'Dit abonnement er {status}.',
  settings_notificationsSubheading: 'Vælg hvad du vil modtage fra os.',
  settings_notificationsTitle: 'Notifikationsindstillinger',
  settings_preferenceText: 'Notifikationer om samtaler og direkte henvendelser.',
  settings_reminders: 'Påmindelser',
  settings_remindersText: 'Mindedage og stille påmindelser.',
  settings_anniversary_marking: 'Jeg ønsker markeringer på mærkedage',
  settings_anniversary_in_app: 'Vis markeringen i Netgrav',
  settings_anniversary_email: 'Send mig også e-mail',
  settings_genealText: 'Nyheder og information fra Netgrav.',
  settings_textMessage: 'SMS',
  settings_general: 'Generelle opdateringer',
  delete: 'Slet',
  settings_goToAgreements: 'klik her',
  settings_shareLink: 'Kopier og del din Netgrav-invitation',
  grave_invitation_shareLink: 'Kopier og del din grav-invitation',
  settings_copyToClipboard: 'link kopieret',
  discard_subheading: 'Du kan fortsætte med at redigere, eller afslutte nu.',
  no: 'Nej',
  yes: 'Ja',
  invitation: 'Invitation',
  information: 'Information',
  interests: 'Interesser',
  note: 'Bemærkning',
  relative: 'Familie',
  uploadingImages: 'uploading billeder',
  uploading: 'Uploader',
  lifeEvent: 'Livsbegivenhed',
  Workplace: 'Arbejdssted',
  delete_modalHeading: 'Bekræft at du vil fjerne',
  picture: 'billede',
  paymentMethod: 'Betalingsmetode',
  vippsAgreement: 'Vipps-aftale',
  settings_complete_subscription: 'Færdiggør abonnement',
  pending_message:
    'Dit abonnement er ufuldstændigt. Fuldfør abonnementet for at fortsætte med at få adgang til Conscious-funktioner.',
  pending_title: 'Din betalingsaftale afventer',
  stopped_title: 'Din betalingsaftale blev stoppet',
  stopped_message:
    'Dit abonnement er ufuldstændigt, fordi betalingsaftalen blev annulleret. Fuldfør abonnementet for at fortsætte med at få adgang til Conscious-funktioner.',
  expired_title: 'Din betalingsaftale er udløbet',
  expired_message:
    'Dit abonnement er ufuldstændigt, fordi betalingsaftalen er udløbet. Fuldfør abonnementet for at fortsætte med at få adgang til Conscious-funktioner.',
  complete_setup: 'fuldfør opsætning',
  cancelled_title: 'Dit abonnement er annulleret',
  cancelled_message:
    'Dit abonnement er annulleret. Du kan genaktivere før {period_end_date} for fortsat adgang til Conscious-funktioner. Derefter nedgraderes det til gratisplan.',
  activeStopped_title: 'Din betalingsaftale er afsluttet',
  activeStopped_message:
    'Betalingsmetoden for abonnementet er udløbet. Forny betalingsmetoden for fortsat adgang. Hvis problemet fortsætter, nedgraderes abonnementet til gratisplan efter cyklussen.',
  renew_Agreement: 'Forny betalingsaftale',
  add_card: 'Tilføj betalingsmetode',
  Reactivate: 'Genaktivér abonnement',
  active_title: 'Dit abonnement aktiveres snart',
  active_message:
    'Dit abonnement behandles og aktiveres om få minutter. Tak for din tålmodighed – du får snart adgang til Conscious-tjenester.',
  activeExpired_title: 'Din betalingsaftale er udløbet',
  activeExpired_message:
    'Betalingsmetoden er udløbet. Forny eller opret en ny aftale for fortsat adgang.',
  notValid_title: 'Betalingsmetode påkrævet',
  notValid_message:
    'Det ser ud til, at din betalingsmetode mangler eller ikke er gyldig. Opdater dine betalingsoplysninger for uafbrudt service.',
  consciousness: 'Om os',
  about_us: 'Om Netgrav',
  team: 'Vores historie',
  careers: 'Bliv en del af os',
  features: 'Om gravstedet',
  available_sustainable: 'Altid tilgængeligt',
  maintenance_free_grave: 'Nemt at bruge',
  memory_album: 'Personer',
  value_archive: 'Egenskaber og historier',
  memorial_wall: 'Varige gravbesøg',
  life_archive: 'Livshistorier',
  anniversary_calendar: 'Vigtige datoers kalender',
  Family_values: 'Familietræ (kommer snart)',
  resources: 'Hjælp og ressourcer',
  find_grave: 'Søg',
  blog: 'Blog',
  help_center: 'Spørgsmål og svar',
  contact: 'Kontakt',
  contact_us: 'Kontakt os',
  business_inquiries: 'Forretningsforespørgsler',
  feedback: 'Del dine tanker',
  basic_information: 'Grundlæggende oplysninger',
  interest: 'Interesse',
  notes: 'Noter',
  passion: 'Passion',
  relation: 'Relation',
  life_event: 'Livsbegivenhed',
  subscription_invitation: 'Abonnementsinvitation',
  cookies_banner_text:
    'Vi bruger nødvendig lagring og vores egen trafikmåling til at drive og forbedre Netgrav.',
  cookies_more: 'Læs mere',
  cookies_accept: 'Godkend',
  cookies_reject: 'Afvis',
  cookies_manage: 'Skift cookievalg',
  cookies_page_title: 'Cookies og måling',
  cookies_page_subtitle: 'Nødvendig lagring og Netgravs egen trafikmåling.',
  cookies_necessary_title: '1. Nødvendig lagring',
  cookies_necessary_body:
    'Netgrav bruger nødvendig lokal lagring og sessionsteknologi til login, sikkerhed, sprog og grundlæggende funktioner. Dette kan ikke slås fra i tjenesten, når det er nødvendigt for den funktion, du bruger.',
  cookies_first_party_title: '2. Netgravs egen måling',
  cookies_first_party_body:
    'Vi tæller sidevisninger og sessioner i vores eget system for at forstå den samlede brug, opdage tekniske problemer og filtrere robotter. Målingen bruger pseudonyme sessions- og besøgsnøgler, sidekategori, browsertype, omtrentligt land og en tidsbegrænset hash af IP-adressen. Rapporter bruges på aggregeret niveau og deles ikke med partnere som brugerprofiler.',
  cookies_list_title: '3. Oversigt',
  cookies_list_body:
    'Nødvendige elementer omfatter Netgravs session og indstillinger som sprog og visning. Netgrav bruger ikke Google Analytics, Google Tag Manager eller analysecookies fra tredjeparter.',
  rooms_landing_eyebrow: 'Rum',
  rooms_landing_title: 'Et sted at samles om det, der betyder noget.',
  rooms_landing_lead:
    'Et rum samler mennesker om det, der betyder noget. Ikke en gruppe. Ikke en tråd. Et rum, hvor du sætter tonen, inviterer dem du vil, og skaber et fællesskab omkring noget, der faktisk betyder noget for dig.',
  rooms_landing_coming_soon: 'Kommer snart til Netgrav.',
  rooms_landing_preview_label: 'Preview',
  rooms_landing_panel_quote: 'Ingen algoritme bestemmer, hvem der ser hvad. Det gør du.',
  rooms_landing_open_rooms: 'Åbne rum',
  rooms_landing_closed_rooms: 'Lukkede rum',
  rooms_landing_private_rooms: 'Private rum',
  rooms_landing_what_title: 'Hvad er et rum?',
  rooms_landing_what_body_1:
    'Et rum er et fællesskab, du opretter omkring en tanke, en oplevelse, en sorg eller en glæde. Du bestemmer, hvem der er velkomne, hvad rummet handler om, og hvordan det holdes trygt.',
  rooms_landing_what_body_2:
    'Nogle rum er åbne. Alle kan læse med, men man skal melde sig ind for at deltage. Andre er lukkede, hvor du godkender, hvem der kommer ind. Og nogle er private, kun for dem du selv inviterer.',
  rooms_landing_who_title: 'Hvem kan oprette et rum?',
  rooms_landing_who_body: 'Alle med en Netgrav-konto kan oprette et rum.',
  rooms_landing_use_case_1: 'Dig, der har mistet nogen og vil samle dem, som kendte personen.',
  rooms_landing_use_case_2: 'En sygeplejerske, som vil give pårørende et trygt sted.',
  rooms_landing_use_case_3: 'En psykolog eller facilitator, som holder en sorggruppe.',
  rooms_landing_use_case_4: 'En ven, som vil holde et minde-rum levende over tid.',
  rooms_landing_who_question: 'Det eneste, vi spørger om, er: hvordan vil du holde rummet trygt?',
  rooms_landing_support_title: 'Støt rummet du holder af',
  rooms_landing_support_body_1:
    'Nogle rum fortjener at leve længe. Hvis du driver et rum, der betyder noget for andre, kan du åbne for støtte. Dem, der finder værdi dér, kan bidrage med for eksempel 99 kr om måneden.',
  rooms_landing_support_body_2:
    'Støtten er et månedligt abonnement. Netgrav beholder 15 %, og betalingsgebyrer trækkes, før resten udbetales til dig.',
  rooms_landing_directions_title: 'Retninger',
  rooms_landing_directions_body:
    'Alle rum tilhører en retning, en kategori der hjælper folk med at finde det, der er relevant for dem. Du vælger retning, når du opretter rummet, og dit rum kan blive synligt for dem, der leder efter netop det, du tilbyder.',
  rooms_landing_direction_grief: 'Sorg og tab',
  rooms_landing_direction_relationships: 'Relationer',
  rooms_landing_direction_life_choices: 'Livsvalg',
  rooms_landing_direction_health: 'Sundhed',
  rooms_landing_direction_eot: 'End of Time Consciousness',
  rooms_landing_cta_eyebrow: 'Tidlig adgang',
  rooms_landing_cta_title: 'Rum er på vej ind i Netgrav.',
  rooms_landing_cta_body:
    'Funktionen er ikke fuldt lanceret endnu. Eksisterende rum er stadig tilgængelige for dem, som allerede bruger dem.',
  rooms_landing_cta_primary: 'Opret et rum',
  rooms_landing_cta_secondary: 'Læs vilkår',
  find_grave_norway: 'Find en grav',
  find_grave_value_statement: 'Find hvor nogen er begravet, og besøg graven på nettet.',
  search_grave: 'Søg efter navn',
  search_recent_title: 'Seneste søgninger',
  search_recent_clear: 'Ryd',
  search_recent_remove: 'Fjern',
  search_suggestions_title: 'Forslag',
  search_searching: 'Søger…',
  search_no_results: 'Ingen resultater',
  or: 'eller',
  find_grave_create_cta: 'læg en grav til',
  create_netgrave: 'opret en Netgrav',
  netgrave: 'Netgrav',
  visit: 'Besøg',
  relation_summary_self: 'Jeg er {relationLower}',
  relation_summary_target: '{name} er min {relationLower}',
  relation_summary_fallback_person: 'denne person',
  visit_grave: 'Find den du tænker på',
  wish: '',
  find_grave_practical_reason:
    'Her kan du finde grave i {municipalityName} og være nær dem, der betyder noget for dig.',
  find_grave_cemetery_practical_reason:
    '{cemeteryName} ligger i {municipalityName}. Her kan du finde grav og se, hvem der er begravet på gravlunden. Søg efter navn for at finde det rigtige gravsted og besøge graven på nettet.',
  find_grave_support_statement: 'Små handlinger giver plads til nærhed over tid.',
  find_grave_guest_cta_title: 'Når du finder den rigtige grav',
  find_grave_guest_cta_body: 'kan du knytte dig til den, efterlade et tegn og følge op over tid.',
  find_grave_guest_cta_button: 'Tag vare på en grav',
  find_grave_search_heading: 'Søg efter navn',
  find_grave_search_description: 'Start med et navn for at finde den rigtige grav.',
  find_grave_name_placeholder: 'Skriv et navn, f.eks. Anna Andersen',
  second_section_description: 'Start med et navn, eller udforsk kommune og kirkegård.',
  find_grave_start_hint: 'Skriv et navn',
  find_grave_faq_title: 'Ofte stillede spørgsmål',
  find_grave_faq_question_1: 'Hvordan finder jeg en grav?',
  find_grave_faq_answer_1:
    'Søg på navn. Du kan også bruge kommune eller kirkegård for at afgrænse resultaterne.',
  find_grave_faq_question_2: 'Kan jeg søge på kommune eller kirkegård?',
  find_grave_faq_answer_2:
    'Ja. Skriv kommunen eller kirkegården i søgningen, eller vælg videre fra oversigten.',
  find_grave_faq_question_3: 'Hvad gør jeg, hvis jeg ikke finder personen?',
  find_grave_faq_answer_3:
    'Prøv en anden stavemåde eller søg med færre ord. Du kan også oprette en Netgrav, hvis den mangler.',
  memorial_plaque: 'Kommuner',
  memorial_plaque_description: 'Udforsk kommuner og gravpladser.',
  archive: 'Kirkegårde',
  archive_description: 'Se kirkegårde i kommunen.',
  memory_album_description: 'Find personer som er begravet der.',
  find_municipality: 'Grave i disse kommuner',
  search_municipality: 'Søg efter kommune',
  find_grave_municipality_cta: 'Se kirkegårde',
  it_is: 'Det er',
  find_grave_count: '{count}',
  municipality_description: 'Søg blandt {count} kommuner og find den grav, du leder efter.',
  no_results: 'Ingen resultater for',
  find_cemetery: 'Vælg en kirkegård i {municipalityName}',
  find_cemetery_generic: 'Find en grav på disse kirkegårde',
  search_cemetery: 'Søg efter gravplads',
  cemetery_description:
    'kirkegårde i {municipalityName}. Udforsk kirkegårdene for at finde personer, der er begravet der.',
  grave_description:
    'personer begravet her. Søg efter navn for at finde det rigtige gravsted og besøge graven på nettet.',
  goto_grave: 'vis grav',
  payment_due_message:
    'Dit abonnement er aktivt. Betalingen behandles. Vipps håndterer betalingen.',
  payment_due_title: 'Dit abonnement er aktivt',
  find_grave_image_title: 'Graven giver et nyt perspektiv på vores liv. På din',
  find_grave_text: 'har du en væg, hvor kontakter kan stille spørgsmål.',
  life_page: 'Livsside',
  the_life_page: 'Mit Lys',
  first_description: 'Følg din gnist. Her kan du dele din egen gnist og reagere på andres.',
  your_graves: 'Dem du bærer med videre',
  second_description: 'Personerne du har sat din relation til, knyttes til dit Lys.',
  update: 'Dine relationer',
  third_description: 'Dine nærmeste bliver en del af dit Lys.',
  find_grave_last_text:
    'Velkommen til Netgrav Et socialt netværk for livets virkelige udfordringer – hvor vi starter med meningsfulde, tilgængelige og vedligeholdelsesfri grave, for os der skal leve videre. Vi håber også at opleve din indre gnist – dine erfaringer fra livet, som du finder mod til at dele med andre. Verden har brug for at høre dine ord og tanker.',
  plans_page_heading: 'Et bevidst valg for et meningsfuldt liv',
  plans_page_subheading:
    'Slip fortiden, omfavn rejsen fremad med det mest værdifulde gravsted for dine kære.',
  per_user: 'per medlem',
  current_members: 'Aktuelle medlemmer',
  added_members: 'Antal medlemmer, der skal tilføjes',
  removed_members: 'Antal medlemmer, der skal fjernes',
  view_current_members: 'Vis aktuelle medlemmer',
  total_members: 'Medlemmer efter ændring',
  plan_price: 'Planpris',
  increment_text: 'Vælg antallet af abonnementer, du ønsker for dig og din familie',
  free_description: 'For dem, der vil søge efter og besøge grave uden omkostninger.',
  conscious_description:
    'Med Conscious-abonnement bliver du en verificeret støtte til End Of Time-perspektiverne.',
  consciousPlus_description:
    'Adgang som Conscious med ekstra fokus på gravens etik. Pris: 500 NOK per år',
  total_user_count: 'For {subscriptionTotalCount} familiemedlemmer er det samlede beløb:',
  per_month: 'per måned',
  current_plan: 'Aktuel plan',
  got_started: 'Kom i gang',
  free_feature_heading: 'Alle funktioner inkluderet i gratisplanen',
  conscious_feature_heading: 'Alle funktioner inkluderet i gratisplanen, plus flere',
  conscious_plus_feature_heading: 'Alle funktioner inkluderet i Conscious-planen, plus flere',
  feature_memory_album: 'Mindebog',
  feature_purposes: 'Formål',
  feature_end_of_time: 'End Of Time-mønt',
  feature_family_tree: 'Stamtræ',
  feature_testament: 'Testamente',
  feature_groups: 'Grupper (fællesskaber)',
  feature_Shop: 'Nærvær',
  feature_Sparks: 'Sparks',
  feature_life_page: 'Mit lys',
  feature_search_grave: 'Søg efter grave',
  feature_create_grave: 'Opret Spark',
  question_answer: 'Spørgsmål og svar',
  feature_life_archive: 'Livsarkiv',
  feature_anniversary_calendar: 'Mærkedagskalender',
  feature_memory_wall: 'Mindevæg',
  feature_value_archive: 'Egenskaber',
  benefits_1_title: 'Kærligheden fortsætter',
  benefits_1_description:
    'Hver conscious grav er et sted, hvor kærligheden lever videre – med værdighed, varme og mening.',
  benefits_2_title: 'Støtter det, der redder liv',
  benefits_2_description:
    'Dit bidrag går direkte til forskning og udvikling for at forstå og overvinde det, der tager liv.',
  benefits_3_title: 'En meningsfuld grav',
  benefits_3_description:
    'Fra blomster og lys – til handling. Conscious-grave former en bedre fremtid.',
  benefits_4_title: 'Mod en verden uden uønsket død',
  benefits_4_description:
    'Sammen skaber vi håb. Hver grav bringer os et skridt nærmere en sikrere og mere hel verden.',
  benefits_title: 'Gode grunde til at vælge Conscious på Netgrav',
  faqs_1_question: 'Hvilke betalingsmetoder accepterer I?',
  faqs_1_answer: 'Vi accepterer kredit-/betalingskort (Visa, Mastercard) og Vipps',
  faqs_2_question: 'Er der ekstra gebyrer, jeg skal være opmærksom på?',
  faqs_2_answer:
    'Der er ingen skjulte gebyrer. Her kan du samle alle grave og begravelser uden ekstra omkostninger',
  faqs_3_question: 'Hvordan opdaterer jeg mine betalingsoplysninger?',
  faqs_3_answer:
    'For at opdatere dine betalingsoplysninger, gå til dine kontoindstillinger og vælg fanen abonnement',
  faqs_4_question: 'Hvad sker der, når betalingen er gennemført?',
  faqs_4_answer:
    'Når betalingen er gennemført, modtager du en meddelelse fra Netgrav om, at dit abonnement er aktiveret.',
  faqs_5_question: 'Hvad er forskellen mellem Free og Conscious?',
  faqs_5_answer:
    'Gratisabonnement giver fem søgninger og fem minder. Der er også en begrænsning på størrelsen af medier, der kan tilføjes grave. Med Conscious har du ubegrænset adgang til alle funktioner og nye funktioner, der tilføjes.',
  faqs_6_question: 'Hvem er Conscious-planen til?',
  faqs_6_answer:
    'Conscious er til dem, der vil have mest muligt ud af livet. Den giver dig frihed til at give slip på gamle antagelser og ritualer. Med Conscious har du altid adgang til funktioner, der støtter din rejse i livet – med udgangspunkt i den mest meningsfulde grav for dine kære og vores løfte om altid at vejlede dig til kærligheden.',
  update_modal_change_plan: 'Skift {name}-plan',
  waite_for_validation: 'Vent venligst, mens vi validerer dit abonnement',
  add_members: 'Tilføj medlemmer',
  remove_members: 'Fjern medlemmer',
  allowed_members: 'Tilladt antal medlemmer',
  how_many_add: 'Hvor mange medlemmer vil du tilføje?',
  how_many_remove: 'Hvor mange medlemmer vil du fjerne?',
  not_remove_all: 'Behold mindst ét medlem.',
  updated_price: 'Opdateret pris efter ændringerne',
  remaining_members: 'Samlet antal resterende medlemmer',
  total_price: 'Totalpris',
  extra_user: 'For yderligere {subscriptionTotalCount} familiemedlemmer er der en ekstra betaling',
  process_payment: 'Gå til betaling',
  continue: 'Fortsæt',
  subscription_members: 'Abonnementsmedlemmer',
  remove_subscription_members: 'Fjern abonnementsmedlemmer ved at klikke fjern',
  subscription_invitation_members: 'Invitationer til abonnement',
  remove_invitation_members: 'Fjern abonnementsinvitation ved at klikke fjern',
  downgrade_plan: 'Nedgrader plan',
  upgrade_plan: 'Opgrader plan',
  downgrade_message:
    'Deaktiver alle abonnementsmedlemmer og invitationer for at fortsætte nedgraderingen',
  upgrade_message: 'Fjern alle abonnementsmedlemmer og invitationer for at opgradere',
  close_message: 'Du kan nu lukke og fortsætte',
  close: 'Luk',
  active_members: 'Aktive medlemmer i dit abonnement',
  active_members_message:
    'For at fortsætte skal du deaktivere et eller flere medlemmer fra dit abonnement.',
  active_members_empty_message: 'Ingen aktive medlemmer fundet i dit abonnement',
  active_invitations: 'Ventende invitationer til dit abonnement',
  active_invitations_message: 'Annuller venligst invitationerne for at fortsætte.',
  active_invitations_empty_message: 'Ingen uafsluttede invitationer tilknyttet dit abonnement',
  check_out: 'Til betaling',
  select_payment_method: 'Vælg betalingsmetode',
  order_details: 'Ordredetaljer',
  subscription_number: 'Antal abonnementer',
  taxes: 'Skatter',
  total: 'Samlet at betale:',
  sub_total: 'Almindelig medlemspris:',
  discount_title: 'Faktureringsfrekvens:',
  subscription_length: 'Plannens varighed',
  discount: 'Rabat for flere medlemmer:',
  renewal: 'Abonnementet fornyes automatisk.',
  renewal_details:
    'Fornyelse sker i henhold til valgt faktureringsfrekvens. Du kan opsige når som helst.',
  payment_page_terms: 'Ved at vælge “Næste” eller “Abonner” accepterer du vores',
  terms_conditions: 'Vilkår for brug.',
  terms_conditions_page_title: 'Vilkår & betingelser',
  terms_conditions_page_subtitle: 'Generelle vilkår og privatliv for netgrav.dk',
  terms_conditions_section1_title: '1. Generelt',
  terms_conditions_section1_body:
    'netgrav.dk er et digitalt samlingssted, hvor familie og venner kan være tæt på den afdøde. Tjenesten giver et skybaseret gravrum, så pårørende kan tænde lys, dele billeder, fortællinger og andre handlinger, når behovet opstår. Ud over at oprette og besøge en Netgrav kan medlemmer bruge Gravalbum, Gravtavlen, Værdiarkivet og Livsarkivet. Visse dele af tjenesten har særlige vilkår – for eksempel priser, betalingsmetoder eller aftaleperioder – som beskrives på websitet. Hvis de særlige vilkår afviger fra disse generelle vilkår, er det de særlige vilkår, der gælder.',
  terms_conditions_section2_title: '2. Registrering, brugernavn og adgangskode',
  terms_conditions_section2_body:
    'Adgangen til tjenesten afhænger af, om du er ansvarlig for den fysiske grav eller blot besøgende. Du kan oprette en konto på netgrav.dk eller via andre tjenester og sociale medier, i det omfang Netgrav stiller det til rådighed. Når du registrerer dig via en tredjepart, accepterer du, at Netgrav indhenter de oplysninger, der er nødvendige for at oprette kontoen. Du er ansvarlig for, at de oplysninger, du afgiver, er korrekte. Adgangskoden er personlig og må ikke deles. Hvis du opdager uautoriseret brug, skal du straks kontakte Nettgrav AS og ændre adgangskoden. For at beskytte tjenesten kan Nettgrav AS til enhver tid bede dig opdatere adgangskoden.',
  terms_conditions_section3_title: '3. Brug af tjenesten',
  terms_conditions_section3_body:
    'Du er ansvarlig for, hvordan du bruger produktet, og tjenesten må kun anvendes til det formål, den er tiltænkt. Du forpligter dig til at holde Nettgrav AS skadesløs for krav eller tab fra tredjemand, der opstår som følge af din brug af produktet og de tjenester, der stilles til rådighed.',
  terms_conditions_section4_title: '4. Priser og betaling',
  terms_conditions_section4_body:
    'Priserne for tjenesten fremgår af netgrav.dk og kan ændres efter behov. Alle priser vises inklusive gældende afgifter, når det er påkrævet.',
  terms_conditions_section5_title: '5. Ansvarsfraskrivelse',
  terms_conditions_section5_body:
    'Medmindre andet udtrykkeligt fremgår, er Nettgrav AS ikke ansvarlig for information eller indhold, som placeres eller sendes via vores tjenester. Netgrav har ingen kontrol over eksterne websites, vi linker til, og påtager sig ikke ansvar for deres indhold. I det omfang loven tillader det, fraskriver Nettgrav AS sig ansvar for skader eller tab, der skyldes dine handlinger eller undladelser i forbindelse med tjenesten.',
  terms_conditions_section6_title: '6. Ændringer',
  terms_conditions_section6_body:
    'Nettgrav AS kan til enhver tid ændre indholdet eller omfanget af tjenesten samt justere priser og øvrige vilkår. Hvis ændringerne er væsentlige og til ugunst for dig, varsles du via brev, SMS eller e-mail på den adresse, du har registreret, senest 30 dage før ændringen træder i kraft. Ønsker du ikke at acceptere nye vilkår, kan du altid opsige dit medlemskab.',
  terms_conditions_section7_title: '7. Varighed og opsigelse',
  terms_conditions_section7_body:
    'Du kan til enhver tid slette din konto og eventuelle abonnementer. Kontakt kontakt@nettgrav.no, hvis du har spørgsmål eller brug for hjælp.',
  terms_conditions_section8_title: '8. Reklamation',
  terms_conditions_section8_body:
    'Hvis du ønsker at reklamere, skal du meddele Nettgrav AS via e-mail, telefon, brev eller gennem websitet inden fem dage fra leveringstidspunktet. Blomster og planter betragtes som ferskvarer og er undtaget fortrydelsesretten.',
  terms_conditions_section9_title: '9. Privatliv',
  terms_conditions_section9_1_title: '9.1 Generelt',
  terms_conditions_section9_1_paragraph1:
    'Dit privatliv er vigtigt, og i overensstemmelse med gældende regler informerer vi om følgende:',
  terms_conditions_section9_1_paragraph2:
    'Nettgrav AS, Damstredet 3, 0177 Oslo (org.nr. 912 857 336) er dataansvarlig for de personoplysninger, der behandles i forbindelse med levering af produkt og tjenester. Nettgrav AS behandler personoplysninger i henhold til norsk lovgivning.',
  terms_conditions_section9_1_paragraph3:
    'Ved at registrere en konto samtykker du til, at Nettgrav AS behandler personoplysninger i overensstemmelse med disse vilkår og vores privatlivspolitik.',
  terms_conditions_section9_2_title: '9.2 Formål',
  terms_conditions_section9_2_body:
    'Nettgrav AS behandler personoplysninger for at kunne levere tjenesterne, analysere brugen, administrere kundeforhold, kommunikere med kontohavere og opfylde lovmæssige forpligtelser.',
  terms_conditions_section9_3_title: '9.3 Hvilke personoplysninger behandles?',
  terms_conditions_section9_3_body:
    'Vi behandler de oplysninger, du giver ved registrering, samt data, der opstår, når du bruger tjenesten. Det kan eksempelvis være navn, adresse, telefonnummer, e-mailadresse, betalingsoplysninger samt relevante oplysninger om den afdøde og de bidrag, der knyttes til graven.',
  terms_conditions_section9_4_title: '9.4 Videregivelse af oplysninger',
  terms_conditions_section9_4_body:
    'Nettgrav AS kan videregive personoplysninger til leverandører, som udfører tjenester på vores vegne, for eksempel drift, IT og kundesupport. Vi videregiver ikke personoplysninger til andre tredjeparter og bruger ikke dine data til træning af kunstig intelligens.',
  terms_conditions_section9_5_title: '9.5 Rettelse, sletning og indsigt',
  terms_conditions_section9_5_body:
    'Du har ret til indsigt i de personoplysninger, Nettgrav AS behandler om dig. Du kan også anmode om, at oplysninger rettes, suppleres eller slettes, når der er retligt grundlag for det.',
  terms_conditions_section9_6_title: '9.6 Brug af cookies',
  terms_conditions_section9_6_body:
    'Vi anvender cookies på websitet. Cookies er små tekstfiler, der gemmes på din enhed og gør det muligt at huske dine valg og hvordan tjenesten bruges. Oplysningerne hjælper os med at tilpasse websitet, forbedre brugeroplevelsen og måle trafikken.',
  terms_conditions_section9_6_paragraph2:
    'De fleste moderne browsere accepterer cookies automatisk, men du kan selv vælge at deaktivere dem. Vi bruger ikke cookies til at personalisere oplevelsen individuelt – alle ser det samme indhold.',
  terms_conditions_section9_6_paragraph3:
    'Trafikken måles i Netgravs eget system med pseudonyme besøgs- og sessionsnøgler. Vi bruger ikke Google Analytics eller andre eksterne analyseværktøjer til denne måling, og måledata deles ikke med kommercielle partnere som brugerprofiler.',
  terms_conditions_section9_6_paragraph4: '',
  terms_conditions_section10_title: '10. Tvister',
  terms_conditions_section10_body:
    'Disse vilkår er underlagt norsk lov, og eventuelle tvister afgøres ved norske domstole. Oslo tingrett er aftalt værneting.',
  terms_conditions_section11_title: '11. Kontaktinformasjon',
  terms_conditions_section11_body:
    'Har du spørgsmål til tjenesten, kan du kontakte Nettgrav AS på kontakt@nettgrav.no, +47 450 07 009 eller pr. post: Damstredet 3, 0151 Oslo.',
  terms_conditions_accept_button: 'Accepter',
  terms_conditions_reject_button: 'Afvis',
  change_free_plan: 'Gratisplan er gratis',
  free_plan_message:
    'Med gratis kan du udforske, besøge og oprette Netgrav. Gratis er en grundlæggende værdi.',
  ending_with: 'slutter med',
  add_payment_method: 'Tilføj betalingsmetode',
  name_on_card: 'Navn på kort',
  expiry_date: 'Udløbsdato',
  secure_payment_message: 'Sikker betaling med SSL-kryptering',
  billing_address: 'Faktureringsadresse',
  enter_address: 'Indtast adresse',
  billing_info_message:
    'Denne information bruges til at udstede den første faktura. Du kan opdatere fremtidige fakturadetaljer i din kontoprofil.',
  subscribe: 'Abonner',
  select_language: 'Vælg sprog',
  payment_error: 'Betalingsfejl',
  subscription_waiting_message:
    'Betaling behandles. Vent venligst, dit abonnement er under behandling',
  success_message: 'Abonnementet blev annulleret succesfuldt',
  reactivate_success_message: 'Abonnementet er genaktiveret',
  choose_plan: 'Vælg en plan før abonnement',
  canceling_waite_message: 'Annullering af abonnement pågår, vent venligst…',
  subscription_overview: 'Abonnementsoversigt',
  users: 'Medlemmer',
  for_members: 'For {user} medlemmer',
  for_member: 'For {user} medlem',
  for_6_members: 'For {user} eller flere',
  billing_cycle: 'Faktureringscyklus',
  amount: 'Beløb',
  cancelSubscriptionInfo:
    'Abonnementet slutter på slutdatoen og går over til gratisplan. Du kan starte igen når som helst.',
  confirm_billing_cycle: 'Gem ændringer',
  different_cycle: 'Vælg en anden faktureringscyklus',
  update_billing: 'Faktureringscyklus er opdateret',
  waiting_update_billing_cycle: 'Vent et øjeblik, opdaterer faktureringscyklus…',
  add_members_message: 'Medlemmer er tilføjet',
  remove_members_message: 'Medlemmer er fjernet',
  your_current_plan: 'Din nuværende plan',
  upgrade_to: 'Opgrader til {planName}',
  downgrade_to: 'Nedgrader til {planName}',
  members_removed: 'Abonnementsmedlem er fjernet',
  invitation_removed: 'Invitationsmedlem er fjernet',
  mann: 'Mand',
  kvinne: 'Kvinde',
  annen: 'Andet',
  life_page_description: 'Her finder du dine grave og Mit Lys.',
  settings: 'Indstillinger',
  settings_description: 'Dine konto oplysninger som kodeord, abonnement og person.',
  logout: 'Log ud',
  logout_description: 'Gør noget venligt. Et blik. Et smil. Et ord. Dit lys betyder noget.',
  logout_success: 'Du er nu logget ud.',
  create_new_grave: 'Opret ny grav',
  create_grave_description: 'Opret en ny grave-post for en afdød i registeret.',
  new: 'Ny',
  read: 'Læs',
  empty_notification_message: 'Nye notifikationer vises her',
  public_anniversaries: 'Offentlige mærkedage',
  grave_anniversaries: 'Mærkedage',
  public_anniversary: 'Offentlig mærkedag',
  grave_anniversary: 'Personlig mærkedag',
  anniversary: 'Mærkedag',
  birthday_event: 'Fødselsdag',
  death_anniversary_event: 'Dødsdag',
  memorial_days: 'Mærkedage',
  anniversary_delete: 'Mærkedagen er slettet.',
  anniversary_created: 'Mærkedagen er oprettet.',
  anniversary_updated: 'Mærkedagen er opdateret.',
  empty_anniversaries: 'Ingen mærkedage oprettet endnu.',
  anniversaries_today: 'I dag',
  anniversaries_upcoming: 'Kommende',
  anniversaries_past: 'Tidligere',
  anniversaries_past_empty: 'Ingen tidligere mærkedage endnu.',
  anniversaries_personal: 'Dine mærkedage',
  anniversaries_personal_empty: 'Du har ikke tilføjet nogen mærkedage endnu.',
  anniversaries_personal_login: 'Log ind for at tilføje dine egne dage.',
  anniversaries_care_title: 'Omsorg over tid',
  anniversaries_care_body:
    'Lys og gravpleje kan varetages på mærkedage, også når ingen er i nærheden.',
  anniversaries_care_soon: 'Kommer snart',
  anniversaries_focus_title: 'Denne dag',
  anniversaries_focus_today: 'Tænd et lys i dag for at være nær.',
  anniversaries_focus_future: 'Lys kan bestilles til denne dag.',
  anniversaries_focus_future_scheduled:
    '{count, plural, one {# lys er bestilt til denne dag.} other {# lys er bestilt til denne dag.}}',
  anniversaries_focus_future_scheduled_self: 'Du har bestilt et lys til denne dag.',
  anniversaries_focus_future_cta: 'Bestil lys',
  anniversaries_focus_past: 'Denne dag er forbi. Mindet består.',
  anniversaries_focus_empty: 'Vælg en mærkedag for at se detaljer.',
  anniversaries_recurring_note: 'Årligt · {year}',
  anniversaries_show_all: 'Vis alle',
  anniversaries_show_less: 'Vis færre',
  candles_now: 'Lys nu',
  candles_on_selected_day: 'Lys denne dag',
  candles_on_selected_day_empty: 'Ingen lys denne dag.',
  schedule_candle: 'Bestil lys',
  schedule_candle_cta: 'Bestil',
  scheduled_gift_context_label: 'Bestiller til',
  scheduled_gift_created: 'Lyset er bestilt.',
  scheduled_gift_error: 'Kunne ikke bestille lys.',
  scheduled_gift_load_error: 'Kunne ikke hente bestilte lys lige nu.',
  quiet_presence_count: 'Stille nærvær · {count}',
  quiet_presence_zero: 'Ingen stille nærvær endnu',
  quiet_presence_return: 'Du har været her før',
  calendar_today_with_date: 'I dag, {date}',
  calendar_today: 'I dag',
  calendar_tomorrow: 'I morgen',
  calendar_upcoming: 'Kommende',
  calendar_month: 'Måned',
  calendar_week: 'Uge',
  calendar_day: 'Dag',
  weekday_short_0: 'Søn',
  weekday_short_1: 'Man',
  weekday_short_2: 'Tir',
  weekday_short_3: 'Ons',
  weekday_short_4: 'Tor',
  weekday_short_5: 'Fre',
  weekday_short_6: 'Lør',
  create: 'Opret',
  add_dates: 'Tilføj datoer',
  date: 'Dato',
  time: 'Tid',
  title: 'Titel',
  reset_time: 'Nulstil tid',
  home: 'Hjem',
  about: 'Om',
  howTo: 'Sådan',
  plans: 'Planer',
  find_a_grave: 'Find en grav',
  create_a_grave: 'Opret en grav',
  take_control: 'Tag kontrol over graven',
  pricing: 'Priser',
  get_started: 'Kom i gang',
  create_new_account: 'Opret din egen konto.',
  did_you_know: 'Vidste du, at',
  registration_description_one:
    'Her er der ingen gravleje eller gravstedspasning. Du behøver ikke tænke på vedligehold. Netgrav tager sig af det ydre – du tager dig af det indre.',
  registration_description_two:
    'En grav, du kan tage med i livet. At huske nogen er også en måde at elske på.',
  registration_description_three:
    'Du behøver ikke præstere her. Det er nok bare at være til stede.',
  enter_your_password: 'Indtast din adgangskode',
  confirm_your_password: 'Bekræft din adgangskode',
  type_your_email: 'Indtast din e-mailadresse',
  type_email: 'Indtast e-mail',
  hi: 'Hej {name}',
  dream_world_question: 'Hvordan ser din drømmeverden ud?',
  decline: 'Afvis',
  read_only: '(kun læsning)',
  accept: 'Accepter',
  accepted_message: 'Invitationen er accepteret',
  invited_title: 'Du er inviteret til et abonnement',
  open: 'Åbn',
  subscription_invitation_message: 'Du er inviteret til {subscription}-abonnement fra {name}',
  email_error: 'Indtast en gyldig e-mail',
  password_length: 'Brug mindst 8 tegn med store og små bogstaver og tal.',
  filled_out: 'Udfyld alle felter for at fortsætte.',
  must_agree: 'Acceptér vilkårene for at fortsætte.',
  inactive: 'Inaktiv',
  delete_payment_method: 'Sletter betalingsmetode…',
  payment_method_deleted: 'Betalingsmetoden er slettet',
  payment_method_inactive: 'Din betalingsmetode er slettet eller inaktiv.',
  subscription_changes_title: 'Du anmodede om disse ændringer.',
  period: 'Du anmodede om at ændre faktureringscyklen fra {month} {previous} til {newMonth} {new}',
  user_count: 'Du anmodede om at reducere medlemmer fra {previous} til {new}',
  product_id: 'Du anmodede om at skifte plan fra {previous} til {new}',
  remove_subscription_change: 'Ændringen er annulleret',
  remove_subscription_loading: 'Vent venligst, behandler…',
  revert: 'Fortryd',
  subscription_changes_subTitle: 'Ændringer gælder efter din nuværende cyklus slutter {date}',
  add_new_paymentMethod: 'Tilføj betalingsmetode',
  filled_out_info: 'Sørg for at alle felter er udfyldt',
  continue_new_card: 'Vælg betalingsmetode eller tilføj nyt kort',
  create_payment_method_waiting: 'Opretter betalingsmetode…',
  login_description: 'Nærhed til de døde og til livet på netgrav.dk. Følg din Gnist.',
  login_with_email: 'Log ind med e-mail',
  login_with_phone: 'Log ind med telefonnummer',
  account_created: 'Velkommen! Din konto er oprettet',
  verify_account: 'E-mailen er ikke bekræftet',
  verification_message:
    'For at logge ind, bekræft din e-mail. Tjek indbakken eller spam, eller bed om en ny mail:',
  resend_email: 'Send bekræftelses-e-mail igen',
  sending_verification_email: 'Verifikations-e-mail sendt',
  sending_verification_code: 'Verifikationskode sendt til telefon',
  sending_verification_waiting: 'Sender kode…',
  email_verification: 'Verifikations-e-mail sendt. Klik på linket i indbakken.',
  signup_step_title: 'Bekræft din e-mail',
  signup_relation_ready:
    'Relationen er klar — vi knytter dig til {name}, så snart e-mailen er bekræftet.',
  signup_message_heading: 'Bekræft din e-mail',
  signup_message_subheading: 'For at fuldføre skal du bekræfte din e-mail.',
  signup_primary_cta: 'Vi har sendt et bekræftelseslink til {email}',
  signup_secondary_cta: 'Når du åbner linket, bliver du logget ind automatisk.',
  signup_secondary_cta_relation:
    'Når du åbner linket, bliver du logget ind automatisk, og relationen bliver knyttet.',
  signup_help_text: 'Finder du ikke e-mailen? Tjek spam eller send linket igen.',
  signup_verification_reason: 'Det gør vi for at sikre korrekt adgang.',
  signup_primary_action: '🕊 Venter på e‑mailbekræftelse …',
  signup_resend_action: 'Send linket igen',
  signup_save_email: 'Gem e-mail',
  signup_cancel_email: 'Annuller',
  signup_email_updated: 'E-mailen er opdateret. Et nyt link er sendt.',
  signup_verification_refresh_hint: 'Bekræftet – opdaterer…',
  signup_change_email: 'Ret e-mail',
  signup_login_action: 'Gå til login',
  signup_resend_toast: 'Bekræftelsesmail sendt igen.',
  signup_waiting_cta: 'Afventer bekræftelse',
  signup_delivery_status_label: 'E-mailstatus:',
  grave_guest_visit_title: 'Besøg graven',
  grave_guest_visit_body:
    'Her kan du læse, se hvem der hører til og være til stede omkring {name}.',
  grave_guest_visit_support: 'Log ind for at knytte dig til graven og følge med videre.',
  grave_guest_visit_primary: 'Knyt dig til graven',
  signup_delivery_status_sending: 'Sender e-mail …',
  signup_delivery_status_sent: 'E-mailen er sendt fra os. Afventer leveringsbekræftelse.',
  signup_delivery_status_delivered: 'E-mailen er leveret.',
  signup_delivery_status_temporary_failure:
    'Vi kunne ikke levere e-mailen lige nu. Prøv igen om lidt.',
  signup_delivery_status_temp_over_quota:
    'E-mailen kunne ikke leveres, fordi postkassen er fuld. Prøv igen om lidt.',
  signup_delivery_status_permanent_failure:
    'E-mailen kunne ikke leveres. Tjek adressen eller brug en anden e-mail.',
  signup_login_inline: 'Har du allerede en konto? Log ind',
  waiting_for_account: 'Opretter konto…',
  account_verification_waiting: 'Verifiering i gang…',
  account_verification_heading: 'Konto verificeret!',
  account_verification_heading_error: 'Verificering mislykkedes',
  account_verification_description: 'Din konto er verificeret.',
  account_verification_description_error: 'Kunne ikke verificere. Prøv igen eller kontakt support.',
  update_payment_method_waiting: 'Opdaterer betalingsmetode…',
  update_payment_method_success: 'Betalingsmetode opdateret!',
  warning_payment_method: 'Vælg ny betalingsmetode',
  complete_pending_payment: 'Fuldfør betalingen.',
  plans_card_payment_method: 'Se betalingsmuligheder her:',
  forgot_password_heading: 'Brug for hjælp med din adgangskode?',
  forgot_password_description: 'Skriv din e-mailadresse, så sender vi et link.',
  forgot_password_button: 'Send link',
  forgot_password_message: 'Vi har sendt et link til din e-mail. Tjek indbakke eller spam.',
  forgot_password_title: 'Link sendt',
  forgot_password_waiting: 'Sender link…',
  set_new_password: 'Angiv ny adgangskode',
  set_new_password_description: 'Vælg ny adgangskode, bekræft og log ind.',
  set_new_password_error: 'Indtast adgangskode',
  set_new_password_success: 'Adgangskode opdateret!',
  set_new_password_waiting: 'Opdaterer adgangskode…',
  action_required: 'Handling påkrævet:',
  email_verification_alert: 'Tilføj og verificer e-mail for at fortsætte login.',
  goTo_settings_page: 'Gå til indstillinger',
  go_to_home_page: 'Gå til startside',
  verify_now: 'Verificer nu',
  authCode_verified: 'Telefonnummer verificeret!',
  personal_information_updated: 'Personlige oplysninger opdateret',
  change_phone_number: 'Skift telefonnummer',
  verify_phone_button: 'Verify phone number',
  change_email: 'Skift e-mail',
  current_email: 'Nuværende e-mail',
  new_email: 'Ny e-mail',
  verify_email_button: 'Verify email',
  change_email_btn: 'Skift e-mail',
  change_password: 'Skift adgangskode',
  change_password_btn: 'Skift adgangskode',
  reset_date: 'Nulstil dato',
  date_picker_day_label: 'Dag',
  date_picker_month_label: 'Måned',
  date_picker_year_label: 'År',
  date_picker_day_placeholder: 'Vælg dag',
  date_picker_month_placeholder: 'Vælg måned',
  date_picker_year_placeholder: 'Vælg år',
  date_picker_search_placeholder: 'Søg…',
  date_picker_no_results: 'Ingen resultater',
  date_picker_clear: 'Ryd valg',
  sending_verification_email_waiting: 'Verifikationslink sendt…',
  local_name: 'Lokalt navn',
  create_anniversary_waiting: 'Opretter mærkedag… vent venligst',
  anniversary_time_end: 'Begivenheden er afsluttet',
  hello: 'Hej',
  coins: 'Mønter',
  store: 'Nærvær',
  purchase: 'Køb',
  checkout_title: 'Fuldfør valget',
  checkout_billing_address: 'Faktureringsadresse',
  checkout_billing_name_label: 'Fuldt navn',
  checkout_billing_name_placeholder: 'Fuldt navn',
  checkout_billing_email_label: 'E-mail',
  checkout_billing_email_placeholder: 'E-mail',
  checkout_billing_phone_label: 'Telefonnummer',
  checkout_billing_phone_placeholder: 'Telefonnummer',
  checkout_billing_street_label: 'Gadeadresse',
  checkout_billing_street_placeholder: 'Gadeadresse',
  checkout_billing_city_label: 'By',
  checkout_billing_city_placeholder: 'By',
  checkout_billing_state_label: 'Kommune',
  checkout_billing_state_placeholder: 'Kommune',
  checkout_billing_postal_label: 'Postnummer',
  checkout_billing_postal_placeholder: 'Postnummer',
  checkout_billing_country_label: 'Land',
  checkout_billing_country_placeholder: 'Vælg land',
  checkout_card_details: 'Kortoplysninger',
  checkout_card_number_label: 'Kortnummer',
  checkout_card_number_placeholder: '1234 1234 1234 1234',
  checkout_card_expiration_label: 'Udløbsdato',
  checkout_card_expiration_placeholder: 'MM / ÅÅ',
  partner_card_expiration: 'Udløbsdato',
  checkout_card_cvc_label: 'Sikkerhedskode',
  checkout_card_cvc_placeholder: 'CVC',
  checkout_payment_unavailable: 'Betalingstjenesten er ikke klar. Prøv igen.',
  checkout_missing_card_details: 'Indtast dit kortnummer for at fortsætte.',
  checkout_missing_card_expiry: 'Indtast udløbsdatoen.',
  checkout_missing_card_cvc: 'Indtast CVC-koden.',
  checkout_saved_payment_methods: 'Betalingsmetode',
  checkout_add_new_payment: 'Tilføj betalingsmetode',
  checkout_notice_banner_title: 'Gave til familien',
  checkout_notice_banner_body:
    'Denne bestilling bliver knyttet til annoncen{hasName, select, true { for {name}} false {}}.',
  checkout_cart_title: 'Din kurv',
  checkout_subtotal: 'Subtotal',
  checkout_total: 'Total',
  checkout_checkout: 'Bekræft valget',
  checkout_complete_purchase: 'Bekræft valget',
  checkout_pay_amount: 'Betal {amount}',
  bonus_tc: 'Bonus TC',
  set_color: 'Hvad er din farve i dag?',
  set_color_button: 'Vælg din farve',
  sparks: 'Gnister',
  community: 'Fællesskab',
  purpose: 'Formål',
  talents: 'Talenter',
  profile_image_changed: 'Billedet er opdateret',
  cover_photo_updated: 'Forsidebilledet er opdateret.',
  cover_photo_removed: 'Forsidebilledet er fjernet.',
  edit_cover_photo: 'Rediger forsidebillede',
  waiting_profile_upload: 'Opdaterer profilbillede… vent venligst',
  graves: 'Dem jeg bærer med mig',
  'cemeteryLanding.title': 'Find en grav på {cemetery}',
  wisdom: 'Visdom',
  sparks_description: 'Del din Gnist, der kan antænde og sprede lys.',
  text_area_placeholder: 'Hvordan kan du oplyse andres vej?',
  crop_image: 'Beskær billede',
  recurring_anniversary: 'Gentag hvert år',
  nick_name: 'Kaldenavn',
  birth_name: 'Fødenavn',
  date_of_birth: 'Fødselsdato',
  date_of_death: 'Dødsdato',
  time_of_birth: 'Fødselstidspunkt',
  time_of_death: 'Dødstidspunkt',
  place_of_birth: 'Fødested',
  place_of_death: 'Dødssted',
  cause_of_death: 'Dødsårsag',
  municipality: 'Kommune',
  country: 'Land',
  cemetery: 'Kirkegård',
  grave_number: 'Gravnummer',
  grave_info_updating: 'Opdaterer graveoplysninger… vent venligst',
  deceased_name: 'Navn',
  deceased_placeholder: 'Indtast navnet på den afdøde',
  deceased_gender: 'Køn',
  i_am: 'Jeg er',
  buried_is_mine: 'Den afdøde er min',
  select_relationship: 'Vælg relation',
  upload_document: 'Upload dokument til graven',
  upload_document_description: 'Vælg hvilket dokument du vil uploade:',
  death_certificate: 'Dødsattest',
  birth_certificate: 'Fødselsattest',
  invoice: 'Kvittering for gravpleje eller leje',
  power_of_attorney: 'Prokura',
  driving_license: 'ID-kort for den afdøde',
  proof_of_person: 'Upload dokument om den afdøde',
  proof_of_person_description: 'Dokumentet kan være PDF, PNG eller JPG og maks. 5 MB',
  replace_files: 'Erstat filer',
  browse_files: 'Find din fil',
  drag_image: 'eller træk filen her',
  dear: 'Kære',
  new_grave_first_description: 'Velkommen til at oprette en ny Netgrav.',
  new_grave_second_description: 'Her kan du oprette en sikker og respektfuld grav.',
  new_grave_third_description:
    'Ved at oprette en Netgrav bekræfter du, at du har tilladelse til det for den afdøde.',
  new_grave_fourth_description: "Klik 'Accepter' for at fortsætte.",
  new_grave_agree_terms: 'Jeg accepterer ovenstående vilkår',
  enter_name_error: 'Indtast personens navn',
  select_gender_error: 'Vælg personens køn.',
  select_relation_error: 'Vælg din relation til personen.',
  select_date_error: 'Vælg en dato',
  select_reason_error: 'Vælg en dødsårsag',
  reason_of_death: 'Dødsårsag',
  other_reason: 'Indtast anden dødsårsag',
  other_reason_error: 'Indtast anden dødsårsag',
  select_country: 'Vælg land',
  select_municipality: 'Vælg kommune',
  select_cemetery: 'Vælg kirkegård',
  select_country_error: 'Vælg et land',
  select_municipality_error: 'Vælg en kommune',
  select_cemetery_error: 'Vælg en kirkegård',
  create_the_grave: 'Opret graven',
  create_the_message: 'Opretter grav… vent venligst',
  death_date_error: 'Vælg en gyldig dødsdato',
  birth_date_error: 'Vælg en gyldig fødselsdato',
  month_0: 'januar',
  month_1: 'februar',
  month_2: 'marts',
  month_3: 'april',
  month_4: 'maj',
  month_5: 'juni',
  month_6: 'juli',
  month_7: 'august',
  month_8: 'september',
  month_9: 'oktober',
  month_10: 'november',
  month_11: 'december',
  unknown_year: 'Ukendt år',
  unknown_month: 'Ukendt måned',
  'life.unknown_month': 'Ukendt måned',
  weekday_0: 'søndag',
  weekday_1: 'mandag',
  weekday_2: 'tirsdag',
  weekday_3: 'onsdag',
  weekday_4: 'torsdag',
  weekday_5: 'fredag',
  weekday_6: 'lørdag',
  father: 'Far',
  mother: 'Mor',
  son: 'Søn',
  husband: 'Ægtefælle',
  wife: 'Hustru',
  brother: 'Bror',
  sister: 'Søster',
  maternal_grandfather: 'Morfar',
  maternal_grandmother: 'Mormor',
  paternal_grandfather: 'Farfar',
  paternal_grandmother: 'Farmor',
  maternal_uncle: 'Morbror',
  maternal_aunt: 'Moster',
  paternal_uncle: 'Farbror',
  paternal_aunt: 'Faster',
  farfar: 'Farfar',
  morfar: 'Morfar',
  farmor: 'Farmor',
  mormor: 'Mormor',
  grandfather: 'Bedstefar',
  grandmother: 'Bedstemor',
  grandchild: 'Barnebarn',
  grandson: 'Barnebarn',
  granddaughter: 'Barnebarn',
  uncle: 'Onkel',
  uncle_child: 'Fætre/Kusiner',
  aunt: 'Tante',
  aunt_child: 'Fætre/Kusiner',
  nephew: 'Nevø',
  niece: 'Niece',
  cousin: 'Fætter/Kusine',
  aunt_husband: 'Tantes ægtefælle',
  uncle_wife: 'Onkels ægtefælle',
  cousin_wife: 'Fætterens/Kusinens ægtefælle',
  cousin_husband: 'Fætterens/Kusinens ægtefælle',
  stepbrother: 'Stedbror',
  stepsister: 'Stedsøster',
  stepfather: 'Stedsfader',
  stepmother: 'Stedmoder',
  stepson: 'Stedsøn',
  stepdaughter: 'Steddatter',
  father_in_law: 'Svigerfar',
  mother_in_law: 'Svigerinde',
  brother_in_law: 'Svoger',
  sister_in_law: 'Svigerinde',
  son_in_law: 'Svigersøn',
  daughter_in_law: 'Svigerdatter',
  self: 'Mig',
  parent: 'Forælder',
  child: 'Barn',
  sibling: 'Søskende',
  spouse: 'Ægtefælle',
  grandparent: 'Bedsteforælder',
  great_grandparent: 'Oldeforælder',
  great_grandchild: 'Oldebarn',
  great_great_grandparent: 'Tip-oldeforælder',
  great_great_grandchild: 'Tip-oldebarn',
  great_great_great_grandparent: 'Tip-tip-oldeforælder',
  great_great_great_grandchild: 'Tip-tip-oldebarn',
  aunt_or_uncle: 'Tante/Onkel',
  great_uncle: 'Grandonkel',
  great_aunt: 'Grandtante',
  great_aunt_or_uncle: 'Grandtante/Grandonkel',
  nibling: 'Niece/Nevø',
  grand_niece: 'Grandniece',
  grand_nephew: 'Grandnevø',
  grand_nibling: 'Grandniece/Grandnevø',
  great_niece: 'Oldeniece',
  great_nephew: 'Oldenevø',
  great_nibling: 'Oldeniece/Oldenevø',
  cousin_in_law: 'Indgiftet fætter/kusine',
  aunt_in_law: 'Indgiftet tante',
  uncle_in_law: 'Indgiftet onkel',
  first_cousin_in_law: 'Indgiftet fætter/kusine',
  uncle_in_law_son: 'Indgiftet onkels søn',
  first_cousin: 'Fætter/kusine (1. led)',
  first_cousin_once_removed: 'Fætter/kusine (1. led, én gang forskudt)',
  first_cousin_twice_removed: 'Fætter/kusine (1. led, to gange forskudt)',
  second_cousin: 'Fætter/kusine (2. led)',
  second_cousin_once_removed: 'Fætter/kusine (2. led, én gang forskudt)',
  second_cousin_twice_removed: 'Fætter/kusine (2. led, to gange forskudt)',
  third_cousin: 'Fætter/kusine (3. led)',
  third_cousin_once_removed: 'Fætter/kusine (3. led, én gang forskudt)',
  third_cousin_twice_removed: 'Fætter/kusine (3. led, to gange forskudt)',
  aunt_uncle_in_law: 'Indgiftet tante/onkel',
  nibling_in_law: 'Indgiftet niece/nevø',
  niece_in_law: 'Indgiftet niece',
  nephew_in_law: 'Indgiftet nevø',
  parent_in_law: 'Svigerforælder',
  child_in_law: 'Svigerbarn',
  sibling_in_law: 'Svigersøskende',
  grandparent_in_law: 'Svigerbedsteforælder',
  grandchild_in_law: 'Svigerbarnebarn',
  step_parent: 'Stedforælder',
  step_mother: 'Stedmoder',
  step_father: 'Stedfader',
  step_child: 'Stedbarn',
  step_daughter: 'Steddatter',
  step_son: 'Stedsøn',
  step_sibling: 'Stedsøskende',
  step_sister: 'Stedsøster',
  step_brother: 'Stedbror',
  boyfriend: 'Kæreste',
  girlfriend: 'Kæreste',
  adopt_son: 'Adoptivsøn',
  adopt_daughter: 'Adoptivdatter',
  adopted_son: 'Adoptivsøn',
  adopted_daughter: 'Adoptivdatter',
  moons: 'Måner',
  my_moons: 'Mine måner',
  has_you_as_moon: 'Har dig som måne',
  moons_empty_title: 'Ingen måner endnu.',
  moons_empty_description: 'En måne er en person, som har vejledt dig. En, hvis lys du følger.',
  friends: 'Venner',
  friends_and_family: 'Familie og venner',
  colleagues: 'Kollegaer',
  friend: 'Ven',
  other: 'Andet',
  daughter: 'Datter',
  partner: 'Partner',
  relation_category_parent: 'Forælder',
  relation_category_child: 'Barn',
  relation_category_partner: 'Partner',
  relation_category_sibling: 'Søskende',
  relation_category_grandparent: 'Bedsteforælder',
  relation_category_aunt_uncle: 'Tante/Onkel',
  relation_quick_pick_hint: 'Vi har forvalgt dit valg. Bekræft eller skift.',
  relation_quick_pick_parent_choose: 'Vælg mor eller far.',
  relation_quick_pick_sibling_choose: 'Vælg bror eller søster.',
  relation_quick_pick_child_choose: 'Vælg søn eller datter.',
  open_details: 'Åbn detalje',
  colleague: 'Kollega',
  great_granddaughter: 'Oldebarn',
  great_grandson: 'Oldebarn',
  great_grandmother: 'Oldemor',
  great_grandfather: 'Oldefar',
  great_great_granddaughter: 'Tipoldebarn',
  great_great_grandson: 'Tipoldebarn',
  great_great_grandmother: 'Tipoldemor',
  great_great_grandfather: 'Tipoldefar',
  great_great_great_granddaughter: 'Tip-tipoldebarn',
  great_great_great_grandson: 'Tip-tipoldebarn',
  great_great_great_grandmother: 'Tip-tipoldemor',
  great_great_great_grandfather: 'Tip-tipoldefar',
  cohabitant: 'Samlever',
  contact_person: 'Din kontaktperson',
  monthly: 'Månedligt',
  semi_annual: 'Halvårligt',
  annually: 'Årligt',
  biennial: 'Hvert andet år',
  auth_modal_description:
    'Log ind eller opret en gratis konto for at besøge grave og bruge alle funktioner.',
  auth_modal_heading: 'Log ind | Opret konto',
  active: 'Aktiv',
  requested_to_remove: 'Anmodning om fjernelse',
  manage_members: 'Administrer medlemmer',
  remove_members_warning: 'Fjern medlemmer eller sænk antallet for at fortsætte.',
  subscription_base_price: 'Basispris',
  membership: 'medlemskab',
  remove_all_grave_user: 'Vigtigt: Opdatering af gravadministration',
  remove_all_grave_user_message:
    'Behold mindst én person eller administrator tilknyttet. Hvis du vil fjerne alle, overfør ejerskab eller slet graven.',
  send_it: 'Send',
  public_view: 'Offentlig visning',
  spark_posting_to_privacy: 'Synlig for {privacy}',
  constellation: 'Stjernebillede',
  moons_only: 'Kun måner',
  form: 'Formular',
  state_of_mind: 'Sindstilstand',
  spark_state_of_mind_info: 'Vælg din sindstilstand. Den former, hvordan din gnist modtages.',
  spark_state_of_mind_info_label: 'Info om sindstilstand',
  spark_form_info_label: 'Info om udtryk',
  spark_remove_link_preview_to_add_media: 'Fjern linkforhåndsvisningen for at tilføje medier.',
  taggable_composer_type_to_tag: 'Skriv et navn for at tagge',
  taggable_composer_no_matches: 'Ingen matches',
  taggable_composer_clear: 'Ryd',
  question: 'spørgsmål',
  insight: 'indsigt',
  experience: 'oplevelse',
  discovery: 'opdagelse',
  feeling: 'følelse',
  value: 'værdi',
  energy: 'energi',
  select_category: 'Vælg kategori',
  spark_delete: 'Gnisten slettet',
  spark_create: 'Gnisten oprettet',
  spark_update: 'Gnisten opdateret',
  ENG: 'Engelsk',
  NOR: 'Norsk',
  loading: 'Indlæser…',
  in_your_mind: 'Del en tanke, et spørgsmål eller en erfaring…',
  spark_reflection_placeholder:
    'Svar med det denne gnisten vækker i dig – refleksion, håb eller forbindelse.',
  create_spark: 'Opret en Gnist',
  reflect_on_spark: 'Reflect on Spark',
  empty_graves:
    'Brug søgefeltet øverst til venstre for at finde en grav, du har forbindelse til. Når relation er sat, vises den her.',
  all: 'Alle',
  owner: 'Ejer',
  affiliated: 'Tilknyttet',
  view_all: 'Vis alle',
  close_relation: 'Når du tilføjer nogen, vises de her.',
  no_relation_set: 'Ingen relationer sat',
  love_ones: 'Dem der går med {name}',
  set_relation: 'Vælg din relation',
  relation_request_send: 'Relationsanmodning sendt',
  relation_updated_success: 'Relationen er opdateret.',
  relation_update_failed: 'Kunne ikke opdatere relationen.',
  relation_removed_success: 'Relationen er fjernet.',
  relation_remove_failed: 'Kunne ikke fjerne relationen.',
  relation_connection: '{name} er min {reciprocalRelation}, og jeg er {name}s {relation}.',
  request_send: 'Anmodning sendt',
  empty_sparks: 'Ingen gnister tilgængelige, opret en ny',
  'sparks.empty_stars':
    'Ingen gnister er blevet stjerner endnu. Når en gnist vokser til en stjerne, vises den her.',
  create_post: 'Gravvæggen · {graveName}',
  grave_wall_cta_primary: 'Læg ordene',
  grave_wall_cta_secondary: 'Luk',
  post: 'Publicer',
  update_post: 'Opdater indlæg',
  account_heading: 'Slet din konto',
  delete_account: 'Slet konto',
  delete_account_pending: 'Sletning igangværende',
  deleted_message_pending:
    'Anmodning om sletning sendt. Konto og data slettes. Kan afbestilles inden 23:50 i dag. Kontakt kontakt@nettgrav.no ved spørgsmål.',
  deleted_message:
    'Hvis du sletter din konto, fjernes al information og data permanent. Sletningen er endelig efter 23:50. Kontakt kontakt@nettgrav.no hvis du har spørgsmål.',
  confirm_delete_account: 'Dette sletter kontoen og alt indhold.',
  confirm_cancel_account: 'Dette stopper sletningen og beholder kontoen.',
  account_delete_confirm_button: 'Fjern konto',
  account_delete_cancel_button: 'Behold konto',
  account_cancel_delete_confirm_button: 'Stop sletning',
  account_cancel_delete_cancel_button: 'Behold konto',
  phone_number_error: 'Telefonnummer/adgangskode passer ikke',
  email_error_login: 'E-mail og adgangskode passer ikke.',
  set_relation_heading: 'Forbind til graven',
  set_relation_free_description: 'Fortæl hvem {graveName} er for dig for adgang.',
  set_relation_access: 'Som medlem kan du:',
  do_you_know: 'Hvem er {graveName} for dig?',
  set_relation_description: 'Send anmodning om medlemskab som slægtning, ven eller godhjertet',
  set_relation_info_message: 'Gratis konti bedes betale $2/måned ved “Bekræft og deltag”.',
  click_button_below: 'Vælg relation for at fortsætte.',
  feature_title_1: 'Mindealbum',
  feature_description_1: 'Tilføj billeder af din kære og familie.',
  feature_title_2: 'Mindevæg',
  feature_description_2: 'Læs og del minder med andre, der kendte dem.',
  feature_title_3: 'Mærkedagskalender',
  feature_description_3: 'Få påmindelser om vigtige dage.',
  feature_title_4: 'Værdiarkiv',
  feature_description_4: 'Gem vigtige lærdomme, din kære gav dig.',
  feature_title_5: 'Livsarkiv',
  feature_description_5: 'Skriv historier om deres liv ned.',
  choose_relation: 'Vælg relation',
  relation_label: 'Jeg er {grave}s',
  reciprocal_label: '{grave} er min',
  set_relation_note: 'Vælg hvem den afdøde er for dig og giv graven et hjem.',
  set_relation_other: 'For alle, der kendte den afdøde – kollega, fan eller andet.',
  set_relation_placeholder: 'F.eks. Jeg var venner med {grave} på universitetet i Oslo…',
  confirm_relation_member: 'Bekræft relation og deltag',
  pay_and_reactivate: 'Betal for at genaktivere medlemskab',
  confirm_membership: 'Bekræft medlemskab',
  enlightened: 'Oplyst',
  inspired: 'Inspireret',
  spark_reaction_add_wood: 'Læg brænde på',
  spark_reaction_add_breath: 'Giv gnisten luft',
  spark_reaction_add_light: 'Giv gnisten lys',
  spark_reaction_legacy: 'Tidligere reaktioner',
  spark_stage_spark: 'Gnisten',
  spark_stage_campfire: 'Lejrbål',
  spark_stage_star: 'Stjerne',
  'spark.openDetail': 'Åbn gnist',
  reflected: 'Reflekteret',
  comments: 'svar',
  comment: 'svar',
  empty_comments: 'Ingen svar fundet',
  comment_placeholder: 'Skriv her…',
  reply: 'Svar',
  view_replies: 'Se alle {total} svar',
  create_grave_body: 'For at oprette en ny Netgrav, skal du have et Conscious-medlemskab.',
  upgrade_modal_heading: 'Opret ny grav',
  go_to: 'Gå til',
  our_plans: 'aktiver medlemskab',
  choose_the_subscription: 'for at få adgang til alle funktioner.',
  link_grave_body:
    'Så dejligt, du vil linke de begravede sammen. Du skal have Conscious-medlemskab.',
  add_more_images_body:
    'For at tilføje flere billeder i albummet skal du opgradere dit abonnement.',
  inviting_body: 'Invitationer er tilgængelige med Conscious-medlemskab.',
  life_archive_body: 'Livsarkivet er tilgængeligt med Conscious-medlemskab.',
  upload_images_body: 'For at tilføje billeder skal du opgradere dit nuværende abonnement.',
  add_value_body: 'Så fint, at du vil tilføje en egenskab. Du skal have Conscious-medlemskab.',
  search_limit_body:
    'Udforsk Netgrav med vores Conscious-plan. Opgrader i dag for ubegrænsede søgninger.',
  grave_invitation_first_text: 'Du er inviteret til at bidrage til graven',
  of: 'af',
  grave_invitation_second_text: 'Her kan I samle minder, billeder og mærkedage sammen.',
  grave_email_info:
    'Denne e-mail er låst for denne invitation. Hvis noget er galt, kontakt den, der inviterede dig.',
  subscription_email_info:
    'Denne e-mail er låst for dette abonnement. Hvis noget er galt, kontakt den, der satte det op.',
  grave_invitation_message:
    '{name} har inviteret dig til at være med til at tage vare på graven for {grave}.',
  accept_or_pay: 'Accepter og betal',
  paid_grave_user_message:
    'Du er inviteret af {userName} med betalt abonnement. Accepter for at deltage, eller afvis.',
  unpaid_grave_user_message:
    'Du er inviteret af {userName}. For at deltage, opgrader til betalt abonnement. Accepter eller afvis.',
  active_unpaid_grave_user_message:
    'Du har ikke et aktivt abonnement. Reaktiver for at fortsætte bidrag. Klik for at fornye!',
  invite: 'Inviter',
  complete_relation_setup: 'Fuldfør betaling for at bekræfte relation',
  already_set_relation: 'Du har allerede sat relationen til {graveName} som {relation}.',
  already_accept_relation: 'Du har allerede accepteret relationen til {graveName} som {relation}.',
  finalize_membership:
    'For at afslutte forbindelsen og låse op for alle medlemsfordele, fuldfør betalingen. Derefter knyttes graven til din livsside, og du får adgang til:',
  click_below_to_complete: 'Klik nedenfor for at fuldføre betalingen og bekræfte relationen.',
  complete_payment: 'Fuldfør betaling',
  awaiting_owner_approval: 'Venter på ejerens godkendelse',
  awaiting_approval_message:
    'Ejeren er informeret om din forespørgsel. Vent på godkendelse eller afslag.',
  subscribed_grave_invitation:
    'Du er inviteret til at linke dig til {graveName} som {relation} af {name}.',
  click_below_to_accept: 'Klik nedenfor for at acceptere invitationen.',
  accept_invitation: 'Accepter invitation',
  accept_invitation_payment: 'Accepter og betal',
  complete_invitation: 'Fuldfør invitation',
  unsubscribed_grave_invitation:
    'For at acceptere invitationen skal du fuldføre betalingen. Derefter får du adgang til eksklusive funktioner:',
  you_are_invited: 'Du er inviteret!',
  reclaim_user_access: 'Generer din adgang',
  previous_relation: 'Du var tidligere forbundet med {graveName} som {relation}.',
  downgrade_subscription:
    'Dit medlemskab er nedgraderet til gratisplanen; adgang er begrænset men du er stadig medlem.',
  regain_access: 'For fuld adgang, opgrader dit medlemskab.',
  click_below_to_upgrade: 'Klik nedenfor for at opgradere og gendanne adgang.',
  upgrade_membership: 'Opgrader medlemskab',
  set_self_relation: 'Fortæl hvem {graveName} er for dig for at linke til graven.',
  set_relation_linked: 'Når du gør det kan du:',
  set_self_relation_1: 'Besøge graven når som helst.',
  set_self_relation_2: 'Bevare minder og familie.',
  set_self_relation_3: 'Lade graven give mere mening fremover.',
  set_self_relation_message: 'Vigtig meddelelse:',
  claim_grave_labe: 'Jeg vil være ansvarlig for denne grav. Marker boksen.',
  claim_grave_terms_1: 'Velkommen til Netgrav.',
  claim_grave_terms_2: 'Her kan du kræve en sikker og respektfuld grav.',
  claim_grave_terms_3: 'Ved at kræve en Netgrav bekræfter du tilladelse fra den afdøde.',
  claim_grave_terms_4: "Normalt er det den fysiske gravs ejer. Klik 'Accepter'.",
  i_agreed_claim: 'Jeg accepterer vilkårene ovenfor',
  upload_death_document: 'Upload dødsattesten for personen.',
  upload_death_document_limit: 'PDF/PNG/JPG, maks. 5 MB',
  drag_files: 'eller træk filen her',
  'grave.new.docs.header': 'Jeg er gravstedsejer/lejer.',
  'grave.new.docs.upload_title': 'Upload dokumentation',
  'grave.new.docs.upload_note': 'Format: PDF, PNG eller JPG (maks 5 MB).',
  'grave.new.docs.button': 'Upload dokumentation',
  'grave.new.docs.drop_hint': 'Klik eller træk filen hertil',
  'grave.new.info.title': 'Ansvar for graven.',
  'grave.new.info.line1':
    'Når du går videre, bekræfter du, at du har ret til at tage vare på denne grav.',
  'grave.new.info.line2':
    'Dette gælder normalt den, der har ansvar for den fysiske grav, eller en med fuldmagt.',
  'grave.new.info.line3': 'Dokumentationen bruges kun til dette formål.',
  'grave.new.accept_label': 'Jeg bekræfter, at jeg har ansvar for denne grav',
  'grave.new.create_cta': 'Opret grav',
  claim_grave_message: 'Har du ansvar for at tage vare på denne grav?',
  claim_grave_document_helper: 'Dette bruges kun til at bekræfte ansvar for graven.',
  claim_guardian_info_title: 'Hvad indebærer omsorgsansvar?',
  claim_guardian_info_lead:
    'At være værge betyder at tage vare på graven og fællesskabet omkring den.',
  claim_guardian_info_bullet_relations: 'Godkende eller afvise relationer',
  claim_guardian_info_bullet_content: 'Administrere indhold på graven',
  claim_guardian_info_bullet_admins: 'Tilføje eller fjerne administratorer',
  claim_guardian_info_note: 'Omsorgsansvar bekræftes med dokumentation.',
  take_ownership: 'Bliv {firstName}s værge',
  manage_grave: 'Forvalt graven',
  claim_request_queue: 'Din anmodning om at kræve {graveName} er sendt. Venter på godkendelse.',
  register_ownership: 'Registrer ejerskab',
  public: 'Offentlig',
  moon: 'Måne',
  moon_set: 'Vælg som min måne',
  moon_remove: 'Fjern månerelation',
  moon_remove_as_moon: 'Fjern som måne',
  moon_remove_confirm_moon:
    'Dette fjerner {username} som din måne. Du kan tilføje {username} igen senere.',
  moon_remove_confirm_as_moon:
    'Dette fjerner dig som måne for {username}. Du kan vælge igen senere.',
  moon_cancel_request: 'Annuller forespørgsel',
  moon_ping_cta: 'Giv et tegn',
  moon_request_sent: 'Måneforespørgsel sendt.',
  moon_request_accepted: 'Måneinvitation accepteret.',
  moon_request_declined: 'Måneinvitation afvist.',
  moon_request_page_title: 'Invitation til månerelation',
  moon_request_page_subtitle: '{name} ønsker, at du skal være deres måne.',
  moon_request_sign_in: 'Log ind for at svare',
  moon_request_accept: 'Acceptér',
  moon_request_decline: 'Afvis',
  moon_request_already_handled: 'Denne invitation er allerede behandlet.',
  moon_removed: 'Månerelation fjernet.',
  moon_ping_sent: 'Signal sendt.',
  moon_ping_cta_sent: 'Tegn sendt',
  moon_ping_sent_hint: 'De får besked om, at du er her for dem.',
  moon_ping_cooldown: 'Du har allerede givet et tegn i dag. Du kan sende et nyt om nogle timer.',
  moon_helper_text_line_1: 'En måne er en person, som har vejledt dig.',
  moon_helper_text_line_2: 'En, hvis lys du følger.',
  moon_helper_text: 'En måne er en person, som har vejledt dig. En, hvis lys du følger.',
  own_words_tab: 'Mine egne ord',
  own_words_public_tab: 'Egne ord',
  own_words_title: 'Mine egne ord',
  own_words_subtitle:
    'Et sted for det, du ønsker, at andre skal forstå om dig, mens I kan tale sammen.',
  own_words_prompts_title: 'Begynd med et spørgsmål',
  own_words_prompt_1: 'Hvad håber jeg, at du forstår om mig?',
  own_words_prompt_2: 'Hvad giver mit liv retning?',
  own_words_prompt_3: 'Hvad er svært at sige højt?',
  own_words_prompt_4: 'Hvad har jeg brug for at sætte ord på lige nu?',
  own_words_placeholder: 'Skriv med dine egne ord...',
  own_words_visibility_title: 'Hvem kan læse dette?',
  own_words_visibility_everyone: 'Alle på Nettgrav',
  own_words_self_only: 'Kun du kan læse dette, indtil du vælger en anden synlighed.',
  own_words_reader_invitation_title: 'Hvordan kan læseren møde dine ord?',
  own_words_reader_invitation_help: 'Valg med privat chat viser en beskedknap sammen med dine ord.',
  own_words_reader_invitation_listen: 'Bare læs',
  own_words_reader_invitation_ask: 'Spørg mig i privat chat',
  own_words_reader_invitation_understand_together: 'Forstå sammen i privat chat',
  own_words_reader_invitation_keep: 'Tag vare på dette',
  own_words_publish: 'Del ordene',
  own_words_update: 'Opdater',
  own_words_publish_success: 'Dine ord er blevet delt.',
  own_words_publish_needs_words: 'Skriv nogle ord, før du deler.',
  own_words_save_error: 'Kunne ikke gemme lige nu.',
  own_words_public_title: 'Med egne ord',
  own_words_public_subtitle: 'Ord, som {name} har skrevet og valgt at dele.',
  own_words_updated: 'Opdateret {date}',
  own_words_chat_cta: 'Spørg for at forstå',
  own_words_chat_ask_cta: 'Send privat besked',
  own_words_chat_understand_cta: 'Forstå sammen',
  own_words_chat_error: 'Samtalen kunne ikke åbnes lige nu.',
  after_me_tab: 'Efter mig',
  after_me_title: 'Efter mig',
  after_me_subtitle: 'Et sted til at gøre valg og ønsker tydeligere.',
  after_me_intro_title: 'Hvis jeg en dag ikke selv kan sige dette',
  after_me_intro_text: 'Du kan skrive lidt eller meget. Du kan ændre alt senere.',
  after_me_step_counter: 'Trin {current} af {total}',
  after_me_step_intentions_title: 'Hvad skal dette give?',
  after_me_step_words_title: 'Noget jeg vil have, at andre skal vide',
  after_me_step_legacy_title: 'Det der lever videre',
  after_me_words_help: 'Det behøver ikke være perfekt. Skriv det med dine egne ord.',
  after_me_writing_prompts_title: 'Begynd med et spørgsmål',
  after_me_writing_prompt_1: 'Hvad håber jeg, at I forstår om mig?',
  after_me_writing_prompt_2: 'Hvad har givet mit liv retning?',
  after_me_writing_prompt_3: 'Hvad håber jeg at give videre?',
  after_me_writing_prompt_4: 'Hvad bør mine nærmeste vide?',
  after_me_public_tab: 'Egne ord',
  after_me_public_title: 'Det jeg ønsker, at I skal vide om mig',
  after_me_public_subtitle: 'Ord skrevet af {name} og delt på egne præmisser.',
  after_me_public_intentions_title: 'Det jeg håber, at dette skal give',
  after_me_public_legacy_title: 'Det jeg håber at give videre',
  after_me_public_choices_title: 'Mine valg',
  after_me_public_updated: 'Opdateret {date}',
  after_me_public_chat_cta: 'Spørg for at forstå',
  after_me_public_chat_error: 'Samtalen kunne ikke åbnes lige nu.',
  after_me_emotional_context_title: 'Hvor kommer ordene fra?',
  after_me_emotional_context_help: 'Vælg kun, hvis det gør ordene lettere at forstå.',
  after_me_emotional_context_vulnerable: 'Sårbarhed',
  after_me_emotional_context_grateful: 'Taknemmelighed',
  after_me_emotional_context_hopeful: 'Håb',
  after_me_emotional_context_uncertain: 'Usikkerhed',
  after_me_emotional_context_peaceful: 'Ro',
  after_me_reader_invitation_title: 'Hvordan ønsker du at blive mødt?',
  after_me_reader_invitation_help: 'Gør det tydeligt, hvordan du ønsker at blive mødt.',
  after_me_reader_invitation_listen: 'Bare lyt',
  after_me_reader_invitation_ask: 'Spørg mig',
  after_me_reader_invitation_understand_together: 'Forstå sammen',
  after_me_reader_invitation_keep: 'Tag vare på dette',
  after_me_public_emotional_context_label: 'Ordene kommer fra',
  after_me_public_reader_invitation_label: 'Jeg ønsker at blive mødt med',
  after_me_legacy_help: 'Dette er valgfrit. Det kan give retning for dem, der står dig nær.',
  after_me_step_boundaries_title: 'Hvad ønsker du ikke?',
  after_me_step_sharing_title: 'Hvem skal vide det?',
  after_me_label_visibility: 'Hvem kan se dette?',
  after_me_label_activation_mode: 'Hvornår skal dette være synligt?',
  after_me_label_intentions: 'Hvad skal dette give?',
  after_me_label_message_text: 'Noget jeg vil have, at andre skal vide',
  after_me_label_grave_choice: 'Gravform',
  after_me_label_ceremony_choice: 'Ceremoniform',
  after_me_label_place_choice: 'Foretrukket sted',
  after_me_label_religious_preference: 'Ønsker du en religiøs ramme?',
  after_me_label_body_title: 'Kroppen',
  after_me_label_body_choice: 'Har du en præference for kremering eller kistegrav?',
  after_me_label_legacy_focus: 'Retning',
  after_me_label_legacy_reason: 'Hvis du vil, skriv én sætning om hvorfor.',
  after_me_label_boundaries: 'Hvad ønsker du ikke?',
  after_me_visibility_moons: 'Måner',
  after_me_visibility_family_friends: 'Familie og venner',
  after_me_visibility_self_only: 'Kun mig',
  after_me_activation_show_when_deceased: 'Vis hvis andre skal træffe valg på mine vegne',
  after_me_activation_visible_now: 'Synlig nu',
  after_me_intention_calm: 'Ro',
  after_me_intention_clarity: 'Tydelighed',
  after_me_intention_closeness: 'Nærhed',
  after_me_intention_calm_help: 'Så de nærmeste slipper at gætte.',
  after_me_intention_clarity_help: 'Så dine valg er lette at forstå.',
  after_me_intention_closeness_help: 'Så det, der sker, kan føles ægte.',
  after_me_choice_unsure: 'Usikker',
  after_me_choice_both: 'Begge',
  after_me_grave_choice_physical: 'Fysisk grav',
  after_me_grave_choice_nettgrav: 'Netgrav',
  after_me_ceremony_choice_small: 'Lille',
  after_me_ceremony_choice_open: 'Åben',
  after_me_ceremony_choice_none: 'Ingen',
  after_me_body_choice_cremation: 'Kremering',
  after_me_body_choice_coffin_burial: 'Kistegrav',
  after_me_place_choice_church: 'Kirke',
  after_me_place_choice_nature: 'Natur',
  after_me_place_choice_home: 'Hjemme',
  after_me_religious_preference_religious: 'Ja',
  after_me_religious_preference_non_religious: 'Nej',
  after_me_legacy_focus_knowledge: 'Viden',
  after_me_legacy_focus_knowledge_help: 'Forståelse, som kan gøre livet klarere og længere.',
  after_me_legacy_focus_health: 'Sundhed',
  after_me_legacy_focus_health_help:
    'Indsatser, der kan bidrage til, at færre liv ender for tidligt.',
  after_me_legacy_focus_care: 'Omsorg',
  after_me_legacy_focus_care_help: 'Værdighed og nærhed, hvor mennesker er mest sårbare.',
  after_me_legacy_focus_nature: 'Natur',
  after_me_legacy_focus_nature_help: 'Livets sammenhæng og det, der bærer os videre.',
  after_me_legacy_focus_creation: 'Skabelse',
  after_me_legacy_focus_creation_help: 'Det mennesket bygger, udtrykker og giver videre.',
  after_me_legacy_focus_freedom: 'Frihed',
  after_me_placeholder_message_text:
    'Er der noget, du gerne vil gøre tydeligt for dem, der står dig nær?',
  after_me_placeholder_legacy_reason: 'Skriv en kort sætning…',
  after_me_placeholder_boundaries: 'Nogle gange er det vigtigste at sætte en grænse.',
  after_me_status_ready: 'Tydelig',
  after_me_status_draft: 'Udkast',
  after_me_status_ready_hint: 'Du kan til enhver tid lave ændringer.',
  after_me_save_state_idle: 'Udkast',
  after_me_save_state_saving: 'Gemmer…',
  after_me_save_state_saved: 'Gemt',
  after_me_save_state_error: 'Kunne ikke gemme',
  after_me_back: 'Tilbage',
  after_me_next: 'Videre',
  after_me_mark_ready: 'Gør tydelig',
  after_me_update: 'Opdater',
  after_me_mark_ready_success: 'Gemt som tydelig.',
  after_me_mark_ready_needs_more: 'For at gøre dette tydeligt, har vi brug for lidt mere.',
  after_me_saved_inline: 'Tydelig version gemt',
  after_me_warning_self_only: 'Kun du kan se dette. Andre kan ikke hjælpe, hvis noget sker.',
  after_me_last_updated: 'Opdateret {date}',
  after_me_save_error: 'Kunne ikke gemme lige nu. Prøv igen.',
  after_me_error_visibility_missing: 'Vælg hvem der kan se dette.',
  after_me_error_activation_mode_missing: 'Vælg hvornår dette skal være synligt.',
  after_me_error_intentions_missing: 'Vælg mindst én intention.',
  after_me_error_content_missing: 'Tilføj nogle ord, før du gør dette tydeligt.',
  after_me_error_message_text_too_long: 'Teksten er for lang. Gør den lidt kortere.',
  after_me_error_boundaries_text_too_long: 'Teksten om grænser er for lang. Gør den lidt kortere.',
  after_me_error_legacy_reason_too_long: 'Begrundelsen er for lang. Gør den lidt kortere.',
  after_me_practical_title: 'Enkle valg',
  after_me_practical_intro: 'Dette handler ikke om detaljer. Kun det vigtigste.',
  after_me_boundaries_help: 'Nogle gange er det vigtigste at sætte en grænse.',
  private: 'Privat',
  relatives: 'Pårørende',
  need_subscription: 'Du skal have et abonnement for at tilføje minder.',
  upgrade_subscription: 'Opgrader abonnement',
  no_memories_added: 'Et sted for det, der bliver tilbage.',
  no_memories_added_with_relation: 'Et sted for det, der bliver tilbage.',
  no_memories_added_ceremony: 'Et sted for ordene også nu.',
  no_memories_added_with_relation_ceremony: 'Et sted for ordene også nu.',
  no_memories_added_no_relation_hint:
    'For dem der hørte til. Vælg din relation for at se gravvæggen og det, der lever videre.',
  grave_wall_pending_review_hint:
    'Din relation er registreret. Gravvæggen åbner, når Netgrav har godkendt graven.',
  input_memory_placeholder: 'Læg et par ord her.',
  input_memory_placeholder_ceremony: 'Skriv når du har brug for det.',
  memory_discard_message: 'Er du sikker på, at du vil forkaste dine ændringer?',
  discard_changes: 'Forkast ændringer?',
  discard: 'Forkast',
  discard_cancel: 'Fortsæt med at redigere',
  post_update_success: 'Indlæg opdateret',
  post_share_success: 'Indlæg delt',
  post_share_failed: 'Kunne ikke dele indlægget. Prøv igen.',
  post_failed: 'Kunne ikke poste. Prøv igen.',
  company_request_approved: 'Virksomhedsanmodning godkendt',
  company_request_declined: 'Virksomhedsanmodning afvist',
  ad_request_approved: 'Annonceanmodning godkendt',
  ad_request_declined: 'Annonceanmodning afvist',
  spark_comment_create_failed: 'Kunne ikke oprette kommentar',
  spark_comment_update_failed: 'Kunne ikke opdatere kommentar',
  settings_notification_preferences_saved: 'Notifikationsindstillinger gemt',
  file_upload_failed: 'Kunne ikke uploade fil',
  posting: 'Poster…',
  updating: 'Opdaterer…',
  edit_post: 'Rediger indlæg',
  update_memory: 'Opdater',
  create_memory_post: 'Post til grav',
  memory_description_placeholder: 'Læg et par ord her.',
  add_photos_videos: 'Tilføj billeder/videoer',
  click_or_drag_media: 'Klik eller træk media hertil',
  edit_image: 'Rediger billede',
  edit_video: 'Rediger video',
  add_caption: 'Tilføj billedtekst…',
  memory_deleted_success: 'Minde slettet!',
  memory_delete_failed: 'Kunne ikke slette mindet.',
  memory_load_failed: 'Indlægget kunne ikke hentes. Prøv igen.',
  comments_load_failed: 'Kommentarerne kunne ikke hentes. Prøv igen.',
  comment_delete_failed: 'Kommentaren kunne ikke slettes. Prøv igen.',
  grave_wall_load_failed: 'Gravvæggen kunne ikke hentes',
  grave_wall_load_failed_description: 'Prøv igen. Dit indhold er ikke blevet ændret.',
  delete_memory_title: 'Fjern fra dette sted?',
  delete_media_confirmation: 'Dette fjerner mediet fra dette sted. Du kan tilføje det igen senere.',
  delete_img_title: 'Fjern fra dette sted?',
  delete_memory_content: 'Dette fjerner indholdet fra dette sted. Du kan tilføje det igen senere.',
  delete_memory_confirm: 'Fjern',
  write_something_or_add_media:
    'En Gnist skal have noget at brænde. Del et billede, et minde eller et par ord – og lad det skinne.',
  empty_grave_post_warning:
    'Et gravopslag behøver noget at dele. Tilføj et billede, et minde eller et par ord – og lad det leve videre.',
  empty_memory_post_warning:
    'Du har ikke skrevet noget endnu. Del nogle ord, tanker eller minder før du udgiver.',
  add_to_your_post: 'Tilføj billede eller video',
  memory_review: 'Forhåndsvis minde',
  grave_wall: 'Gravvæggen',
  grave_ceremony_title: 'Dødsannonce og ceremoni',
  grave_ceremony_death_notice_section: 'Dødsannonce',
  grave_ceremony_ceremony_section: 'Ceremoni',
  grave_ceremony_edit: 'Rediger',
  grave_ceremony_subtitle_ready: 'Tid og sted, når det er klart.',
  grave_ceremony_subtitle_empty: 'Tilføj tid og sted, når det er klart.',
  grave_ceremony_published_by: 'Informationen er delt af {name}',
  grave_ceremony_published_by_relation: '{relation} til {graveName}',
  grave_ceremony_updated_at: 'Opdateret {dateTime}',
  grave_ceremony_when: 'Tidspunkt',
  grave_ceremony_where: 'Sted',
  grave_ceremony_place_of_death: 'Dødssted',
  grave_ceremony_message: 'Meddelelse',
  grave_ceremony_save: 'Gem',
  grave_ceremony_not_set: 'Ikke angivet',
  grave_ceremony_saved: 'Ceremoniinformation gemt.',
  grave_ceremony_save_failed: 'Kunne ikke gemme lige nu.',
  grave_ceremony_attendance_coming: 'Kommer',
  grave_ceremony_attendance_unsure: 'Usikker',
  grave_ceremony_attendance_not_coming: 'Kan ikke komme',
  grave_ceremony_attendance_summary: 'Svar',
  grave_ceremony_attendance_prompt: 'Kan du deltage i ceremonien?',
  grave_ceremony_response_saved: 'Dit svar er gemt.',
  grave_ceremony_response_failed: 'Kunne ikke gemme dit svar lige nu.',
  grave_ceremony_copy_link_failed: 'Kunne ikke kopiere linket lige nu.',
  grave_ceremony_redirecting: 'Åbner dødsannoncen på gravsiden…',
  grave_ceremony_timing_pending: 'Tid og sted er ikke fastsat endnu',
  grave_ceremony_responses_title: 'Hvem kommer',
  grave_ceremony_share_link: 'Del dødsannoncen',
  grave_ceremony_link_copied: 'Link til dødsannoncen kopieret',
  grave_ceremony_responses_empty: 'Ingen svar endnu.',
  grave_ceremony_responses_load_failed: 'Kunne ikke hente svarlisten lige nu.',
  grave_ceremony_move_to_anniversaries: 'Flyt til mærkedage nu',
  grave_ceremony_move_to_anniversaries_saved: 'Flyttet til mærkedage.',
  grave_ceremony_move_to_anniversaries_failed: 'Kunne ikke flytte lige nu.',
  create_grave_ceremony_visibility_notice:
    'Dødsannoncen offentliggøres på gravvæggen og kan deles med andre. Du kan redigere oplysningerne senere.',
  life_archive_menu: 'Livsarkiv',
  media: 'Media',
  connect_grave: 'Forbind grav',
  upgrade_plan_modal: 'Opgrader plan',
  more: 'Mere',
  about_name: 'Navn',
  about_gender: 'Køn',
  relations: 'Relationer',
  about_birthplace: 'Fødested',
  about_nickname: 'Kaldenavn',
  about_birth_name: 'Fødenavn',
  about_death_location: 'Dødssted',
  about_cemetery: 'Kirkegård',
  about_birthday: 'Fødselsdag',
  about_death_date: 'Dødsdato',
  about_relations: 'Relationer',
  about_cause_of_death: 'Dødsårsag',
  about_country: 'Land',
  about_title: 'Om',
  about_privacy: 'Synlighed',
  buried: 'Begravet',
  edit_grave_details: 'Rediger graveoplysninger',
  relationships: 'Relationer',
  grave_people_tab_label: 'Dem der hører til',
  grave_people_title: 'Dem der hører til',
  grave_people_title_with_name: 'Dem der stod {name} nær',
  grave_people_subtitle_with_name: 'Det er menneskene, som var en del af livet for {name}.',
  work: 'Arbejde',
  announcements: 'Dødsannoncer',
  grave_link: 'Sammen med',
  grave_link_header: '{graveName}, din {relation}, er forbundet med',
  placeholder_name: 'Indtast navn',
  placeholder_nickname: 'Indtast kaldenavn',
  placeholder_birth_name: 'Indtast fødenavn',
  placeholder_birthplace: 'Indtast fødested',
  placeholder_death_location: 'Indtast dødssted',
  placeholder_gender: 'Vælg køn',
  placeholder_country: 'Vælg land',
  placeholder_municipality: 'Vælg kommune',
  placeholder_cemetery: 'Vælg kirkegård',
  placeholder_cause_of_death: 'Vælg dødsårsag',
  placeholder_privacy: 'Vælg synlighed',
  placeholder_date_of_birth: 'Vælg fødselsdato',
  placeholder_time_of_birth: 'Vælg fødselstid',
  placeholder_date_of_death: 'Vælg dødsdato',
  placeholder_time_of_death: 'Vælg dødstid',
  grave_owner: 'gravejer',
  admin: 'admin',
  edit_relation: 'Rediger relation',
  remove_member: 'Fjern medlem',
  confirm_delete_user_title: 'Er du sikker?',
  confirm_button: 'Fjern',
  cancel_button: 'Behold',
  confirm_delete_message:
    'Dette fjerner {username} som familiemedlem. Du kan tilføje {username} igen senere.',
  confirm_remove_member_self_title: 'Vil du forlade denne grav?',
  confirm_remove_member_self_message: 'Du mister adgang nu, men kan knytte dig til igen senere.',
  confirm_remove_member_other_title: 'Vil du fjerne {username} fra denne grav?',
  confirm_remove_member_other_message:
    '{username} mister adgang nu, men kan inviteres igen senere.',
  relation_to_buried: 'Relation til dig',
  relation_to_user: 'Din relation til den begravede',
  role_required: 'Vælg en rolle',
  relation_required: 'Vælg en relation',
  direction_required: 'Vælg relationens retning.',
  relation_you_are_prefix: 'Du er',
  relation_you_are_suffix: 'til {name}',
  relation_they_are_prefix: '{name} er din',
  invitation_relation_you_are_prefix: 'Den inviterede er',
  invitation_relation_you_are_suffix: 'til {name}',
  invitation_relation_they_are_prefix: '{name} er den inviteredes',
  invite_family_member: 'Inviter nogen',
  grave_people_invite_button: 'Giv familien adgang',
  email_required: 'Indtast e-mail',
  email_required_validation: 'Indtast en gyldig e-mailadresse',
  name_required: 'Indtast navn',
  pending_invitations: 'Ventende invitationer',
  find_grave_member: 'Søg i relationer',
  grave_people_pending_invitations: 'Ventende invitationer',
  grave_people_search_placeholder: 'Find en person',
  grave_people_search_failed: 'Kunne ikke søge efter personer. Prøv igen.',
  grave_people_search_empty_title: 'Ingen resultater',
  grave_people_search_empty_message: 'Prøv et andet navn.',
  grave_invitations_load_failed: 'Invitationerne kunne ikke hentes.',
  relation_requests_load_failed: 'Relationsanmodningerne kunne ikke hentes.',
  relation_request_update_failed: 'Relationsanmodningen kunne ikke opdateres.',
  grave_invitation_sent: 'Invitationen er sendt.',
  grave_invitation_updated: 'Invitationen er opdateret.',
  find_invited_user: 'Find en du har inviteret',
  find_workplace: 'Find arbejdsplads',
  add_workplace: 'Tilføj arbejdsplads',
  company_name_label: 'Firmanavn',
  company_name_placeholder: 'Indtast firmanavn',
  company_name_required: 'Tilføj firmanavn.',
  city_label: 'By',
  city_placeholder: 'Indtast by',
  city_required: 'Tilføj by.',
  position_label: 'Stilling',
  position_placeholder: 'Indtast stilling',
  position_required: 'Tilføj stilling.',
  start_year_label: 'Startår',
  start_year_placeholder: 'Vælg startår',
  start_year_required: 'Vælg startår.',
  end_year_label: 'Slutår',
  end_year_placeholder: 'Vælg slutår',
  end_year_required: 'Vælg slutår.',
  description_label: 'Beskrivelse',
  description_placeholder: 'Indtast jobbeskrivelse',
  publicPrivacy_label: 'Privatliv',
  publicPrivacy_placeholder: 'Vælg privatlivsindstilling',
  publicPrivacy_required: 'Vælg privatlivsvalg.',
  invalid_end_date: 'Ugyldig slutdato',
  invalid_end_date_message: 'Slutdato kommer efter startdato.',
  no_workplaces_added: 'Steder der hørte til livet.',
  add_workplaces_message: 'Vælg din relation for at tilføje arbejdssteder der betød noget.',
  add_workplaces_message_member: 'Her kan du tilføje, hvor personen har arbejdet gennem livet.',
  no_invitations_sent: 'Del graven med de nærmeste',
  no_invitations_message: 'Inviter familie og venner til at være til stede – når det passer dem.',
  grave_people_empty_title: 'Ingen ventende invitationer',
  grave_people_empty_message: 'Invitationer du sender vises her, indtil de bliver besvaret.',
  grave_relation_responsible: 'Har ansvar',
  grave_people_owner_tag: 'Den som holder graven',
  photos: 'Album',
  find_interests: 'Find interesser',
  add_interest: 'Tilføj interesse',
  interest_name: 'Interessenavn',
  interest_name_placeholder: 'Indtast interessenavn',
  interest_name_required: 'Tilføj interessenavn.',
  interest_category: 'Kategori',
  interest_category_placeholder: 'Vælg kategori',
  interest_category_required: 'Vælg kategori.',
  interest_description: 'Beskrivelse',
  interest_description_placeholder: 'Indtast beskrivelse',
  interest_description_required: 'Tilføj beskrivelse.',
  confirm_delete_workplace_message:
    'Dette fjerner arbejdsstedet. Du kan tilføje arbejdsstedet igen senere.',
  confirm_delete_interests_message:
    'Dette fjerner interessen. Du kan tilføje interessen igen senere.',
  confirm_delete_payment_method_message:
    'Dette fjerner betalingsmetoden. Du kan tilføje en ny senere.',
  no_interests_added: 'Det der gav glæde, ro eller nysgerrighed.',
  add_interests_message: 'Vælg din relation for at dele interesser der hørte til livet.',
  add_interests_message_member:
    'Her kan du dele, hvad der fangede deres nysgerrighed, inspirerede dem eller fik dem til at smile.',
  add_passion: 'Tilføj passion',
  confirm_delete_passion_message:
    'Dette fjerner passionen fra dette sted. Du kan tilføje passionen igen senere.',
  confirm_delete_gift_message:
    'Dette fjerner gaven fra dette sted. Du kan tilføje gaven igen senere.',
  passion_description: 'Passionsbeskrivelse',
  passion_description_placeholder: 'Indtast passionsbeskrivelse',
  passion_description_required: 'Tilføj passionsbeskrivelse.',
  no_passion_added: 'Det der gav energi og mening.',
  add_passion_message: 'Vælg din relation for at tilføje passioner der betød meget.',
  add_passion_message_member:
    'Tilføj, hvad de virkelig brændte for – det, der gav dem energi, mening eller glæde.',
  no_grave_linked: 'Forbindelser skaber sammenhæng.',
  add_grave_linked_message:
    'Vis hvordan {firstName} hænger sammen med sin familie. Knyt {firstName} til dem, der betyder noget – uanset hvor gravene er.',
  grave_link: 'Sammen med',
  grave_link_empty_primary: 'Nogle grave hørte sammen i livet.',
  grave_link_empty_secondary: 'Her kan de stå sammen – uanset hvor de er begravet.',
  grave_link_empty_tertiary: 'Vælg din relation for at knytte dem sammen på Netgrav.',
  grave_link_empty_image_alt: 'To gravsteder knyttet sammen',
  grave_link_open_grave: 'Åbn graven for {name}',
  grave_link_more_actions: 'Flere handlinger for gravforbindelsen',
  grave_link_removed: 'Gravforbindelsen er fjernet.',
  grave_link_remove_failed: 'Vi kunne ikke fjerne forbindelsen. Prøv igen om lidt.',
  grave_link_updated: 'Gravforbindelsen er opdateret.',
  photo_albums_manage: 'Rediger samling',
  upload_photo: 'Upload foto',
  photo_uploading_title: 'Uploader billeder',
  photo_album_system_name: 'Samlede billeder',
  photo_album_images_count: '{count, plural, one {# billede} other {# billeder}}',
  photo_album_empty_count: 'Ingen billeder her endnu',
  photo_tagging_label: 'Vis også på andre grave',
  photo_tagging_placeholder: 'Vælg grave',
  photo_tagged_section_title: 'Billeder, der deles med andre grave',
  photo_tagged_source: 'Også på graven til {graveName}',
  photo_tagged_open_original: 'Se original',
  photo_upload_progress: 'Uploader {completed} af {total}',
  photo_upload_partial_failure:
    '{successCount} billeder uploadet, {failedCount} fejlede. Du kan prøve igen.',
  photo_album_delete_confirm_title: 'Slet album?',
  photo_album_delete_confirm_body: 'Billederne slettes ikke. De flyttes til Samlede billeder.',
  photo_album_delete_confirm_body_with_images:
    'Billederne er fortsat tilgængelige i Samlede billeder.',
  photo_album_delete_confirm_body_empty: 'Dette album er tomt og bliver slettet.',
  photo_album_delete_confirm_action: 'Slet album',
  photo_delete_image_title: 'Fjern billedet?',
  photo_delete_image_content: 'Billedet fjernes fra denne grav. Du kan tilføje det igen senere.',
  photo_delete_failed: 'Billedet kunne ikke fjernes. Prøv igen.',
  grave_photos_loading: 'Henter billeder',
  grave_photos_load_failed: 'Billederne kunne ikke hentes',
  grave_photos_load_failed_description: 'Prøv igen. Dit indhold er ikke blevet ændret.',
  grave_photos_retry: 'Prøv igen',
  grave_photos_load_more: 'Vis flere billeder',
  grave_photos_load_more_failed: 'Flere billeder kunne ikke hentes.',
  photo_albums_load_failed: 'Albumsamlingerne kunne ikke hentes.',
  grave_photo_alt: 'Billede på gravstedet for {name}',
  photo_comment_action_failed: 'Kommentaren kunne ikke gemmes. Prøv igen.',
  photo_comment_delete_title: 'Slet kommentaren?',
  photo_comment_delete_content: 'Kommentaren fjernes permanent.',
  photo_move_to_album: 'Flyt til album',
  photo_move_to_album_title: 'Flyt billede til album',
  photo_move_to_album_placeholder: 'Vælg album',
  no_photos_added: 'Her kan billeder samles over tid.',
  add_photos_message: 'Når et billede tilføjes, bliver det en del af historien.',
  album_empty_primary: 'Billeder der samles over tid.',
  album_empty_album_title: 'Ingen billeder her endnu',
  album_empty_album_message: 'Når et billede tilføjes, bliver det en del af historien.',
  album_empty_secondary: 'Vælg din relation for at tilføje billeder og se mere af historien.',
  album_empty_cta: 'Knyt dig til {firstName}',
  select_cover_photo: 'Vælg forsidebillede',
  add_photos: 'Tilføj billeder',
  choose_cover_photo: 'Vælg forsidebillede',
  adjust_cover_position: 'Juster placering',
  upload_image: 'Tilføj billede',
  remove_image: 'Fjern fra forsiden',
  remove_grave_avatar: 'Fjern profilbillede',
  grave_avatar_removed: 'Profilbilledet er fjernet.',
  grave_avatar_remove_failed: 'Kunne ikke fjerne profilbilledet.',
  edit_profile_photo: 'Rediger profilbillede',
  edit_cover_image: 'Rediger forsidebillede',
  add_cover_photo: 'Tilføj forsidebillede',
  edit: 'Rediger',
  upload_photos: 'Upload billeder',
  label_description: 'Beskrivelse',
  placeholder_description: 'Indtast beskrivelse',
  label_address: 'Adresse',
  placeholder_address: 'Indtast adresse',
  date_time: 'Dato og tid',
  create_anniversary: 'Opret mærkedag',
  edit_anniversary: 'Rediger mærkedag',
  add_life_event: 'Tilføj historie',
  no_events_added: '{firstName}s bog rummer historierne, der hører til {firstName}s liv.',
  life_events_empty_primary: 'Her kan livets historier få plads.',
  life_events_empty_secondary:
    'Knyt dig til gravstedet, hvis du vil bidrage med minder og historier.',
  life_events_empty_cta: 'Knyt dig til {firstName}',
  add_events_message: 'Her kan du dele minder, øjeblikke og ord, som viser hvem {firstName} var.',
  life_events_load_failed: 'Livshistorien kunne ikke hentes.',
  life_events_load_failed_description: 'Prøv igen. Dit indhold er ikke blevet ændret.',
  try_again: 'Prøv igen',
  life_event_media_update_failed: 'Billedet kunne ikke opdateres. Prøv igen.',
  life_event_media_delete_failed: 'Mediet kunne ikke fjernes. Prøv igen.',
  event_label_name: 'Historietitel',
  event_placeholder_name: 'Indtast titel',
  event_required_name: 'Tilføj titel.',
  event_label_date: 'Historiedato',
  event_placeholder_date: 'Vælg dato',
  event_required_date: 'Vælg dato.',
  event_label_theme: 'Vælg tema',
  event_placeholder_theme: 'Vælg tema',
  event_required_theme: 'Vælg tema.',
  event_label_country: 'Land',
  event_placeholder_country: 'Vælg land',
  event_required_country: 'Vælg land.',
  event_theme_selected: 'Valgt farve:',
  event_label_description: 'Historietekst',
  event_placeholder_description: 'Skriv historien her',
  event_required_description: 'Vælg historietekst.',
  event_theme_light: 'Lyst tema',
  event_theme_dark: 'Mørkt tema',
  create_event: 'Opret historie',
  create_event_grave_info: 'Tilføj en livsbegivenhed på {graveName}s grav.',
  edit_event: 'Rediger historie',
  show_all: 'Vis alle',
  set_as_cover: 'Sæt som forside',
  creator: 'Skaber',
  previous: 'Forrige',
  view_more_events: 'Vis flere livshistorier',
  view_more: 'Vis mere',
  connect_grave_title: 'Grave du kan knytte til {graveName}',
  connect_grave_select_title: 'Vælg graven du vil knytte til',
  connect_grave_relations_title: 'Sæt relationer',
  connect_grave_relation_subject: '{name} er',
  connect_grave_relation_object: 'til {name}',
  connect_grave_confirm: 'Knyt gravene',
  connect_grave_section_direct: 'Dine grave',
  connect_grave_section_other: 'Andre relevante',
  link_to_grave: 'Knyt til denne grav',
  your: 'Din',
  graves_not_found: 'Ingen grave tilgængelige lige nu.',
  connect_grave_empty_title: 'Der er ingen andre grave her endnu',
  connect_grave_empty_message: 'Når du får adgang til flere, kan du knytte dem sammen.',
  connect_grave_load_failed: 'Vi kunne ikke hente gravene lige nu.',
  share: 'Del',
  linked_copied: 'Link kopieret',
  share_memory: 'Del minde',
  copy_link: 'Kopier link',
  media_not_added: 'Ingen medier tilføjet endnu.',
  delete_event_title: 'Bekræft sletning af historie?',
  grave_is_private_title: '{graveName}s grav er privat',
  grave_is_private_message: 'Kun nære pårørende kan se minder og historier her.',
  grave_relations_private_title: 'Relationer er private',
  grave_relations_private_message: 'Da graven er privat, er relationer kun synlige for nære.',
  grave_user_not_found_message:
    'Her samles relationerne omkring {firstName}. Start med dig selv, og tilføj dem, der betyder noget.',
  grave_user_not_found_message_primary: 'Her samles relationerne omkring {firstName}.',
  grave_user_not_found_message_secondary: 'Start med dig selv, og tilføj dem, der betyder noget.',
  grave_relations_empty_primary: 'Her ser du hvem der hører til.',
  grave_relations_empty_secondary:
    'Knyt dig til graven for at se hvem der hører til omkring {firstName}.',
  grave_relations_empty_cta: 'Knyt dig til {firstName}',
  connect_with_grave: 'Vælg din relation til {graveName}',
  join_set_relation_free: 'Vælg din relation til {firstName}',
  join_sheet_title: 'Vælg din relation til {name}',
  join_sheet_intro: 'Et personligt rum til nærhed til {name} – tilgængeligt når du ønsker det.',
  join_sheet_auth_title: 'Log ind for at fortsætte',
  join_sheet_auth_intro: 'Log ind for at reagere, tilføje en refleksion eller skrive en kommentar.',
  join_sheet_intent_react_title: 'Log ind for at reagere på Gnister',
  join_sheet_intent_react_intro: 'Når du er logget ind, kan du reagere og deltage i samtalen.',
  join_sheet_intent_weekly_question_title: 'Log ind for at svare på ugens spørgsmål',
  join_sheet_intent_weekly_question_intro:
    'Når du er logget ind, kan du dele dit eget svar som en Gnist.',
  join_sheet_intent_reflect_title: 'Log ind for at tilføje en refleksion',
  join_sheet_intent_reflect_intro: 'Når du er logget ind, kan du dele din refleksion.',
  join_sheet_intent_composer_title: 'Log ind for at skrive en kommentar',
  join_sheet_intent_composer_intro: 'Når du er logget ind, kan du være med i samtalen.',
  join_sheet_intent_submit_title: 'Log ind for at offentliggøre din kommentar',
  join_sheet_intent_submit_intro: 'Når du er logget ind, kan din kommentar deles.',
  guest_quota_notice_title: 'Flere søgninger i dag',
  guest_quota_notice_body:
    'For at fortsætte med at søge i dag kan du logge ind eller oprette en konto.',
  please_sign_in_to_continue: 'Log ind for at fortsætte.',
  join_sheet_subtitle: 'Et sted for nærhed til {name}.',
  join_sheet_name_fallback: 'dem du holder af',
  connect_grave_message: 'Sæt din relation til en kær. Kræver Premium. Opgrader for adgang.',
  cancel_relation_request: 'Annuller relationsanmodning',
  cancel_claim_request: 'Annuller ejerskabsanmodning',
  grave_welcome_title: 'Velkommen til {name}s grav.',
  grave_intro_text: 'Her kan du læse, reflektere, dele historier, eller bare være stille.',
  grave_natural_feelings_text:
    'Det er naturligt at tænke på eget liv og egne tab, når du besøger en grav. Det er helt okay. Du er ikke alene.',
  grave_what_you_can_do_title: 'Dette kan du gøre her:',
  grave_read_stories: 'Læse historier og minder',
  grave_react_comment_care: 'Reagere og kommentere',
  grave_share_reflections: 'Dele egne refleksioner',
  grave_light_candle: 'Vær nær på mærkedage, og inviter andre som kendte den gravlagte',
  grave_why_nettgrav_matters_title: 'Netgrav missionen',
  grave_support_end_of_time_center:
    'Hver Netgrav støtter arbejdet til End Of Time Center, som arbejder for en sundere verden hvor færre dør af sygdom.',
  grave_team_end_of_time_message:
    'Hos Netgrav kan du også læse beskeder fra vores partnere – virksomheder der ønsker at gøre mere for dig og bidrage til en bedre verden.',
  grave_enter_grave_button: 'Luk',
  my_light_welcome_title: 'Mit Lys',
  my_light_you_are_the_light: 'Du er lyset.',
  my_light_intro_text: 'Dette er dit rum.',
  my_light_sparks_relationships_graves: 'Her kommer løsninger til det, der betyder noget.',
  my_light_what_you_find_here_title: 'Alt der bygges her har som mål at styrke gode sociale liv.',
  my_light_sparks: 'Med styrke, omsorg og menneskelig nærhed i centrum.',
  my_light_graves: 'Dette er et sted for dig.',
  my_light_loved_ones: 'For det du bærer, og det du ønsker at give videre.',
  my_light_everything_begins_with_you: 'Mere vil komme.',
  my_light_enter_button: 'Forstået',
  my_light_profile_occupation_label: 'Erhverv eller rolle',
  my_light_profile_occupation_placeholder: 'Hvad arbejder du med?',
  my_light_profile_bio_label: 'Om mig',
  my_light_profile_bio_placeholder: 'Skriv et par linjer om dig',
  compass_tab: 'Mit kompas',
  compass_title: 'Mit kompas',
  compass_title_other: 'Sådan holder {name} kurs',
  compass_subtitle: 'Det jeg forsøger at leve efter.',
  compass_empty_lead: 'Nogle vælger at skrive den retning ned, de vil holde fast i.',
  compass_empty_copy: 'Det kan gøre både livet og relationerne tydeligere.',
  compass_empty_cta: 'Skriv Mit kompas',
  compass_help_primary: 'Skriv det, som det er for dig.',
  compass_label_pressure_pattern: 'Det der trækker mig ud af kurs',
  compass_nav_pressure_pattern: 'Ud af kurs',
  compass_help_pressure_pattern: 'Hvad får dig typisk til at miste retning?',
  compass_placeholder_pressure_pattern: 'Når jeg hellere vil være likt end ærlig.',
  compass_label_anchor_statement: 'Det som ikke er til forhandling for mig',
  compass_nav_anchor_statement: 'Ikke til forhandling',
  compass_help_anchor_statement: 'Det jeg ikke går på kompromis med.',
  compass_placeholder_anchor_statement: 'Jeg lyver ikke for mig selv.',
  compass_label_choice_question: 'Spørgsmålet der holder mig på kurs',
  compass_nav_choice_question: 'Mit spørgsmål',
  compass_help_choice_question: 'Et spørgsmål før vigtige valg.',
  compass_placeholder_choice_question: 'Er dette sandt, eller bare trygt?',
  compass_label_known_for: 'Sådan mærker du, at jeg er ude af kurs',
  compass_nav_known_for: 'Sådan mærker du det',
  compass_help_known_for: 'Hvad andre kan lægge mærke til.',
  compass_placeholder_known_for: 'Jeg bliver stille og trækker mig væk.',
  compass_label_growth_edge: 'Sådan finder jeg tilbage',
  compass_nav_growth_edge: 'Sådan finder jeg tilbage',
  compass_help_growth_edge: 'Hvad hjælper dig tilbage i retning?',
  compass_placeholder_growth_edge: 'Jeg har brug for ro og én ærlig samtale.',
  compass_label_visibility: 'Synlighed',
  compass_visibility_self_only: 'Kun mig',
  compass_visibility_moons: 'Måner',
  compass_visibility_family_friends: 'Familie og venner',
  compass_visibility_public: 'Offentlig',
  compass_visibility_shown_for: 'Synlig for: {visibility}',
  compass_visibility_owner_hint:
    'Sådan vises dit kompas for andre ud fra den synlighed, du har valgt.',
  compass_visibility_reason_family_friends:
    'Du ser dette, fordi du er registreret som familie eller ven.',
  compass_visibility_reason_moons: 'Du ser dette, fordi du er registreret som måne.',
  compass_visibility_reason_public: 'Du ser dette, fordi kompasset er delt offentligt.',
  compass_visibility_reason_default: 'Synligheden styres af ejeren.',
  compass_safety_hint: 'Dit kompas kan ændre sig, når livet ændrer sig.',
  compass_share_nudge: 'Vil du dele dit kompas med nære?',
  compass_share_nudge_moons: 'Del med måner',
  compass_share_nudge_family: 'Del med familie og venner',
  compass_share_nudge_public: 'Del offentligt',
  compass_step_indicator: 'Felt {current} af {total}',
  compass_step_counter: '{current}/{total}',
  compass_summary_title: 'Sådan holder jeg kurs',
  compass_prev: 'Forrige',
  compass_prev_alt: '← Forrige',
  compass_prev_to: '← Til {label}',
  compass_next: 'Videre',
  compass_next_alt: 'Næste →',
  compass_next_to: 'Til {label} →',
  compass_save: 'Gem',
  compass_saving: 'Gemmer...',
  compass_saved: 'Gemt',
  compass_save_error: 'Kunne ikke gemme lige nu.',
  compass_signal_cta: 'Tak fordi du delte',
  compass_signal_sent: 'Tegn sendt',
  compass_signal_sent_to: 'Tak sendt til {name}',
  compass_signal_toast_sent: 'Tak sendt.',
  compass_signal_error: 'Kunne ikke sende tak lige nu.',
  compass_signal_hint: 'En stille tak for at de delte deres kompas. Det vises ikke offentligt.',
  compass_signal_sent_hint: 'Det vises kun for {name}.',
  compass_signal_guest_hint: 'Log ind for at lade dem vide, at du så dette.',
  compass_signal_guest_cta: 'Log ind',
  compass_can_change: 'Du kan ændre dette når som helst.',
  compass_shared_none: 'Intet kompas delt endnu.',
  my_light_profile_cancel: 'Luk',
  my_light_profile_save: 'Gem',
  my_light_about_title: 'Om mig',
  conversation_starters_tab_self: 'Spørg mig om',
  conversation_starters_tab_other: 'Spørg {name}',
  conversation_starters_title_self: 'Spørg mig om',
  conversation_starters_title_other: 'Spørg {name}',
  conversation_starters_subtitle: 'Nogle samtaler behøver kun et sted at begynde.',
  conversation_starters_placeholder: 'Skriv noget andre gerne må spørge dig om',
  conversation_starters_suggestion_1: 'hvorfor jeg',
  conversation_starters_suggestion_2: 'hvordan jeg',
  conversation_starters_suggestion_3: 'hvad jeg lærte da',
  conversation_starters_suggestion_4: 'hvad der fik mig til at',
  conversation_starters_visibility_label: 'Hvem kan se dette?',
  conversation_starters_visibility_everyone: 'Alle',
  conversation_starters_visibility_moons: 'Måner',
  conversation_starters_visibility_family_friends: 'Familie og venner',
  conversation_starters_visibility_self_only: 'Kun mig',
  conversation_starters_add: 'Tilføj',
  conversation_starters_ask: 'Spørg {name}',
  conversation_starters_chat_draft: 'Hej {name}. Du skriver, at jeg kan spørge dig om »{starter}«.',
  conversation_starters_empty: 'Tilføj noget der kan åbne en god samtale.',
  conversation_starters_save_error: 'Kunne ikke gemme samtaleindgangen lige nu.',
  conversation_starters_delete_error: 'Kunne ikke slette samtaleindgangen lige nu.',
  conversation_starters_chat_error: 'Kunne ikke åbne samtalen lige nu.',
  day_title: 'Dagen',
  day_subtitle: 'Noget at tænke over, nogen at forstå og noget at bevare.',
  day_reflection_label: 'En tanke for dagen',
  day_reflection_1: 'Hvad har du med tiden fået en anden forståelse af?',
  day_reflection_2: 'Hvilket spørgsmål følger dig lige nu?',
  day_reflection_3: 'Hvad ville du ønske, at flere mennesker var nysgerrige på?',
  day_reflection_4: 'Hvad har et andet menneske lært dig uden at vide det?',
  day_reflection_5: 'Hvad betyder nærhed for dig i dag?',
  day_reflection_action: 'Gå til Skab Gnist',
  day_connection_label: 'Forstå sammen',
  day_connection_title: '{name} har delt noget, de ønsker at forstå sammen med andre.',
  day_connection_empty_title: 'Har du noget, du ønsker at forstå sammen med andre?',
  day_connection_empty_text:
    'Del det med egne ord og vælg, om Netgrav må hjælpe nye mennesker med at finde det.',
  day_connection_action: 'Læs og forstå sammen',
  day_connection_empty_action: 'Del med egne ord',
  day_preserve_label: 'Bevar',
  day_preserve_title: 'Findes der et billede med en historie, som kun du kender?',
  day_preserve_action: 'Gå til dine grave',
  own_words_discovery_title: 'Lad Netgrav knytte mig til nye mennesker',
  own_words_discovery_help:
    'Disse ord kan vises i Dagen for personer, du ikke kender. Du kan slå det fra når som helst.',
  my_light_about_subtitle: 'Et par ord om mig, sådan som livet føles nu.',
  my_light_questions_title: 'Tre spørgsmål',
  my_light_question_1: 'Hvad er vigtigt for mig i livet lige nu?',
  my_light_question_2: 'Hvad giver mig ro, mening eller energi i hverdagen?',
  my_light_question_3: 'Hvad er jeg i færd med at lære om mig selv?',
  spark_energy_tooltip: 'Din Gnist gør verden til et bedre sted.',
  grave_support_title: 'Hvad støtter denne grav?',
  grave_support_intro: 'Hver Netgrav er en del af noget større.',
  grave_support_body:
    'Denne grav støtter End Of Time Center – et videnscenter med én radikal vision: En verden uden død.',
  grave_support_help:
    'Sammen søger vi svar på hvorfor vi dør, og hvordan indsigt fra døden kan hjælpe os med at leve dybere og mere omsorgsfuldt – for os selv og hinanden.',
  grave_support_read_more: 'Læs mere om End Of Time Center.',
  end_of_time_center_title: 'End Of Time Center',
  end_of_time_center_intro:
    'Netgrav er det første produkt fra The End Of Time Corporation. Vi planlægger at etablere End Of Time Center – et videnscenter for forskning i liv og død, med et radikalt mål: At forstå døden og skabe en fremtid hvor ingen behøver en grav.',
  end_of_time_center_body:
    'Her vil forskere, visionære og problemløsere samles for at udvikle viden, løsninger og nye perspektiver på livets største spørgsmål. Sammen søger vi indsigt og inspiration, der kan gøre verden tryggere, varmere – og måske lidt mere evig.',
  end_of_time_center_close: 'Luk',
  about_this_grave: 'Om denne grav',
  my_light: 'Mit Lys',
  relation_confirmation_label: 'Auto-bekræft relation',
  auto_confirm_on: 'Automatisk',
  auto_confirm_off: 'Kræver godkendelse',
  relation_requests: 'Relationsanmodninger',
  connection_request_sent_info:
    'Din forbindelsesanmodning er sendt til ejeren af {graveName}. Når den er godkendt, vises graven under dine tilknyttede grave.',
  connection_request_sent: 'Forbindelsesanmodning sendt.',
  connection_created_unverified:
    'Gravforbindelsen blev oprettet uden bekræftelse fra en gravforvalter.',
  connection_request_failed: 'Kunne ikke sende forbindelsesanmodning. Prøv igen senere.',
  linked_grave_unverified_status: 'Ikke bekræftet af en gravforvalter',
  grave_already_connected: '{graveName} is already connected',
  is_grave_already_connected: 'Is this grave already connected?',
  take_grave_ownership: 'Vil du være ejer af denne grav?',
  grave_privacy_public:
    'Denne grav er offentlig. Alle kan se og interagere med offentligt indhold.',
  grave_privacy_private:
    'Denne grav er privat. Kun inviterede brugere kan se indholdet. Andre kan ikke se noget.',
  grave_privacy_relatives:
    'Denne grav er indstillet til pårørende. Pårørende kan se både private og offentlige data. Andre ser kun offentligt indhold.',
  please_fill_all_fields: 'Udfyld venligst alle krævede felter',
  grave_invitations: 'Grav invitationer',
  'relationships.manageInvites': 'Invitér familie og venner',
  invite_you_as: 'inviterer dig som',
  grave_invitation: 'Grav invitation',
  grave_invitations_not_found_title: 'Ingen invitationer fundet',
  grave_invitations_not_found_subtile:
    'Du har ikke modtaget nogen gravinvitationer endnu. Når nogen inviterer dig, ser du dem her.',
  invited_you_to_grave: '{name} inviterede dig til graven',
  search_by_name: 'Søg efter navn',
  confirm_delete_linked_grave_message:
    'Dette fjerner koblingen til denne grav. Du kan koble graven til igen senere.',
  search_grave_placeholder: 'Søg efter navn',
  search_open: 'Åbn søgning',
  search_open_full: 'Søg',
  search_submit: 'Søg',
  clear_search: 'Ryd søgning',
  close_search: 'Luk søgning',
  search_grave_heading: 'Find graven du leder efter',
  search_grave_intro: 'Søg efter navn, eller filtrer videre.',
  search_all_heading: 'Find mennesker og grave',
  search_all_intro: 'Søg efter et menneske eller en grav ved navn.',
  search_all_placeholder: 'Søg efter mennesker og grave',
  search_people_heading: 'Find personen, du leder efter',
  search_people_intro: 'Søg efter navn for at finde mennesker.',
  search_people_placeholder: 'Søg efter mennesker',
  search_grave_guest_cta_title: 'Når du finder den rigtige grav',
  search_grave_guest_cta_body: 'kan du knytte dig til den, efterlade et tegn og følge op over tid.',
  search_grave_guest_cta_button: 'Opret konto',
  search_grave_loading_title: 'Vi henter graven...',
  search_grave_loading_subtitle: 'Dette tager normalt under et sekund.',
  search_all_loading_title: 'Vi henter resultaterne...',
  search_all_loading_subtitle: 'Dette tager normalt under et sekund.',
  search_people_loading_title: 'Vi henter medlemmerne...',
  search_people_loading_subtitle: 'Dette tager normalt under et sekund.',
  search_grave_none_subtext:
    'Prøv et andet navn eller søg med færre bogstaver. Du kan også afgrænse resultaterne med kommune og kirkegård.',
  search_grave_none_text: 'Ingen resultater for',
  search: 'Søg',
  search_grave_perfect_matches: 'Kunne dette være den, du leder efter?',
  search_grave_filter_heading: 'Filtrer efter land, kommune og kirkegård',
  search_grave_show_filters: 'Vis flere søgemuligheder',
  search_grave_hide_filters: 'Skjul søgemuligheder',
  search_grave_image_heading: 'Søg efter grave for at komme i gang.',
  search_grave_image_subtitle: 'Hvem søger du i dag?',
  search_grave_search_for: 'Resultat for',
  search_grave_no_relation_hint:
    'Du kan besøge graven nu. Når du vælger relation, bliver den en del af dit rum her.',
  search_grave_visit_cta: 'Besøg graven',
  grave_invitation_email: 'E-mailadresse',
  grave_invitation_email_placeholder: 'Skriv e-mailadresse',
  grave_invitation_email_required: 'Tilføj e-mail.',
  grave_invitation_email_required_validation: 'Indtast en gyldig e-mail',
  grave_invitation_invited_person_name: 'Navn',
  grave_invitation_invited_person_name_placeholder: 'Skriv navn',
  grave_invitation_name_required: 'Tilføj navn.',
  grave_invitation_relation_to_grave: 'Jeres forhold',
  grave_invitation_relation_to_grave_modal: 'Den inviteredes relation til {graveName}',
  grave_invitation_relation_to_grave_help: 'Sæt forholdet som den inviterede person vil se det.',
  grave_invitation_relation_required: 'Vælg relation.',
  grave_invitation_select_relationship: 'Vælg hvordan I er knyttet sammen',
  grave_invitation_select_relationship_short: 'Vælg relation',
  grave_invitation_relation_to_person: 'Sådan ser de {graveName}',
  grave_invitation_relation_to_person_modal: '{graveName}s relation til den inviterede',
  grave_invitation_relation_to_person_help: 'Dette vises fra den inviterede persons perspektiv.',
  grave_invitation_select_reciprocal: 'Vælg relation (f.eks. far eller søskende)',
  grave_invitation_direction_required: 'Vælg relationsretning.',
  grave_invitation_administrator_access: 'Administratoradgang',
  grave_invitation_role_required: 'Vælg rolle.',
  grave_invitation_administrator: 'Administrator',
  grave_invitation_normal: 'Normal',
  anniversary_create_name: 'Navn',
  anniversary_create_placeholder_name: 'Indtast navn',
  anniversary_create_date_time: 'Dato',
  anniversary_create_name_required: 'Indtast navn',
  anniversary_create_date_time_required: 'Vælg dato',
  anniversary_create_date_hint: 'Kan ændres senere.',
  anniversaries_create_title: 'Tilføj mærkedag',
  anniversaries_create_hint: 'Til samling, besøg eller en dag der betyder noget for jer.',
  spark_create_modal_category: 'Gniste kategori:',
  spark_suggestions_label: 'Lidt inspiration:',
  spark_category_question: 'spørgsmål',
  spark_category_insight: 'indsigt',
  spark_category_experience: 'oplevelse',
  spark_category_discovery: 'opdagelse',
  spark_category_emotion: 'følelse',
  spark_category_value: 'værdi',
  spark_category_energy: 'energi',
  spark_category_intention: 'intention',
  spark_category_Story: 'Fortælling',
  spark_category_Feeling: 'Følelse',
  edit_spark: 'Rediger Gnist',
  share_spark: 'Del Gnist',
  extinguish_park: 'Sluk Gnist',
  spark_info_title: 'Hvad er min Gnist?',
  spark_info_intro:
    'En Gnist begynder i dig. Det kan være en tanke, et spørgsmål, en erfaring eller noget, der får dig til at stoppe op og mærke efter. Når du deler den, kan den vække refleksion, nærhed eller handling hos andre.',
  spark_examples_title: 'Eksempler på en Gnist',
  spark_form_info:
    'Vælg formen på din Gnist. Så viser du, hvordan du ønsker at dele din sandhed – som et spørgsmål, en fortælling, en indsigt, en følelse eller en intention.',
  spark_example_question: 'Et spørgsmål du undrer dig over.',
  spark_example_insight: 'En indsigt du har fået.',
  spark_example_experience: 'En oplevelse der rørte dig.',
  spark_example_value: 'En værdi du vil fremhæve.',
  spark_why_title: 'Hvorfor lave en Gnist?',
  spark_why_inspire: 'For at inspirere andre.',
  spark_why_express: 'For at sætte ord på det du tænker og føler.',
  spark_why_share: 'For at dele noget der betyder noget for dig.',
  spark_why_build: 'For at bygge et varmere og mere åbent fællesskab.',
  spark_how_title: 'Hvordan laver du en Gnist?',
  spark_how_step1: 'Skriv en tanke, et spørgsmål eller del en følelse.',
  spark_how_step2: 'Vælg kategori: Spørgsmål, Indsigt, Oplevelse, Værdi, Følelse, Energi.',
  spark_how_step3: 'Udgiv – og lad din gnist lyse for andre!',
  spark_helper_text:
    'Del din gnist – et spørgsmål, en tanke eller en følelse. Små eller store ord kan give lys til andre.',
  spark_show_inspirations: 'Bliv inspireret – hent et spørgsmål',
  spark_get_question: 'Hent et spørgsmål',
  spark_selected_question: 'Hvad er din Gnist?',
  spark_change_question: 'Skift spørgsmål',
  spark_optional_helper: 'Dit bidrag kan være en gnist for andre.',
  spark_textarea_label: 'Hvad vækker en Gnist i dig?',
  'sparks.media.limits': 'Op til 5 billeder eller videoer. Maks. 50 MB pr. fil.',
  'sparks.media.tooMany': 'Du kan tilføje op til 5 billeder eller videoer.',
  'sparks.media.tooLarge': '{name} er større end 50 MB.',
  'sparks.media.invalidType': '{name} er ikke et understøttet billed- eller videoformat.',
  spark_reflection_label: 'Tilføj dit svar på gnisten.',
  spark_menu_button: 'Gnistmenu',
  spark_share_button: 'Del',
  discard_draft: 'Læg kladde til side',
  share_life_event: 'Del livshændelse',
  delete_spark_title: 'Vil du slette denne Gnist?',
  share_link_spark: 'Gnist er klar til deling',
  public_view_description: 'Denne Gnist deles med alle',
  moons_only_description: 'Denne Gnist deles med dine måner',
  constellation_description: 'Denne Gnist deles med dit stjernebillede',
  memory_public_description: 'Alle, der besøger {name} på Netgrav, kan læse indlægget.',
  memory_private_description: 'Dit opslag er kun synligt for dig',
  memory_relatives_description:
    'Det du deler her er kun synligt for dem, der har en relation til {name} på Netgrav.',
  memory_privacy_label: 'Privatliv',
  memory_description_label: 'Ord du efterlader',
  file_remove_failed: 'Kunne ikke fjerne filen.',
  add_value: 'Tilføj egenskab',
  spark_feeling_Reflecting: 'Reflekterende',
  spark_feeling_Reflecting_description: 'Skab en Gnist om noget, du har tænkt meget over.',
  spark_feeling_Wonder: 'Forundring',
  spark_feeling_Wonder_description: 'Skab en Gnist med et spørgsmål du undrer dig over.',
  spark_feeling_Connection: 'Forbindelse',
  spark_feeling_Connection_description: 'Skab en Gnist som binder mennesker sammen.',
  spark_feeling_Freedom: 'Frihed',
  spark_feeling_Hopeful: 'Håb',
  spark_feeling_Gratitude: 'Taknemmelighed',
  spark_feeling_Peace: 'Fred',
  spark_feeling_Freedom_description:
    'Skab en Gnist fra dit frie, indre sted – et sted vi skal værne om. Del uden frygt for at sætte gang i forandring.',
  spark_feeling_tooltip: 'Vælg perspektiv',
  memory_reaction_name_Healed: 'Vis at det trøstede',
  memory_reaction_name_Love: 'Vis kærlighed',
  memory_reaction_name_Remembered: 'Jeg husker det også',
  memory_reaction_name_Cherished: 'Sæt pris på mindet',
  views: 'visninger',
  grave_memories: 'Graveminder',
  grave_memories_placeholder: 'Læg et par ord her.',
  grave_memories_message: 'Et sted at lægge ord, når du er på besøg.',
  grave_post_on: 'Offentliggjort på:',
  select_grave: 'Vælg grav',
  select_a_grave: 'venligst vælg en grav',
  user_values_title: 'Det ser vi i {name}',
  user_values_menu: 'Det ser jeg i {name}',
  profile_values_tab_self: 'Det andre har forstået om mig',
  profile_values_tab_self_mobile: 'Forstået om mig',
  profile_values_tab_other: 'Det andre har forstået om {name}',
  profile_values_tab_other_mobile: 'Om personen',
  profile_people_tab_self: 'Mine mennesker',
  profile_people_tab_self_mobile: 'Mennesker',
  compass_tab_mobile: 'Kompas',
  profile_people_tab_other: 'Menneskene omkring {name}',
  profile_people_tab_other_mobile: 'Mennesker',
  my_light_profile_label: 'Mit lys',
  my_light_profile_purpose_self:
    'Et sted for det, du står for, menneskene omkring dig og det, du ønsker at give videre.',
  my_light_profile_purpose_other:
    'Et sted for det, der kendetegner {name}, menneskene omkring og det, der skal leve videre.',
  intention_moment_section_title_self: 'Det andre har forstået om mig',
  intention_moment_section_title_other: 'Det andre har forstået om {name}',
  intention_moment_section_intro:
    'Øjeblikke andre lagde mærke til, og samtaler om hvordan de blev oplevet.',
  intention_moment_add: 'Del et øjeblik',
  intention_moment_empty_self_title: 'Ingen har delt sådan et øjeblik endnu',
  intention_moment_empty_self_message:
    'Her kan andre dele et øjeblik, de lagde mærke til, og du kan svare med dit perspektiv.',
  intention_moment_empty_other_title: 'Er der noget, du har lagt mærke til hos {name}?',
  intention_moment_empty_other_message: 'Del et konkret øjeblik og hvad det gjorde ved dig.',
  intention_moment_empty_readonly_title: 'Ingen har delt et sådant øjeblik om {name} endnu',
  intention_moment_empty_readonly_message:
    'Her får øjeblikke, som mennesker tæt på {name} vælger at dele, plads.',
  intention_moment_create_title: 'Noget du lagde mærke til hos {name}',
  intention_moment_edit_title: 'Rediger øjeblikket',
  intention_moment_observed_label: 'Hvad skete der?',
  intention_moment_observed_help:
    'Fortæl om en konkret handling, et valg eller et øjeblik med {name}.',
  intention_moment_observed_placeholder: 'Beskriv situationen, som du oplevede den.',
  intention_moment_impact_label: 'Hvad gjorde det ved dig?',
  intention_moment_impact_help: 'Hvad tænkte, følte eller gjorde du anderledes bagefter?',
  intention_moment_impact_placeholder: 'Det gjorde, at jeg ...',
  intention_moment_share: 'Del øjeblikket',
  intention_moment_update: 'Gem',
  intention_moment_save_error: 'Øjeblikket kunne ikke gemmes. Prøv igen.',
  intention_moment_card_impact: 'Det gjorde ved mig',
  intention_moment_legacy_value: 'Et ord der blev valgt: {value}',
  intention_moment_delete_title: 'Slet øjeblikket?',
  intention_moment_delete_message: 'Bidraget fjernes permanent.',
  intention_moment_hide_title: 'Fjern dette fra din profil?',
  intention_moment_hide_message: 'Bidraget fjernes. Ordene ændres ikke og tilskrives ikke dig.',
  intention_moment_hide_action: 'Fjern',
  intention_moment_creator_consent:
    'Jeg er tryg ved offentlig visning, hvis {name} også ønsker det.',
  intention_moment_private_until_both:
    'Kortet er privat mellem jer, indtil I begge udtrykkeligt vælger offentlig visning.',
  intention_moment_response_title: 'Sådan var det for dig',
  intention_moment_response_observer_label: 'Dette blev bemærket',
  intention_moment_response_prompt: 'Hvad var vigtigt for dig i situationen?',
  intention_moment_response_help:
    'Fortæl med dine egne ord. Det kan have været sammensat eller noget, du ikke før havde tænkt over.',
  intention_moment_response_placeholder: 'Sådan oplevede jeg det, der foregik i mig ...',
  intention_moment_subject_consent: 'Jeg ønsker, at hele kortet kan vises offentligt i Mit lys.',
  intention_moment_public_only_together:
    'Kortet bliver kun offentligt, fordi I begge har valgt det.',
  intention_moment_response_save: 'Del mit perspektiv',
  intention_moment_card_subject_response: 'Sådan var det for {name}',
  intention_moment_respond: 'Svar med dit perspektiv',
  intention_moment_edit_response: 'Rediger mit perspektiv',
  intention_moment_continue_chat: 'Fortsæt i chatten',
  intention_moment_chat_error: 'Kunne ikke åbne samtalen.',
  intention_moment_content_locked:
    'Når modtageren har svaret, kan ordene ovenfor ikke ændres. Du kan stadig ændre dit samtykke.',
  user_values_add_cta: 'Sig noget, du ser',
  user_values_empty_title: 'Tilføj egenskaberne, der viser hvem {firstName} er.',
  user_values_empty_message:
    'Del hvad der betyder mest for {name}, så andre ved, hvordan de kan støtte.',
  user_values_empty_self_title: 'Det andre ser i dig',
  user_values_empty_self_message: 'Når nogen deler det, de ser i dig, vises det her.',
  user_values_modal_title: 'Hvad ser du i {name}?',
  user_values_modal_edit_title: 'Rediger egenskab',
  user_values_modal_heading: 'Vælg en egenskab, du genkender, og fortæl hvorfor.',
  user_values_selected_label: 'Jeg ser dette i {name}',
  user_values_selected_message: 'Hvad får dig til at vælge “{personality}”?',
  user_values_placeholder: 'Skriv nogle ord om det, du har set eller oplevet.',
  user_values_create_cta: 'Del',
  user_values_update_cta: 'Del',
  user_values_privacy_public_description: 'Synligt for alle, der besøger {name}s side.',
  user_values_privacy_private_description: 'Kun du og {name} ser denne egenskab.',
  user_values_privacy_relatives_description:
    'Personer, du inviterer til at passe på {name}, kan se denne egenskab.',
  gift_from: 'Tændte et lys',
  grave_values: 'Ord om {graveName}',
  grave_values_fallback: 'Ord om',
  grave_values_load_failed: 'Ordene kunne ikke hentes lige nu',
  grave_values_load_failed_description: 'Prøv igen. Det, der allerede er delt, er stadig gemt.',
  grave_values_options_load_failed: 'Egenskaberne kunne ikke hentes',
  grave_values_options_load_failed_description: 'Prøv igen, før du deler dine ord.',
  grave_values_privacy_label: 'Hvem kan se dette?',
  grave_values_created: 'Egenskaben er tilføjet.',
  grave_values_updated: 'Egenskaben er opdateret.',
  grave_values_deleted: 'Egenskaben er fjernet.',
  grave_values_save_failed: 'Egenskaben kunne ikke gemmes. Prøv igen.',
  the_value_archive: 'Egenskaber',
  edit_value_archive: 'Rediger egenskab',
  create_value_archive: 'Opret egenskab',
  update_value_archive: 'Opdater egenskab',
  value_archive_title: 'Vælg en egenskab og tilføj historie',
  value_archive_selected: 'En egenskab, der beskriver {graveName}',
  value_archive_selected_message:
    'Du husker {graveName} som {personality}. Del nogle ord, der viser det.',
  no_suggestions: 'Ingen forslag tilgængelige',
  value_archive_placeholder: 'Skriv nogle ord, der peger på egenskaben',
  select_personality_warning: 'Vælg en egenskab.',
  enter_description_warning: 'Husk at tilføje nogle ord, der peger på egenskaben.',
  grave_values_empty_primary: 'Ord og små historier om hvem {firstName} var for andre.',
  grave_values_empty_secondary: 'Knyt dig til graven for at dele dine ord om {firstName}.',
  grave_values_empty_cta: 'Knyt dig til {firstName}',
  no_values_added: '{firstName}s historie rummer mere.',
  add_values_message:
    'Egenskaber er ord, der beskriver hvordan personen var at møde – det som satte spor hos andre.',
  confirm_delete_value_message:
    'Dette fjerner egenskaben fra dette sted. Du kan tilføje den igen senere.',
  confirm_delete_product_message: 'Dette fjerner produktet. Du kan tilføje produktet igen senere.',
  added_personality_value: 'tilføjede',
  create_grave: 'Opret grav',
  create_grave_mode_label: 'Hvad vil du oprette?',
  create_grave_mode_grave: 'Ny grav',
  create_grave_mode_with_ceremony: 'Ny grav med dødsannonce',
  create_grave_mode_with_ceremony_mobile: 'Med dødsannonce',
  create_grave_mode_with_ceremony_help:
    'Du kan tilføje det vigtigste nu. Tid og sted kan udfyldes senere.',
  create_grave_ceremony_accuracy_confirm_label:
    'Jeg bekræfter, at oplysningerne er korrekte så langt, jeg ved.',
  create_grave_ceremony_confirm_required: 'Bekræft, at oplysningerne er korrekte så langt, du ved.',
  create_grave_death_notice_section: 'Dødsannonce',
  create_grave_ceremony_section: 'Ceremoni',
  create_grave_ceremony_message_label: 'Besked til familie og venner',
  create_grave_ceremony_message_placeholder: 'Skriv en kort besked.',
  create_grave_ceremony_place_of_death_label: 'Hvor døde personen',
  create_grave_ceremony_place_of_death_placeholder: 'fx hjemme, på plejehjem eller hospital',
  create_grave_ceremony_timing_pending: 'Tid og sted er ikke fastsat endnu',
  create_grave_ceremony_timing_pending_help: 'Du kan opdatere dette senere på graven.',
  create_grave_ceremony_funeral_date_label: 'Ceremoni (dato)',
  create_grave_ceremony_funeral_time_label: 'Ceremoni (tid)',
  create_grave_ceremony_funeral_time_placeholder: 'fx 12:00',
  create_grave_ceremony_funeral_at_label: 'Ceremoni (dato og tid)',
  create_grave_ceremony_funeral_venue_label: 'Sted',
  create_grave_optional_field_help: 'Valgfri',
  create_grave_ceremony_funeral_venue_placeholder: 'fx Lade kirke',
  create_grave_any_proof: 'Har du dokumenter til at bekræfte dødsfaldet?',
  create_grave_validation_name_required: 'Tilføj navn.',
  create_grave_validation_gender_required: 'Vælg køn.',
  create_grave_validation_birthday_required: 'Vælg fødselsdato.',
  create_grave_validation_death_date_required: 'Vælg dødsdato.',
  create_grave_validation_country_required: 'Vælg land.',
  create_grave_validation_municipality_required: 'Vælg kommune.',
  create_grave_validation_cemetery_required: 'Vælg kirkegård.',
  create_grave_validation_relation_required: 'Vælg relation.',
  create_grave_validation_reciprocal_relation_required: 'Vælg gensidig relation.',
  create_grave_validation_reason_required: 'Vælg dødsårsag.',
  create_grave_validation_other_reason_required: 'Vælg anden årsag.',
  create_grave_select_document_heading: 'Vælg dokument',
  create_grave_select_document_message: 'Vælg dokumentet, du vil uploade, og accepter vilkårene',
  spark_feeling: 'Vælg perspektiv',
  added_spark_feeling_Reflecting: 'skaber gnist med refleksion',
  added_spark_feeling_Wonder: 'skaber gnist med forundring',
  added_spark_feeling_Connection: 'skaber gnist med forbindelse',
  added_spark_feeling_Freedom: 'skaber gnist med frihed',
  added_spark_feeling_Hopeful: 'skaber gnist med håb',
  added_spark_feeling_Gratitude: 'skaber gnist med taknemmelighed',
  added_spark_feeling_Peace: 'skaber gnist med fred',
  added_reflection_feeling_Reflecting: 'reflekterer med refleksion',
  added_reflection_feeling_Wonder: 'reflekterer med forundring',
  added_reflection_feeling_Connection: 'reflekterer med forbindelse',
  added_reflection_feeling_Freedom: 'reflekterer med frihed',
  added_reflection_feeling_Hopeful: 'reflekterer med håb',
  added_reflection_feeling_Gratitude: 'reflekterer med taknemmelighed',
  added_reflection_feeling_Peace: 'reflekterer med fred',
  spark_reflections_header: 'Refleksioner',
  spark_add_reflection: 'Tilføj refleksion',
  spark_reflections_empty: 'Bliv den første til at tilføje en refleksion.',
  spark_reflections_count: '{count, plural, one {# refleksion} other {# refleksioner}}',
  spark_reflectors_count: '{count, plural, one {# person} other {# personer}}',
  spark_reflecting_on: 'Reflekterer over',
  spark_reflection_feeling: 'Tilstand: {state}',
  spark_original_label: 'Oprindelig gnist',
  spark_reflection_context_label: 'Refleksion',
  spark_unknown_user: 'Nogen',
  spark_reactions_empty: 'Ingen reaktioner for dette udvalg endnu.',
  memory_feeling_Remembering: 'Husker',
  memory_feeling_Remembering_description:
    'Genoplev gode øjeblikke og historier, der holder mindet i live.',
  memory_feeling_Honoring: 'Sætter pris på',
  memory_feeling_Honoring_description:
    'Udtryk taknemmelighed og anerkend de værdier og spor, de efterlod.',
  memory_feeling_Reflecting: 'Reflekterer',
  memory_feeling_Reflecting_description:
    'Tag en pause for at mærke, hvad deres liv og nærvær betyder for dig.',
  memory_feeling_Thankful: 'Taknemmelig',
  memory_feeling_Thankful_description:
    'Del, hvad du er taknemmelig for – deres kærlighed, visdom eller minder du bærer med dig.',
  memory_feeling_Missing: 'Savner',
  memory_feeling_Missing_description: 'Sæt ord på savnet og det tomrum, deres fravær efterlader.',
  memory_feeling_Forgiving: 'Tilgiver',
  memory_feeling_Forgiving_description: 'Vælger at tilgive og give slip.',
  added_memory_feeling_Remembering: 'husker {graveName}',
  added_memory_feeling_Honoring: 'sætter pris på {graveName}',
  added_memory_feeling_Reflecting: 'reflekterer over {graveName}',
  added_memory_feeling_Thankful: 'er taknemmelig for {graveName}',
  added_memory_feeling_Missing: 'savner {graveName}',
  added_memory_feeling_Forgiving: 'tilgiver {graveName}',
  view_header_desktop: 'Desktop forhåndsvisning',
  view_header_mobile: 'Mobil forhåndsvisning',
  memory_posts: 'Mindeposter',
  view_deceased_name: 'Gravens navn',
  grave_duplicate_title: 'Denne grav findes allerede',
  grave_duplicate_message:
    'En grav med samme navn og detaljer findes allerede på Netgrav. Vi opretter ikke en ny grav, når vi finder et sikkert match. Besøg den eksisterende for at knytte dig til den.',
  grave_duplicate_button: 'Gå til eksisterende grav',
  create_grave_pending_review_notice:
    'Graven er sendt til Netgrav til godkendelse og er ikke offentligt synlig endnu.',
  create_grave_create_error: 'Graven kunne ikke oprettes. Kontrollér oplysningerne og prøv igen.',
  create_grave_potential_duplicates_title: 'Vi fandt en lignende grav',
  create_grave_potential_duplicates_message:
    'Tjek om en af disse er den samme person, før du opretter en ny grav.',
  create_grave_potential_duplicates_button: 'Gå til graven',
  grave_create_invalid_date_title: 'Ugyldig dato­række',
  grave_create_invalid_date_message:
    'Dødsdatoen kan ikke være før fødselsdatoen. Kontrollér datoerne og prøv igen.',
  memory_feeling_tooltip: 'Følelse',
  memory_feeling: 'Følelse',
  conscious_verified_badge:
    'Du modtager et verificeret badge – et tegn på tillid, nærvær og omsorg i fællesskabet',
  conscious_supports_free_graves:
    'Du hjælper med at holde alle grave åbne og passet på, så alle kan mindes deres kære.',
  conscious_ad_free_safe_space:
    'Du støtter et sikkert, reklamefrit rum baseret på tilhørsforhold og ærlighed.',
  conscious_supports_community_and_mission:
    'Dit bidrag støtter Netgrav-fællesskabet og End Of Time-missionen nu og fremover.',
  partner_page_title: 'Partnere – The End of Time',
  partner_page_mission: 'Støt minder, taknemmelighed og sandhed.',
  partner_welcome_title: 'Velkommen!',
  partner_welcome_message:
    'Bliv partner. Støt minder, taknemmelighed og sandhed for familier og samfund.',
  partner_company_name: 'Firmanavn',
  partner_company_website: 'Virksomhedswebsted',
  partner_company_mission: 'Kort missions­udsagn',
  partner_company_logo: 'Logo',
  partner_continue: 'Fortsæt',
  partner_choose_context_title: 'Vælg hvor du vil støtte',
  partner_appears_memory_album: 'Vises ved siden af familiernes mindealbum.',
  partner_appears_value_archive: 'Taknemmelighed er mulig takket være vores partnere.',
  partner_appears_funeral_room: 'I partnerskab med dig for erindring.',
  partner_appears_anniversary_calendar: 'Fejring af minder med partneres hjælp.',
  partner_appears_groups: 'Fællesskabsstøtte takket være partnere.',
  partner_appears_store: 'Bragt til dig med omsorg af partnere.',
  partner_upload_or_generate_title: 'Upload eller generer din annonce',
  partner_upload_image_video: 'Upload billede/video',
  partner_select_theme: 'Vælg tema',
  partner_select_theme_remembrance: 'Erindring',
  partner_select_theme_gratitude: 'Taknemmelighed',
  partner_select_theme_support: 'Støtte',
  partner_or: 'Eller',
  partner_describe_generate:
    "Beskriv, hvad du vil generere (f.eks. 'et blidt stearinlys med rolig baggrund')",
  partner_generate_ai: 'Generer med AI',
  partner_upload_success: 'Kreativt indhold uploadet!',
  partner_generate_success: 'Genereret med AI!',
  partner_write_message_title: 'Skriv din besked',
  partner_write_message_placeholder: 'Skriv en varm, støttende besked…',
  partner_make_warmer: 'Gør det varmere / poetisk',
  partner_live_preview: 'Live forhåndsvisning',
  partner_message_preview_placeholder: 'Din besked vises her.',
  partner_set_commitment_title: 'Angiv dit engagement',
  partner_commitment_cpm: 'CPM (pr. 1 000 visninger)',
  partner_commitment_cpm_desc: '~6 200 visninger/måned, 140 kr CPM',
  partner_commitment_cpc: 'CPC (pr. klik)',
  partner_commitment_cpc_desc: 'Betal kun for hvert klik',
  partner_commitment_flat: 'Fast månedlig sponsorat',
  partner_commitment_flat_desc: 'Fast pris, alt inkluderet',
  partner_campaign_summary: 'Din kampagnesammendrag',
  partner_estimated_monthly_reach: 'Anslået månedlig rækkevidde',
  partner_commitment: 'Engagement',
  partner_submit_review: 'Indsend til gennemgang',
  partner_status_thank_you: 'Tak! Dit partnerskab vil blive gennemgået inden for 24 timer.',
  partner_status_subtitle:
    'Du får en opdatering via e-mail, når det er godkendt. Du kan følge status på dit dashboard.',
  partner_go_to_dashboard: 'Gå til dashboard',
  partner_your_campaigns: 'Dine kampagner',
  partner_placement: 'Placering',
  partner_status: 'Status',
  partner_impressions: 'Visninger',
  partner_clicks: 'Klik',
  partner_actions: 'Handlinger',
  partner_view_company: 'Vis virksomhed',
  partner_sponsored: 'End Of Time Call',
  partner_call_cta: 'End Of Time Call',
  partner_supported_by: 'Støttet af ❤️ {count} bevidste medlemmer',
  partner_highlight_this_partner: 'Fremhæv denne partner',
  partner_about: 'Om',
  partner_partner_since: 'Partner siden: {date}',
  partner_causes_supported: 'Støttede sager:',
  partner_active_campaigns: 'Aktive kampagner:',
  partner_families_supported: 'Støttede familier',
  partner_testimonials: 'Testimonialer:',
  partner_total_highlights: 'Samlede fremhævninger',
  partner_see_support_helps: 'Se, hvordan din støtte hjælper',
  partner_share_impact: 'Del denne partners indvirkning',
  partner_invite_more_causes: 'Inviter denne partner til at støtte flere sager',
  partner_review_preview_title: 'Gennemse & Forhåndsvis',
  partner_review_ad_preview: 'Annonce­forhåndsvisning',
  partner_review_placement: 'Placering',
  partner_review_company: 'Virksomhed',
  partner_review_website: 'Websted',
  partner_review_mission: 'Mission',
  partner_review_billing: 'Fakturering',
  partner_confirm_submit: 'Bekræft & Indsend',
  partner_appears_key_memory_album: 'Mindebog',
  partner_appears_key_value_archive: 'Egenskaber',
  partner_appears_key_funeral_room: 'Begravelsesrum',
  partner_appears_key_anniversary_calendar: 'Mærkedagskalender',
  'settings.security.title': 'Sikkerhed',
  'settings.security.sessions.title': 'Hvor du er logget ind',
  'settings.security.sessions.device': 'Enhed',
  'settings.security.sessions.this_device': 'Denne enhed',
  'settings.security.sessions.last_active': 'Sidst aktiv',
  'settings.security.sessions.created': 'Oprettet',
  'settings.security.sessions.expires': 'Udløber',
  'settings.security.sessions.ip': 'IP',
  'settings.security.sessions.logout': 'Log ud',
  'settings.security.sessions.logout_all': 'Log ud af alle enheder',
  'settings.security.sessions.logout_others': 'Log ud af andre enheder',
  'security.alerts.reuse_detected.title': 'Vi afsluttede din session for at holde dig sikker',
  'security.alerts.reuse_detected.body':
    'Vi bemærkede et usædvanligt login. Vi loggede dig ud på alle enheder. Hvis det ikke var dig, skift venligst din adgangskode.',
  'gettingStarted.title': 'Velkommen',
  'gettingStarted.subtitle': 'Begynd med at søge på navnet for at finde graven.',
  'gettingStarted.search': 'Søg',
  'gettingStarted.search.placeholder': 'Søg på navn',
  'gettingStarted.addRelation': 'Tilføj person',
  'gettingStarted.explainer':
    'Angiv din relation for at få opdateringer, mærkedage og venlige påmindelser.',
  partner_appears_key_groups: 'Grupper/Fællesskab',
  partner_appears_key_store: 'Butik/Webshop',
  account_form_email_label: 'E-mail',
  account_form_email_placeholder: 'Indtast din e-mail',
  account_form_email_required: 'Angiv e-mail',
  account_form_email_invalid: 'Angiv en gyldig e-mailadresse',
  account_form_userName_label: 'Navn',
  account_form_userName_placeholder: 'Indtast dit navn',
  account_form_userName_required: 'Angiv dit navn',
  account_form_userName_invalid: 'Navnet skal indeholde mindst ét bogstav',
  account_form_gender_label: 'Køn',
  account_form_gender_placeholder: 'Vælg køn',
  account_form_gender_required: 'Vælg køn',
  account_form_gender_option_male: 'Mand',
  account_form_gender_option_female: 'Kvinde',
  account_form_gender_option_other: 'Andet',
  account_form_password_label: 'Adgangskode',
  account_form_password_placeholder: 'Indtast din adgangskode',
  account_form_password_required: 'Angiv adgangskode',
  account_form_password_min: 'Brug mindst 8 tegn.',
  account_form_password_max: 'Brug højst 128 tegn.',
  account_form_confirmPassword_label: 'Bekræft adgangskode',
  account_form_confirmPassword_placeholder: 'Bekræft din adgangskode',
  account_form_confirmPassword_required: 'Bekræft din adgangskode',
  account_form_confirmPassword_match: 'Adgangskoderne stemmer ikke overens',
  not_authorized: 'Du har ikke tilladelse',
  account_form_country_label: 'Land',
  account_form_country_placeholder: 'Vælg land',
  account_form_country_required: 'Vælg dit land',
  account_form_dateOfBirth_label: 'Fødselsdato',
  account_form_dateOfBirth_placeholder: 'Vælg dato',
  account_form_dateOfBirth_required: 'Vælg din fødselsdato',
  account_form_dateOfBirth_underage: 'Tilgængelig fra 13 år.',
  account_form_language_label: 'Sprog',
  account_form_language_placeholder: 'Vælg sprog',
  account_form_language_required: 'Vælg foretrukket sprog',
  language_english: 'Engelsk',
  language_norwegian: 'Norsk',
  language_danish: 'Dansk',
  language_swedish: 'Svensk',
  language_finnish: 'Finsk',
  account_form_checked_label: 'Jeg accepterer {termsLink}',
  account_form_checked_required: 'Acceptér for at fortsætte.',
  account_form_creating_account: 'Opretter konto...',
  account_form_submit: 'Opret konto',
  registration_too_many_attempts: 'For mange registreringsforsøg. Vent lidt, før du prøver igen.',
  registration_failed: 'Vi kunne ikke oprette kontoen. Prøv igen.',
  grave_tab: 'Søg',
  home_welcome: 'Tag graven i skyen med netgrav.dk.',
  home_subheading: 'Tilgængelig og nær i dit liv. Søg på navn for at komme i gang.',
  home_create_account: 'Opret konto',
  home_login: 'Log ind',
  home_terms: 'Ved at fortsætte accepterer du vores',
  footer_copyright: '© 2013–2026 Netgrav.dk.',
  footer_built_by: 'The End Of Time Corporation',
  footer_teotc_name: 'Netgrav udvikles og drives af The End of Time Corporation (TEOTC).',
  footer_intro_eyebrow: 'Netgrav — hvor kærligheden aldrig slutter.',
  footer_intro_body: 'Produkter og tjenester fra ét perspektiv — det, som består i al tid.',
  footer_col_nettgrav: 'Netgrav',
  footer_col_explore: 'Udforsk',
  footer_col_teotc: 'End of Time',
  footer_col_contact: 'Kontakt',
  footer_find_grave: 'Find en grav',
  footer_graves: 'Søg blandt alle grave',
  footer_about: 'Om Netgrav',
  footer_create_spark: 'Skab Gnisten',
  footer_my_light: 'Mit lys',
  footer_rooms: 'Rum',
  footer_partner: 'Partner',
  footer_how_it_works: 'Sådan fungerer Netgrav',
  footer_create_nettgrav: 'Opret en Netgrav',
  footer_about_teotc: 'Om TEOTC',
  footer_nettarv: 'Nettarv',
  footer_matvarebutikken: 'Matvarebutikken',
  footer_become_partner: 'Bliv partner',
  footer_privacy: 'Privatliv',
  footer_terms: 'Vilkår',
  footer_cookies: 'Cookies',
  footer_end_of_time_center: 'The End of Time Center',
  footer_end_of_time_chat: 'End Of Time Chat',
  my_light_info_title: 'Mit lys',
  my_light_info_intro: 'Et sted for det, der betyder mest for dig, i dit eget tempo.',
  my_light_info_body_1: 'Mit lys er din livsside i Netgrav.',
  my_light_info_body_2:
    'Her knytter du dig til mennesker, du holder af, bygger relationer over tid — og kan gøre det vigtigste tydeligt.',
  my_light_info_body_3: 'Det handler ikke om at dele mest.',
  my_light_info_body_4: 'Det handler om at være til stede.',
  my_light_info_section_what_you_can_do_title: 'Hvad du kan gøre i Mit lys',
  my_light_info_body_5: 'Du kan:',
  my_light_info_body_6: 'styrke relationerne til de mennesker, du holder af',
  my_light_info_body_7: 'dele ord og nærvær, der gør godt',
  my_light_info_body_8: '• sige gode ord til hinanden — mens vi lever',
  my_light_info_body_9: 'vælge Måner — de nærmeste, du stoler på',
  my_light_info_body_10: 'sætte retning med Mit kompas og gøre det vigtigste tydeligt i Efter mig',
  my_light_info_body_11: 'Mit lys rummer både livet nu — og retningen videre.',
  my_light_info_section_not_title: 'Hvad dette ikke er',
  my_light_info_body_12:
    'Mit lys er ikke et socialt netværk. Det handler ikke om tempo, opmærksomhed eller vækst.',
  my_light_info_body_13: 'Her kan det vigtigste deles med ro, nærhed og omtanke.',
  my_light_info_section_why_title: 'Hvorfor findes det?',
  my_light_info_body_14: 'Fordi mennesker har brug for hinanden.',
  my_light_info_body_15: 'Og fordi det er godt at sige det, der betyder noget — mens vi lever.',
  my_light_info_cta: 'Gå til Mit lys',
  'my_light_guest_preview.eyebrow': 'Til dig som gæst',
  'my_light_guest_preview.supporting': 'Her ser du, hvad Mit lys indeholder.',
  'my_light_guest_preview.primary_cta': 'Log ind til Mit lys',
  'my_light_guest_preview.secondary_cta': 'Opret konto',
  'my_light_guest_preview.panel_label': 'Det indeholder Mit lys',
  'my_light_guest_preview.modules_title': 'Sådan ser Mit lys ud',
  'my_light_guest_preview.modules_intro': 'Det her er de områder, du møder i Mit lys.',
  'my_light_guest_preview.card_about_title': 'Om mig',
  'my_light_guest_preview.card_about_body':
    'En kort introduktion, et par linjer om hvem du er, og tre spørgsmål, der fanger livet, som det føles nu.',
  'my_light_guest_preview.card_relations_title': 'De nære omkring dig',
  'my_light_guest_preview.card_relations_body':
    'Her ser du de nærmeste omkring dig, og hvem der har en særlig rolle, når noget betyder mest.',
  'my_light_guest_preview.card_compass_title': 'Mit kompas',
  'my_light_guest_preview.card_compass_body':
    'Her kan du sætte ord på, hvad der holder dig på kurs, hvad der betyder mest, og hvad andre bør forstå om dig.',
  'my_light_guest_preview.card_moons_title': 'Måner',
  'my_light_guest_preview.card_moons_body':
    'Måner er de nære omkring dig, som påvirker dit liv med nærhed, retning og tryghed.',
  'my_light_guest_preview.card_after_me_title': 'Efter mig',
  'my_light_guest_preview.card_after_me_body':
    'Efter mig er stedet, hvor du gør det vigtigste tydeligt for dem, du holder af.',
  'my_light_guest_preview.footer_title': 'Et personligt sted for relation og ansvar',
  'my_light_guest_preview.sample_name': 'Eksempelprofil',
  'my_light_guest_preview.sample_role': 'Lærer og forælder',
  'my_light_guest_preview.sample_bio':
    'Jeg prøver at give plads til ærlige samtaler, rolige morgener og de mennesker, jeg har brug for at være tæt på.',
  'my_light_guest_preview.answer_1': 'At værne om tiden med de mennesker, jeg elsker.',
  'my_light_guest_preview.answer_2': 'Gåture, stilhed og én sand samtale.',
  'my_light_guest_preview.connection_name_1': 'Anna Berg',
  'my_light_guest_preview.connection_role_1': 'Søster',
  'my_light_guest_preview.connection_name_2': 'Isak Berg',
  'my_light_guest_preview.connection_role_2': 'Familieven',
  'my_light_guest_preview.compass_value_1':
    'Jeg vil ikke miste forbindelsen til det, der betyder mest.',
  'my_light_guest_preview.compass_value_2': 'Skaber dette mere sandhed, eller bare mindre ubehag?',
  'my_light_guest_preview.moon_name_1': 'Liv',
  'my_light_guest_preview.moon_role_1': 'Nær ven',
  'my_light_guest_preview.moon_name_2': 'Maren',
  'my_light_guest_preview.moon_role_2': 'Datter',
  'my_light_guest_preview.moon_status': 'Måne',
  'my_light_guest_preview.after_me_status': 'Tydelig',
  'my_light_guest_preview.after_me_updated': 'Opdateret for nylig',
  'my_light_guest_preview.after_me_message':
    'Hvis noget sker, så lad det være enkelt, varmt og uden gætteri.',
  end_of_time_center_title: 'The End of Time Center',
  end_of_time_center_intro: 'Et arbejde, der begynder, hvor livet slutter.',
  end_of_time_center_body_1: 'En grav findes, fordi et menneske er dødt.',
  end_of_time_center_body_2:
    'Vi søger forståelse af, hvorfor liv slutter, og hvordan viden, indsigt og forskning kan bidrage til, at færre liv gør det i fremtiden.\nIkke gennem løfter, men gennem langsigtet arbejde.',
  end_of_time_center_section_1_title: 'Fra tab til handling',
  end_of_time_center_section_1_body_1:
    'De fleste stopper ved døden.\nThe End of Time Center begynder der.',
  end_of_time_center_section_1_body_2:
    'Når et menneske dør, opstår spørgsmål, som ikke kan besvares af minder alene. Her samles forskning, refleksion og udvikling med mål om at forstå livets sårbarhed og tidens rolle i sygdom, aldring og død.',
  end_of_time_center_section_1_body_3: 'Dette er ikke et mindearbejde.\nDet er et ansvar.',
  end_of_time_center_section_2_title: 'Graven som bro',
  end_of_time_center_section_2_body_1:
    'Gennem Netgrav bliver graven mere end et sted for stilhed.\nDen bliver en bro mellem det, der har været – og det, der kan blive.',
  end_of_time_center_section_2_body_2:
    'Handlinger knyttet til graven – lys, cirkler og tilstedeværelse – er forankret i The End of Time Center. På den måde får graven en retning videre, mod forståelse, sammenhæng og forskning i livets grænser.\nDette arbejde kaldes End of Time Care.',
  end_of_time_center_section_3_title: 'Et langsigtet arbejde',
  end_of_time_center_section_3_body_1:
    'The End of Time Center er et langsigtet initiativ under The End Of Time Corporation. Arbejdet er forankret i Norge og udvikles med respekt for livets kompleksitet og menneskets behov for mening.',
  end_of_time_center_section_3_body_2:
    'Dette er ikke et projekt, der skal skaleres hurtigt.\nDet er et arbejde, der skal stå over tid.',
  end_of_time_center_section_4_title: 'Derfor findes The End of Time Center',
  end_of_time_center_section_4_body_1:
    'Fordi et liv tog slut.\nDet blev til en grav.\nOg fordi det forpligter.',
  end_of_time_chat_title: 'End Of Time Chat',
  end_of_time_chat_intro: 'Samtaler der kan tåle stilhed',
  end_of_time_chat_beta_label: 'Beta-version',
  end_of_time_chat_beta_short:
    'Den grundlæggende krypteringsbeskyttelse er aktiv. Da dette er en beta, kan funktioner og dele af brugerfladen ændre sig.',
  end_of_time_chat_open_beta: 'Åbn beta-chatten',
  end_of_time_chat_explore_security: 'Sådan beskyttes dine samtaler',
  end_of_time_chat_security_eyebrow: 'Privat fra begyndelsen',
  end_of_time_chat_security_summary_title: 'Beskyttelsesstatus',
  end_of_time_chat_security_active: 'Aktiv',
  end_of_time_chat_security_note:
    'Dine samtaler er beskyttet med kryptering og andre sikkerhedsforanstaltninger, men ingen digital tjeneste kan garantere fuldstændig sikkerhed.',
  end_of_time_chat_beta_title: 'Klar til brug, stadig under forbedring',
  end_of_time_chat_beta_body:
    'End of Time Chat er nu tilgængelig som beta. Du kan møde ufærdige detaljer, mens vi forbedrer stabilitet, opkald, synkronisering og den samlede oplevelse.',
  end_of_time_chat_beta_point_1:
    'Funktioner og detaljer i brugerfladen kan ændre sig i beta-perioden.',
  end_of_time_chat_beta_point_2:
    'Midlertidige problemer med synkronisering eller opkaldsforbindelse kan forekomme.',
  end_of_time_chat_beta_point_3:
    'Brug ikke en beta-tjeneste til nødsituationer eller tidskritisk kommunikation.',
  end_of_time_chat_security_title: 'Bygget til at beskytte samtalen',
  end_of_time_chat_security_intro:
    'Kryptering er ikke et valgfrit tillæg. Det er en del af, hvordan beskeder, grupper og opkald er designet fra starten.',
  end_of_time_chat_e2ee_title: 'End-to-end-kryptering',
  end_of_time_chat_e2ee_body:
    'Samtalens indhold krypteres på deltagernes enheder. Netgrav transporterer krypterede data i stedet for en læsbar kopi af din samtale.',
  end_of_time_chat_pq_title: 'Hybrid post-kvantebeskyttelse',
  end_of_time_chat_pq_body:
    'Hybrid X-Wing-nøgleetablering kombinerer etableret kryptografi med post-kvantebeskyttelse. Det hjælper med at reducere risikoen for, at krypteret trafik gemmes i dag og dekrypteres af fremtidige kvantecomputere.',
  end_of_time_chat_mls_title: 'Sikker rotation af gruppenøgler',
  end_of_time_chat_mls_body:
    'Messaging Layer Security opdaterer gruppehemmeligheder, når medlemskab og samtaletilstand ændres, og hjælper med at begrænse virkningen af en kompromitteret nøgle over tid.',
  end_of_time_chat_cta_title: 'Et tryggere rum til samtaler, der betyder noget',
  end_of_time_chat_cta_body:
    'Brug betaen, fortæl os hvad der ikke fungerer som forventet, og hjælp os med at gøre privat kommunikation mere pålidelig.',
  end_of_time_chat_feedback: 'Rapportér et beta-problem',
  end_of_time_chat_body_1: 'Kommer snart',
  end_of_time_chat_body_2:
    'Nogle samtaler er for sårbare til det åbne. Andre er for sande til at forsvinde.',
  end_of_time_chat_body_3:
    'End of Time Chat er skabt for mennesker der ønsker et trygt rum for nære samtaler – hvor relationer kan leve videre med ærlighed, ømhed og tid.',
  end_of_time_chat_section_1_title: 'Et rum, ikke en strøm',
  end_of_time_chat_section_1_body_1:
    'Dette er ikke en social platform.\nDet er ikke et sted for synlighed, tempo eller præstation.',
  end_of_time_chat_section_1_body_2:
    'End of Time Chat er et lukket rum mellem mennesker som har valgt hinanden.\nSamtalerne får være det de er – uden publikum.',
  end_of_time_chat_section_2_title: 'Bygget for tryghed',
  end_of_time_chat_section_2_body_1:
    'Samtalerne er end-to-end-krypterede og bygget med sikkerhed som grundprincip. Det der deles, forbliver mellem dem det tilhører.',
  end_of_time_chat_section_2_body_2:
    'Teknologien er der af én grund:\nAt beskytte det menneskelige.',
  end_of_time_chat_section_3_title: 'Hvorfor End Of Time Chat findes',
  end_of_time_chat_section_3_body_1:
    'Fordi relationer ikke slutter når livet bliver svært.\nFordi nærhed har brug for rum der ikke udnytter sårbarhed.\nFordi nogle ord kun kan deles når det er trygt at gøre det.',
  end_of_time_chat_section_3_body_2:
    'End of Time Chat er også skabt til de samtaler man ønsker at have mens man lever.\nFor at kunne sige det man tror på.\nFor at vise hvad der er vigtigt.\nFor at være den der siger jeg elsker dig først.',
  end_of_time_chat_section_3_body_3:
    'Der er styrke i at være ægte.\nOgså når det ikke bliver mødt.\nOgså når det gør én sårbar.',
  end_of_time_chat_section_4_title: 'En del af Netgrav',
  end_of_time_chat_section_4_body_1:
    'End of Time Chat er udviklet som en del af Netgrav.\nEt sted for liv, relationer og nærvær – også efter tab.',
  end_of_time_chat_section_5_title: 'Et grundlæggende princip',
  end_of_time_chat_section_5_body_1:
    'End of Time Chat er ikke et produkt.\nDet er et rum der beskytter relationer.',
  about_nettgrav_title: 'Om Netgrav',
  about_nettgrav_intro:
    'Netgrav er skabt for nærhed både til dem, der er gravlagt, og til dem, der lever videre.',
  about_nettgrav_body_1:
    'Når døden indtræffer, opstår der ofte behov som en fysisk grav alene ikke kan rumme. Netgrav gør det muligt at være til stede også på nettet – på tværs af tid, afstand og livssituationer.',
  about_nettgrav_body_2:
    'En grav er mere end et sted. Den rummer et menneske, et levet liv og relationerne omkring. Netgrav er skabt til at give dette rum værdighed og varighed.',
  about_nettgrav_body_3:
    'Netgrav eksisterer uafhængigt af den fysiske grav. Selv om en grav ændres, flyttes eller genbruges, består det digitale sted som et varigt rum for nærhed og minder.',
  about_nettgrav_body_4:
    'Tjenesten er udviklet i Norge med fokus på varighed, respekt og menneskelig nærhed. Netgrav er støttet af offentlige innovationsmidler gennem Innovation Norway, og er i stor grad bygget med støtte fra familie og venner.',
  about_nettgrav_body_5:
    'Bag Netgrav står de samme mennesker som The End Of Time Corporation – et norsk, langsigtet arbejde for at skabe tjenester, der står i mødet med døden, tiden og menneskets behov for mening og sammenhæng.',
  create_spark_title: 'Skab Gnisten',
  create_spark_intro: 'Et rum for det, der er sandt for dig',
  create_spark_body_1: 'At stå ved det, man tror på, kan være en følelsesmæssig rejse.',
  create_spark_body_2:
    'Skab Gnisten giver plads til at sætte ord på det, der er sandt for dig – mens du lever.',
  create_spark_body_3: 'En gnist kan være en tanke, en værdi, en undren eller en refleksion.',
  create_spark_body_4: 'Noget, du ønsker at udtrykke, uden krav om facit eller respons.',
  create_spark_body_5:
    'At skabe en gnist handler ikke om at overbevise andre, men om at være ærlig i mødet med sig selv og verden omkring.',
  create_spark_body_6: 'I Netgrav findes både liv og minder.',
  create_spark_body_7: 'Gravene rummer historien. Gnister rummer det, der lever nu.',
  partner_title: 'Partner',
  partner_intro:
    'Netgrav samarbejder med partnere, der ønsker at bidrage til gode liv for mennesker og familier, som bruger Netgrav.',
  partner_body_1:
    'Samarbejde på Netgrav handler om at støtte mennesker i livets vigtige øjeblikke – med nærhed, omsorg og langsigtethed. Sammen ønsker vi at styrke følelsesmæssig og psykisk robusthed, og valg der giver mening over tid.',
  partner_body_2:
    'For organisationer og brands, der ønsker at bygge samfund gennem deling og generøsitet, findes vores partnerprogram i samarbejde med End of Time – et netværk der investerer ressourcer dér, hvor de behøves.',
  partner_cta: 'Bliv partner',
  how_it_works_title: 'Sådan fungerer Netgrav',
  how_it_works_intro: 'Netgrav er et sted for nærhed til dine mennesker og det, der betyder noget.',
  how_it_works_lead_1:
    'Et sted, der findes ved siden af den fysiske grav – og som består over tid.',
  how_it_works_lead_2: 'Denne side forklarer, hvordan Netgrav fungerer, og hvad du kan forvente.',
  how_it_works_section_1_title: 'Et sted ved siden af den fysiske grav',
  how_it_works_section_1_body_1: 'Den fysiske grav er et sted, man kan besøge.',
  how_it_works_section_1_body_2:
    'Netgrav gør det muligt at være til stede også på nettet, når afstand, tid eller livssituation gør det svært at komme dertil.',
  how_it_works_section_1_body_3: 'Netgrav er uafhængig af den fysiske gravs varighed.',
  how_it_works_section_1_body_4:
    'Selv om en grav ændres, flyttes eller genbruges, består Netgraven som et varigt sted for tilhørsforhold.',
  create_nettgrav_title: 'Opret en Netgrav',
  create_nettgrav_intro: 'En Netgrav kan oprettes når det er nødvendigt.',
  create_nettgrav_body_1:
    'For at oprette en Netgrav indtaster du navnet på den begravede og vælger kommune og kirkegård hvis dette er kendt.',
  create_nettgrav_body_2: 'Netgrav er ikke afhængig af den fysiske grav.',
  create_nettgrav_body_3: 'Den begravede er vores udgangspunkt – ikke stedet.',
  create_nettgrav_section_create_title: 'Opret grav på nettet',
  create_nettgrav_section_missing_title: 'Når kommune eller kirkegård mangler',
  create_nettgrav_missing_body_1:
    'Netgrav vil over tid ikke fokusere på at registrere alle kommuner og kirkegårde.',
  create_nettgrav_missing_body_2:
    'Hvis kommunen eller kirkegården ikke findes i listen, vælger du:',
  create_nettgrav_missing_body_3: 'Netgrav som kommune',
  create_nettgrav_missing_body_4: 'End Of Time Cemetery som kirkegård',
  create_nettgrav_missing_body_5: 'Så oprettes Netgraven uden omkostning.',
  create_nettgrav_missing_body_6:
    'Denne Netgrav fungerer på samme måde som alle andre og giver et varigt digitalt sted for nærhed, minder og relationer.',
  create_nettgrav_section_place_title: 'Digital grav oprettelse – et sted der varer',
  create_nettgrav_place_body_1: 'Netgrav bygger på en enkel tanke:',
  create_nettgrav_place_body_2: 'Den begravede er et andet sted end den fysiske grav.',
  create_nettgrav_place_body_3:
    'Derfor er Netgrav skabt for dem der lever videre – familie, venner og nære – og for forbindelsen der består over tid.',
  create_nettgrav_place_body_4:
    'End Of Time Cemetery er Netgravs egen kirkegård, skabt til at rumme Netgraver uafhængigt af fysisk sted og ment til at bestå over tid.',
  create_nettgrav_section_login_title: 'Log ind og opret ny Netgrav',
  create_nettgrav_login_body_1: 'Log ind og opret ny Netgrav',
  create_nettgrav_login_cta: 'Log ind og opret ny Netgrav',
  how_it_works_section_2_title: 'Find eller besøg en grav',
  how_it_works_section_2_body_1: 'På Netgrav kan du:',
  how_it_works_section_2_body_2: 'finde eksisterende grave',
  how_it_works_section_2_body_3: 'oprette en ny Netgrav',
  how_it_works_section_2_body_4: 'besøge en grav online',
  how_it_works_section_2_body_5: 'knytte din relation til den, der er gravlagt',
  how_it_works_section_2_body_6:
    'lære mennesket graven repræsenterer at kende. Du behøver ikke gøre noget bestemt. Det er muligt bare at være der – stille og uden krav.',
  how_it_works_section_3_title: 'Små handlinger, der betyder noget',
  how_it_works_section_3_body_1: 'Netgrav er bygget omkring enkle handlinger:',
  how_it_works_section_3_body_2: 'sende en gave',
  how_it_works_section_3_body_3: 'dele nogle ord',
  how_it_works_section_3_body_4: 'tilføje et billede eller et minde',
  how_it_works_section_3_body_5: 'markere mærkedage',
  how_it_works_section_3_body_6: 'Alt er frivilligt og kan gøres, når det føles rigtigt.',
  how_it_works_section_3_body_7: 'Ingen forventninger. Ingen tidsfrister.',
  how_it_works_section_4_title: 'Familie og nære',
  how_it_works_section_4_body_1: 'Netgrav kan deles med familie og mennesker, der hører til.',
  how_it_works_section_4_body_2: 'Du vælger selv:',
  how_it_works_section_4_body_3: 'hvem der har adgang',
  how_it_works_section_4_body_4: 'hvad der deles',
  how_it_works_section_4_body_5: 'hvordan graven forvaltes over tid',
  how_it_works_section_4_body_6: 'Sådan kan flere være til stede – på egne præmisser.',
  how_it_works_section_5_title: 'Privatliv og tryghed',
  how_it_works_section_5_body_1: 'Netgrav er lavet til følelsesmæssig og menneskelig tryghed.',
  how_it_works_section_5_body_2: 'Indhold kan være:',
  how_it_works_section_5_body_3: 'privat',
  how_it_works_section_5_body_4: 'synligt for inviterede',
  how_it_works_section_5_body_5: 'åbent for alle, der besøger graven',
  how_it_works_section_5_body_6: 'Du har kontrollen og kan ændre dette, når det føles rigtigt.',
  how_it_works_section_6_title: 'Skab Gnisten – liv der lever nu',
  how_it_works_section_6_body_1: 'Ud over Netgrav findes Skab Gnisten.',
  how_it_works_section_6_body_2:
    'Skab Gnisten er et rum for refleksion, tanker og det, der er sandt for dig – mens du lever.',
  how_it_works_section_6_body_3: 'Her kan ord deles som udtryk for liv, mening og sammenhæng.',
  how_it_works_section_6_body_4: 'Gravene rummer historien.',
  how_it_works_section_6_body_5: 'Gnister rummer det, der lever nu.',
  how_it_works_section_7_title: 'Et sted skabt til at vare',
  how_it_works_section_7_body_1: 'Netgrav er bygget med tiden for øje.',
  how_it_works_section_7_body_2:
    'Det er et sted, der ikke forsvinder, og som ikke kræver vedligeholdelse.',
  how_it_works_section_7_body_3: 'Et varigt rum for nærhed til livet.',
  how_it_works_section_7_body_4: 'Du kan komme tilbage, når du vil.',
  how_it_works_section_7_body_5: 'Det er nok at være der.',
  orbit_section_header: 'Jordens position',
  orbit_intro_text:
    'Vi rejser alle sammen på denne store rejse rundt om Solen. Du er aldrig alene her.',
  orbit_day_progress: 'Dag {day} af 365',
  orbit_position_label: 'Jordens position: {position}°',
  page_not_found: 'Denne side findes ikke.',
  grave_load_server_error: 'Noget gik galt på serveren. Genindlæs siden, og prøv igen.',
  grave_load_failed: 'Vi kunne ikke hente gravstedet. Prøv igen.',
  grave_user_load_failed: 'Vi kunne ikke hente brugeroplysningerne. Prøv igen.',
  grave_static_data_load_failed: 'Vi kunne ikke hente de nødvendige oplysninger. Prøv igen.',
  see_more: 'se mere',
  filter_button: 'Filtrer grave',
  search_event: 'Søg begivenhed, dato',
  add_new: 'Tilføj ny',
  search_tab_all: 'Alle',
  search_tab_graves: 'Grave',
  search_tab_members: 'Mennesker',
  search_people_none_text: 'Ingen medlemmer fundet for',
  user_age: 'Alder:',
  user_shared_grave: 'delt grav',
  user_shared_graves: 'delte grave',
  view_life_page: 'Se Livssiden',
  see_my_light: 'Se Mit lys',
  see_user_light: 'Se {name}s lys',
  relation_to: 'til',
  user_values_heading:
    'Her kan dem, der er forbundet med dig, udtrykke, hvordan de oplever dig. Du kan også besøge en person og gøre noget godt for vedkommende.',
  add_user_values: 'Sig noget, du ser',
  user_values_modal_title: 'Hvad ser du i {name}?',
  user_values_modal_subtitle:
    'To let someone know that you value and see their inner being is truly valuable. The value given and received is unending.',
  user_values_select_category: 'Select category',
  user_values_select_value: 'Vælg et ord, du genkender.',
  user_values_save: 'Save',
  user_values_note_placeholder: 'Tilføj en bemærkning',
  family_tree_page_title: 'Stamtræer',
  family_tree_set_relationships: 'Indstil relationer',
  family_tree_set_relationship: 'Indstil relation',
  family_tree_choose_my_relation: 'Vælg min relation',
  family_tree_people_you_might_know: 'Personer du måske kender',
  family_tree_no_suggestions: 'Ingen forslag endnu',
  family_tree_relations_in_tree: 'Relationer i træet',
  family_tree_relations_radius_hint:
    'Viser relationer, som er med i træet inden for {count} generationer.',
  family_tree_focus_in_tree: 'Fokusér i træet',
  family_tree_group_parents: 'Forældre',
  family_tree_group_partners: 'Partnere',
  family_tree_group_siblings: 'Søskende',
  family_tree_group_children: 'Børn og efterkommere',
  family_tree_group_grandparents_list: 'Bedsteforældre og ældre slægtled',
  family_tree_group_extended_family: 'Andre i familien',
  family_tree_open_relation: 'Åbn',
  family_tree_open_grave: 'Gå til grav',
  family_tree_open_light: 'Gå til lys',
  family_tree_suggestion_likely_relation: 'Kan være din {relation}',
  family_tree_suggestion_via: 'Via {name}',
  family_tree_your_relations: 'Dine relationer',
  family_tree_empty_title: 'Dit stamtræ begynder at vokse her.',
  family_tree_empty_description:
    'Du kan allerede tilføje relationer til de begravede og se båndene tage form. Dette er en tidlig version – flere grene og funktioner kommer snart.',
  family_tree_card_title: 'Dit stamtræ',
  family_tree_card_members: '{count} medlemmer',
  family_tree_card_description: 'Du og dine to sønner er her',
  family_tree_view_tree: 'Se stamtræ',
  family_tree_empty_state:
    'Dine relationer vises her. Start med at knytte en relation til en grav eller en person.',
  family_tree_no_relations: 'Ingen relationer endnu',
  family_tree_connect_relation: 'Forbind relation',
  family_tree_load_more: 'Indlæs mere',
  family_tree_no_info: 'Ingen info',
  family_tree_single_node_hint:
    'Familietræet vokser, når du forbinder relationer til grave og personer, for eksempel forældre eller børn.',
  still_alive: 'stadig i live',
  family_tree_modal_title: 'Vælg din relation til {name}',
  family_tree_modal_suggestion_title: 'Vælg din relation til {name}',
  family_tree_modal_claim_title: 'Omsorgsansvar for graven',
  family_tree_modal_add_mother_title: 'Tilføj din mor',
  family_tree_modal_add_father_title: 'Tilføj din far',
  family_tree_role_mother: 'mor',
  family_tree_role_father: 'far',
  family_tree_role_person: 'person',
  family_tree_modal_tab_relation: 'Relation',
  family_tree_modal_tab_care: 'Bliv værge',
  family_tree_modal_select_grave_label: 'Skriv og vælg grav-/livsside',
  family_tree_modal_select_grave_placeholder: 'Skriv og vælg et navn',
  family_tree_modal_search_person_label: 'Søg og vælg person',
  family_tree_modal_search_person_placeholder: 'Søg efter din {role}',
  family_tree_modal_search_person_hint: 'Skriv mindst 2 bogstaver for at søge på navn.',
  family_tree_modal_locked_relation_label: 'Relation',
  family_tree_modal_locked_relation_value: 'Registreres som: {relation}',
  family_tree_modal_invite_person:
    'Ingen resultater endnu. Prøv fuldt navn eller en anden stavemåde.',
  family_tree_modal_relation_to_person_label: 'Din relation til {name}',
  family_tree_modal_relation_to_you_label: 'Hvad er denne persons relation til dig?',
  family_tree_modal_relation_to_you_with_name_label: 'Hvad er {name}s relation til dig?',
  family_tree_connect_relations_modal_title: 'Forbind relationer',
  family_tree_connect_relations_modal_subtitle:
    'Nem at forbinde forskellige slægtninge med hinanden',
  family_tree_connect_relations_first_label: 'Vælg en slægtning',
  family_tree_connect_relations_second_label: 'Vælg den slægtning du vil relatere til den ovenfor',
  family_tree_connect_relations_third_label: 'Vælg {from}s relation til {to}',
  family_tree_connect_relations_third_label_default:
    'Vælg den første persons relation til den anden',
  family_tree_connect_relations_fourth_label: 'Hvad er {to}s relation til {from}',
  family_tree_connect_relations_fourth_label_default:
    'Hvad er den anden persons relation til den første',
  family_tree_tab: 'Stamtræ',
  waiting_for_approval: 'Afventer godkendelse',
  family_tree_tree_tab: 'Træ',
  family_tree_no_grave_selected: 'Vælg en person for at starte familietræet.',
  family_tree_me_label: 'Mig',
  family_tree_you_label: 'Dig',
  family_tree_you_are_relation: 'Du er {relation}',
  family_tree_additional_connections: '+{count} flere',
  family_tree_connected_relatives: 'Forbundne slægtninge',
  family_tree_modal_reciprocal_label: '{name}s relation til dig',
  family_tree_modal_more_relations: 'Flere valg',
  family_tree_modal_confirm_relation: 'Bekræft relationen',
  family_tree_modal_confirm_care: 'Bekræft omsorgsansvar',
  family_tree_modal_relation_search_placeholder: 'Søg relationer',
  family_tree_modal_relation_search_no_results: 'Ingen matchende relationer',
  family_tree_depth: 'Dybde',
  family_tree_radius_label: 'Generationer',
  family_tree_radius_help: 'Vis flere generationer i slægtstræet.',
  family_tree_radius_decrease: 'Vis færre generationer',
  family_tree_radius_increase: 'Vis flere generationer',
  family_tree_zoom_label: 'Zoom',
  family_tree_zoom_in: 'Zoom ind',
  family_tree_zoom_out: 'Zoom ud',
  family_tree_fit_view: 'Tilpas hele træet',
  family_tree_center_viewer: 'Centrer på mig',
  family_tree_toggle_panel: 'Panel',
  family_tree_children: 'Børn',
  family_tree_partners: 'Partnere',
  family_tree_siblings: 'Søskende',
  family_tree_relation_of_user: '{relation} til {name}',
  family_tree_deceased_relation_to_user: '{deceased} er {relation} til {name}',
  family_tree_unknown_person: 'Denne person',
  family_tree_senses_title: 'Sanser',
  family_tree_add_skill: 'Tilføj talent',
  family_tree_talent_name_placeholder: 'Talent, gave eller evne',
  family_tree_talent_note_placeholder: 'Valgfri note (hvordan dette viser sig i livet)',
  family_tree_no_skills: 'Ingen talenter tilføjet endnu',
  family_tree_cycles_broken_title: 'Mønstre der blev brudt',
  family_tree_add_cycle_broken: 'Tilføj ændring',
  family_tree_cycle_name_placeholder:
    'Mønster der blev brudt, eller noget der blev båret videre anderledes',
  family_tree_cycle_note_placeholder: 'Hvad gjorde denne ændring mulig?',
  family_tree_no_cycles_broken: 'Ingen ændringer tilføjet endnu',
  family_tree_shared_lineage_title: 'Mønstre i familien',
  family_tree_shared_lineage_intro: 'Nogle ting går igen gennem generationer.',
  family_tree_no_shared_lineage: 'Her kan sådanne mønstre blive synlige over tid.',
  family_tree_trait_signal_personal_memory: 'Personligt minde',
  family_tree_trait_signal_possible_family_pattern: 'Muligt familiemønster',
  family_tree_trait_signal_family_confirmed: 'Familiebekræftet',
  family_tree_trait_signal_personal_transformation: 'Personlig ændring',
  family_tree_trait_signal_possible_family_transformation: 'Mulig familieændring',
  family_tree_trait_signal_family_confirmed_transformation: 'Familiebekræftet ændring',
  family_tree_group_cycles: 'Ændringer',
  family_tree_find_and_add: 'Find og tilføj',
  family_tree_done: 'Færdig',
  family_tree_search_loading: 'Indlæser...',
  family_tree_search_no_matches: 'Ingen resultater. Du kan stadig tilføje manuelt nedenfor.',
  family_tree_unified_search_placeholder: 'Søg i sanser, talenter og ændringer...',
  family_tree_suggested_senses: 'Foreslåede sanser',
  family_tree_suggested_talents: 'Foreslåede talenter',
  family_tree_suggested_cycles: 'Foreslåede ændringer',
  family_tree_origin_personal: 'Personlig',
  family_tree_origin_possible_family_pattern: 'Muligt familiemønster',
  family_tree_origin_family_pattern: 'Familiemønster',
  family_tree_origin_personal_change: 'Personlig ændring',
  family_tree_origin_possible_family_change: 'Mulig familieændring',
  family_tree_origin_family_change: 'Familieændring',
  family_tree_added_by_you: 'Tilføjet af dig',
  family_tree_chip_added_in_family: 'Tilføjet i familien',
  family_tree_agree: 'Genkender',
  family_tree_agreed: 'Genkender',
  family_tree_shared_in_lineage: 'Delt i slægtslinjen',
  family_tree_kind_sense: 'Sans',
  family_tree_kind_talent: 'Talent',
  family_tree_kind_cycle: 'Ændring',
  family_tree_lineage_type_cycle: 'Ændring',
  family_tree_lineage_type_talent: 'Talent',
  family_tree_parents_title: 'Forældre',
  family_tree_no_parents: 'Ingen forældre registreret',
  family_tree_add_mother: 'Tilføj mor',
  family_tree_add_father: 'Tilføj far',
  family_tree_detached_title: 'Kendte personer uden forbindelse endnu',
  family_tree_detached_description:
    'Disse personer er registreret, men har endnu ikke en familierelation i dette træ.',
  family_tree_close_panel: 'Luk detaljepanelet',
  family_tree_remove_talent: 'Fjern talent',
  family_tree_remove_change: 'Fjern ændring',
  family_tree_add_note: 'Tilføj tekst',
  family_tree_edit_note: 'Rediger tekst',
  user_has_already_been_taken: 'Brugeren er allerede taget',
  relation_already_exists: 'Relationen findes allerede',
  coin_store_categories: 'Kategorier',
  coin_store_price: 'Pris',
  coin_store_category_all: 'Alle',
  coin_store_category_flowers: 'Blomster',
  coin_store_category_plants: 'Planter',
  coin_store_category_candles: 'Lys',
  coin_store_category_cure: 'Cure',
  coin_store_occasions: 'Lejligheder',
  coin_store_add_to_cart: 'Vælg denne',
  coin_store_preview: 'Se forhåndsvisning',
  coin_store_preview_frame: 'Se cirklen',
  coin_store_preview_candle: 'Se lyset',
  coin_store_already_subscribed: 'Allerede abonneret',
  coin_store_no_products: 'Ingen produkter tilgængelige',
  coin_store_no_frames: 'Ingen rammer tilgængelige',
  coin_store_no_flowers: 'Ingen blomster tilgængelige',
  coin_store_no_candles: 'Ingen lys tilgængelige',
  coin_store_no_plants: 'Ingen planter tilgængelige',
  coin_store_no_cure_products: 'Ingen Cure-produkter tilgængelige',
  coin_store_search_placeholder: 'Søg',
  coin_store_sort_placeholder: 'Sorter',
  coin_store_sort_name: 'Navn',
  coin_store_sort_price_low: 'Pris: Lav til høj',
  coin_store_sort_price_high: 'Pris: Høj til lav',
  coin_store_tab_all: 'ALLE',
  coin_store_tab_physical: 'FYSISK',
  coin_store_tab_digital: 'DIGITAL',
  coin_store_tab_gift: 'GIV EN TJENESTE',
  coin_store_category_frames: 'Cirkler',
  coin_store_hero_heading: 'End Of Time Collection',
  coin_store_hero_subheading: 'Hver flamme og cirkel bringer nærværet tilbage.',
  coin_store_hero_image_alt: 'store illustration',
  coin_store_hero_pill_label: 'Everlight – følger døgnrytmen ved graven',
  coin_store_hero_note1: 'rolig animation, skånsom mod øjnene',
  coin_store_hero_note2: 'designet til nærvær – ikke støj',
  coin_store_filters: 'Filtre',
  nav_section: 'Navigation',
  account_section: 'Konto',
  aria_menu: 'menu',
  aria_profile_menu: 'profilmenu',
  aria_notifications: 'notifikationer',
  aria_home: 'hjem',
  aria_my_light: 'mit lys',
  aria_open_search: 'åbn søgning',
  aria_close_search: 'luk søgning',
  verified: 'Verificeret',
  claimed_by_you: 'Registreret af dig',
  claimed_explainer: 'Denne grav er verificeret og knyttet til din konto.',
  composer_visibility: 'Synlighed',
  composer_public: 'Offentlig',
  composer_relatives: 'Slægtsringe',
  composer_private: 'Privat',
  composer_public_desc: 'alle',
  composer_relatives_desc: 'Synlig for familie/følgere',
  composer_private_desc: 'Kun for dig',
  composer_more: 'Flere valg …',
  composer_fewer: 'Færre valg',
  composer_caption_ph: 'Billedtekst (valgfrit)',
  composer_add_link_prompt: 'Indsæt et link (URL)',
  composer_add_link: 'Tilføj link',
  composer_add_emoji: 'Tilføj emoji',
  composer_search_emoji: 'Søg emojis',
  reply: 'Svar',
  store_products: 'Cirkler og lys',
  store_products_subheading: 'Vælg nu. Brug det fra Mine valg efter købet.',
  store_intro_eyebrow: 'Nærvær på Netgraven',
  store_intro_title: 'Til en, du tænker på',
  store_intro_body: 'Her finder du lys og cirkler, som kan give din tanke et personligt udtryk.',
  store_intro_candles: 'Tænd et lys',
  store_intro_frames: 'Vælg en cirkel',
  store_intro_inventory: 'Se Mine valg',
  store_frames_description:
    'En digital cirkel omkring profilbilledet på graven. Efter købet vælger du, hvilken grav den skal bruges på fra Mine valg.',
  store_candles_description:
    'Et digitalt lys, du kan tænde på en grav nu eller på en mærkedag. Ét køb giver ét lys i Mine valg.',
  store_view_all: 'Se alle {category}',
  store_choose_frame: 'Vælg denne cirkel',
  store_choose_candle: 'Vælg dette lys',
  store_preview_no_grave: 'Du kan afslutte valget nu og vælge grav fra Mine valg efter købet.',
  store_preview_example_grave: 'Eksempel på en grav',
  store_cart_open: 'Åbn dit valg',
  store_cart_close: 'Luk dit valg',
  store_cart_decrease: 'Reducer antal',
  store_cart_increase: 'Øg antal',
  store_cart_remove: 'Fjern fra valget',
  store_cart_empty: 'Du har ikke valgt noget endnu.',
  store_continue_checkout: 'Gå videre',
  store_favorites_section: 'Gemt til senere',
  store_favorite_add: 'Gem til senere',
  store_favorite_remove: 'Fjern fra gemte',
  coin_store_select_frame_title: 'Vælg en cirkel',
  coin_store_select_frame_subtitle: 'Vælg en ramme, du vil tilføje til dit lager.',
  coin_store_select_frame_confirm: 'Vælg denne?',
  frame_upload_title: 'Add New Frame',
  frame_upload_name_label: 'Name',
  frame_upload_name_placeholder: 'Frame name',
  frame_upload_name_required: 'Enter frame name',
  frame_upload_kind_label: 'Kind',
  frame_upload_kind_svg: 'SVG',
  frame_upload_kind_lottie: 'Lottie',
  frame_upload_kind_gif: 'GIF',
  frame_upload_kind_apng: 'APNG',
  frame_upload_kind_webp: 'WebP',
  frame_upload_kind_mp4: 'MP4',
  frame_upload_kind_webm: 'WebM',
  frame_upload_kind_mov: 'MOV',
  frame_upload_kind_tgs: 'TGS',
  frame_upload_viewbox_label: 'ViewBox',
  frame_upload_viewbox_placeholder: 'e.g., 0 0 100 100',
  frame_upload_viewbox_extra: "Format: 'minX minY width height'",
  frame_upload_inner_circle_label: 'Inner Circle',
  frame_upload_inner_circle_extra: 'Circle center (cx, cy) and radius (r) in viewBox units',
  frame_upload_inner_circle_cx_placeholder: 'cx',
  frame_upload_inner_circle_cy_placeholder: 'cy',
  frame_upload_inner_circle_r_placeholder: 'r',
  frame_upload_asset_file_label: 'Asset File',
  frame_upload_asset_file_button: 'Select file',
  frame_upload_asset_file_required: 'Please select at least one file.',
  frame_upload_price_label: 'Price',
  frame_upload_price_placeholder: 'Enter price',
  frame_upload_price_required: 'Enter price',
  frame_upload_description_label: 'Description',
  frame_upload_description_placeholder: 'Describe this frame',
  frame_upload_color_label: 'Farve',
  frame_upload_color_red: 'Rød',
  frame_upload_color_blue: 'Blå',
  frame_upload_color_green: 'Grøn',
  frame_upload_theme_label: 'Tema',
  frame_upload_theme_light: 'Lys',
  frame_upload_theme_dark: 'Mørk',
  frame_upload_submit: 'Upload',
  frame_upload_delete_title: 'Delete Frame',
  frame_upload_delete_content: 'Dette er permanent.',
  frame_upload_delete_ok: 'Delete',
  frame_apply: 'Påfør',
  frame_buy_more: 'Vælg cirkel',
  frame_available_quantity: 'Tilgængelig: x{count}',
  frame_applied_at: 'Aktiv på:',
  frame_no_graves_yet: 'Dine tilknyttede grave kommer her',
  frame_no_graves_active: 'Ingen aktive grave endnu.',
  no_frames_available: 'Du har ingen cirkler endnu. Se de cirkler du kan vælge imellem.',
  frame_modal_title: 'Vælg cirkel eller upload billede',
  frames_store_title: 'Cirkler',
  send_gift: 'Tænd et lys',
  gift_message_label: 'Ord til graven',
  gift_event_context_time: 'på {event} · {time}',
  gift_message_placeholder: 'Skriv et par ord, hvis du vil',
  no_gifts_available: 'Ingen gaver tilgængelige.',
  no_gifts_yet: 'Tænd et lys for {graveName}',
  candles: 'Lys',
  choose_candle: 'Vælg lys',
  add_candle: 'Tilføj lys',
  buy_gifts: 'Køb gaver',
  gifts_title: 'Gaver',
  gifts_empty_state: 'No gifts have been added yet.',
  previous_gift: 'Forrige gave',
  next_gift: 'Næste gave',
  gift_update_success: 'Gift updated',
  gift_delete_success: 'Gift deleted',
  gifts_load_error: 'Unable to load gifts right now.',
  gift_update_error: 'Unable to update gift.',
  gift_delete_error: 'Unable to delete gift.',
  gift_edit_title: 'Rediger gave',
  gift_sent: 'Gave sendt',
  gift_send_error: 'Kunne ikke sende gave',
  gift_event_by_user: '{event} af {user}',
  edit_text_description: 'Tilføj, rediger eller fjern tekst',
  my_light_tooltip: 'Din Gnist gør verden til et bedre sted.',
  products_title: 'Cirkler og lys',
  products_add_product: 'Tilføj produkt',
  products_edit_product: 'Rediger produkt',
  products_table_index: 'Nr.',
  products_table_name: 'Navn',
  products_table_image_or_frame: 'Billede eller ramme',
  products_table_price: 'Pris',
  products_table_description: 'Beskrivelse',
  products_table_action: 'Handling',
  products_action_edit: 'Rediger',
  products_action_delete: 'Slet',
  products_form_type_label: 'Type',
  products_form_type_frame: 'Ramme',
  products_form_type_cure: 'Gravpleje',
  products_form_type_flower: 'Blomst',
  products_form_type_plant: 'Plante',
  products_form_type_candle: 'Lys',
  products_form_cure_name_label: 'Navn',
  products_form_cure_name_placeholder: 'Produktnavn',
  products_form_cure_name_required: 'Angiv produktnavn',
  products_form_cure_lengths_label: 'Løbetid',
  products_form_cure_lengths_placeholder: 'Angiv abonnementsperioder',
  products_form_cure_lengths_required: 'Angiv løbetider',
  products_form_cure_price_label: 'Pris',
  products_form_cure_price_placeholder: 'Angiv pris',
  products_form_cure_price_required: 'Angiv pris',
  products_form_cure_description_label: 'Beskrivelse',
  products_form_cure_description_placeholder: 'Beskriv produktet',
  products_form_cure_image_label: 'Billede',
  products_form_cure_image_required: 'Vælg et billede.',
  products_form_upload_button: 'Upload',
  products_form_translations_label: 'Oversættelser',
  products_form_add_translation: 'Tilføj oversættelse',
  products_form_translations_help:
    'Tilføj valgfri sprogtekst for at tilsidesætte den engelske standard.',
  products_form_translation_locale_label: 'Sprog',
  products_form_translation_locale_required: 'Vælg et sprog',
  products_form_translation_locale_placeholder: 'Vælg sprog',
  products_form_translation_name_label: 'Navn',
  products_form_translation_name_required: 'Angiv et navn',
  products_form_translation_name_placeholder: 'Oversat produktnavn',
  products_form_translation_description_label: 'Beskrivelse',
  products_form_translation_description_placeholder: 'Oversat beskrivelse (valgfrit)',
  products_form_translation_remove: 'Fjern oversættelse',
  products_delete_error_in_use: 'Kan ikke slette dette produkt, fordi det stadig er i brug.',
  checkout_purchase_success: 'Købet lykkedes',
  checkout_payment_failed: 'Betalingen mislykkedes',
  checkout_missing_payment_method_id: 'Manglende betalingsmetode-id',
  lighthouse_title: 'End Of Time Collection',
  lighthouse_subtitle: 'Hver flamme og cirkel bringer nærværet tilbage.',
  lighthouse_description:
    'Et urokkeligt lys i horisonten, der leder kærligheden gennem mørke vande. Rolige have, stille styrke og en stråle, der siger: du er aldrig alene. En mild hyldest til kystens hjerter og til enhver, der bar andre sikkert hjem.',
  lighthouse_go_to_store: 'Se samlingen',
  frame_info_title: 'Sådan sætter du en ramme',
  frame_info_description:
    '1. Gå til graven du vil ændre.\n2. Klik på gravens profilbillede.\n3. Vælg en ramme – den vises på graven med det samme.',
  profile_and_settings: 'Profil og indstillinger',
  help_and_support: 'Hjælp & support',
  report_problem: 'Rapporter et problem',
  light_theme: 'Lyst tema',
  dark_theme: 'Mørkt tema',
  toggle_theme: 'Skift tema',
  toggle_theme_to_dark: 'Skift til mørk tilstand',
  toggle_theme_to_light: 'Skift til lys tilstand',
  partner_title: 'Partner',
  partner_become_seller: 'Bliv partner (sælgerkonto)',
  partner_status_pending: 'Partnerstatus: afventer godkendelse',
  partner_apply: 'Ansøg om at blive partner',
  partner_open_portal: 'Åbn partnerportalen',
  partner_dashboard: 'Partner-dashboard',
  partner_create_ad: 'Opret annonce/produkt',
  partner_payouts: 'Udbetalinger',
  'designSystem.showcase.title': 'Design System',
  'designSystem.colors.title': 'Portalens farveskema',
  'designSystem.colors.silver': 'Sølv',
  'designSystem.colors.gold': 'Guld',
  'designSystem.colors.roseGold': 'Rosaguld',
  'designSystem.colors.bronze': 'Bronze',
  'designSystem.colors.titanium': 'Titan',
  'designSystem.colors.emerald': 'Smaragd',
  'designSystem.colors.platinum': 'Platin',
  'designSystem.colors.copper': 'Kobber',
  'designSystem.colors.amethyst': 'Ametyst',
  'designSystem.colors.sapphire': 'Safir',
  'designSystem.colors.ruby': 'Rubin',
  'designSystem.colors.obsidian': 'Obsidian',
  'designSystem.colors.aqua': 'Akvamarin',
  'designSystem.colors.sunset': 'Solnedgang',
  'designSystem.colors.surfaces': 'Overfladefarver',
  'designSystem.colors.text': 'Tekstfarver',
  'designSystem.colors.metallic': 'Metalliske paletter',
  'designSystem.colors.viewMetallicIcons': 'Se metallikon-demo',
  'designSystem.anniversaries.upcoming': 'Kommende jubilæer',
  'designSystem.anniversaries.breakdown.title': 'Næste 7 dage',
  'designSystem.anniversaries.grave': 'Grav',
  'designSystem.anniversaries.user': 'Bruger',
  'designSystem.anniversaries.public': 'Offentlige',
  'designSystem.anniversaries.total': 'I alt',
  'designSystem.grid.sectionTitle': 'Grid-layout',
  'designSystem.grid.controls.title': 'Interaktive kontroller',
  'designSystem.grid.controls.align': 'Vertikal justering',
  'designSystem.grid.controls.justify': 'Horisontal justering',
  'designSystem.grid.controls.horizontalGutter': 'Vandret afstand (px)',
  'designSystem.grid.controls.verticalGutter': 'Lodret afstand (px)',
  'designSystem.grid.controls.wrap': 'Ombryd linjer',
  'designSystem.grid.controls.currentProps': 'Aktive egenskaber',
  'designSystem.grid.preview.title': 'Forhåndsvisning',
  'designSystem.grid.align.top': 'Top',
  'designSystem.grid.align.middle': 'Midte',
  'designSystem.grid.align.bottom': 'Bund',
  'designSystem.grid.align.stretch': 'Stræk',
  'designSystem.grid.justify.start': 'Start',
  'designSystem.grid.justify.center': 'Center',
  'designSystem.grid.justify.end': 'Slut',
  'designSystem.grid.justify.spaceBetween': 'Fordel mellem',
  'designSystem.grid.justify.spaceAround': 'Fordel rundt',
  'designSystem.grid.justify.spaceEvenly': 'Fordel jævnt',
  'designSystem.grid.box.label': 'Kolonne {index}',
  'designSystem.grid.box.span': 'span {value}',
  'designSystem.grid.box.offset': 'Forskydning {value}',
  'designSystem.grid.box.order': 'Rækkefølge {value}',
  'designSystem.grid.box.flex': 'flex {value}',
  'designSystem.grid.box.grow': 'Fylder resterende plads',
  'designSystem.grid.responsive.title': 'Responsivt eksempel',
  'designSystem.grid.responsive.description':
    'Ændr vinduets størrelse for at se afstande og justering skifte mellem breakpoints.',
  'designSystem.grid.box.responsive': 'xs 24 → md 12',
  'designSystem.grid.box.responsiveDetail': 'Stablet på mobil, opdelt på desktop',
  'designSystem.grid.box.responsiveAlign': 'Deler afstand automatisk via kontekst',
  'designSystem.grid.docs.title': 'Grid-layout – Row & Col',
  'designSystem.grid.docs.notes':
    'Row beregner responsive afstande og justering, og Col spejler værdierne via kontekst for et ensartet layout.',
  'designSystem.mediaUpload.triggerLabel': 'Select files',
  'designSystem.mediaUpload.type.media': 'media',
  'designSystem.mediaUpload.type.image': 'images',
  'designSystem.mediaUpload.type.video': 'videos',
  'designSystem.mediaUpload.type.audio': 'audio',
  'designSystem.mediaUpload.type.file': 'files',
  'designSystem.mediaUpload.dropHint': 'Drag & drop to upload or browse files',
  'designSystem.mediaUpload.dropActive': 'Release to upload',
  'designSystem.mediaUpload.emptyState': 'No files selected yet',
  'designSystem.mediaUpload.previewVideoLabel': 'Preview of {name}',
  'designSystem.mediaUpload.previewImageAlt': 'Preview of {name}',
  'designSystem.mediaUpload.removeFile': 'Remove {name}',
  'designSystem.mediaUpload.editFile': 'Rediger {name}',
  'designSystem.mediaUpload.zoom': 'Zoom',
  'designSystem.mediaUpload.unnamed': 'Untitled file',
  'designSystem.mediaUpload.showcase.defaultLabel': 'Media library',
  'designSystem.mediaUpload.showcase.defaultDescription':
    'Upload new photos, videos or audio to share with your team.',
  'designSystem.mediaUpload.showcase.controlTitle': 'Configuration',
  'designSystem.mediaUpload.showcase.mediaTypeLabel': 'Media type',
  'designSystem.mediaUpload.showcase.multipleLabel': 'Allow multiple files',
  'designSystem.mediaUpload.showcase.maxFilesLabel': 'Max files',
  'designSystem.mediaUpload.showcase.duplicatesLabel': 'Allow duplicate files',
  'designSystem.mediaUpload.showcase.dragLabel': 'Enable drag & drop',
  'designSystem.mediaUpload.showcase.selectedCount':
    '{count, plural, =0 {No files yet} one {# file selected} other {# files selected}}',
  'designSystem.mediaUpload.showcase.helper': 'Maximum {limit} MB per file',
  'designSystem.mediaUpload.showcase.tooLarge': '{name} exceeds the {limit} MB limit',
  'designSystem.mediaUpload.showcase.untitledFile': 'Selected file',
  'designSystem.mediaUpload.showcase.trigger': 'Upload {label}',
  'designSystem.mediaUpload.showcase.dropHint': 'Drag & drop {label} or browse files',
  'designSystem.mediaUpload.showcase.examplesTitle': 'Examples',
  'designSystem.mediaUpload.showcase.imageTitle': 'Gallery images',
  'designSystem.mediaUpload.showcase.imageDescription':
    'Upload retina-ready hero images for landing pages.',
  'designSystem.mediaUpload.showcase.imageHelper': 'PNG or JPG up to {limit} MB each.',
  'designSystem.mediaUpload.showcase.videoTitle': 'Promo video',
  'designSystem.mediaUpload.showcase.videoDescription':
    'Collect a single teaser video for campaigns.',
  'designSystem.mediaUpload.showcase.videoHelper':
    'MP4 up to {limit} MB. We’ll transcode automatically.',
  'designSystem.mediaUpload.showcase.audioTitle': 'Audio tribute',
  'designSystem.mediaUpload.showcase.audioDescription': 'Gather spoken memories or music clips.',
  'designSystem.mediaUpload.showcase.audioHelper': 'MP3 or WAV up to {limit} MB.',
  'designSystem.mediaUpload.showcase.fileTitle': 'Document upload',
  'designSystem.mediaUpload.showcase.fileDescription': 'Store memorial programs or consent forms.',
  'designSystem.mediaUpload.showcase.fileHelper': 'PDF or DOCX up to {limit} MB each.',
  'designSystem.mediaUpload.showcase.buttonTitle': 'Quick upload button',
  'designSystem.mediaUpload.showcase.buttonDescription':
    'Single tap button with icon for quick uploads.',
  'designSystem.mediaUpload.showcase.buttonHelper': 'Tap the button to pick one or more files.',
  'designSystem.mediaUpload.showcase.buttonTrigger': 'Choose files',
  'designSystem.mediaUpload.showcase.imageButtonCaption':
    'Tap the media button or drop hero images here.',
  'designSystem.mediaUpload.showcase.imageButtonAria': 'Add gallery image',
  'designSystem.mediaUpload.showcase.videoButtonCaption':
    'Drop or select a promo trailer to share.',
  'designSystem.mediaUpload.showcase.videoButtonAria': 'Add campaign video',
  'library.mediaUpload.trigger': '{count, plural, =0 {Upload media} other {Add more media}}',
  'library.mediaUpload.helper': 'Drag files here or browse from your device.',
  'search.publicNotice.title': 'Offentlige oplysninger',
  'search.publicNotice.body': 'Log ind for at se billeder, minder og mere.',
  // Header/Notifications additions
  design_system: 'Design system',
  settings: 'Indstillinger',
  logout: 'Log ud',
  account_menu: 'Kontomenu',
  guest_menu: 'Menu',
  'guest_menu.subtitle': 'Udforsk mere af Netgrav eller log ind for at fortsætte.',
  more_information: 'Mere information',
  accepted: 'Godkendt',
  rejected: 'Afvist',
  // Groups & Group Details
  'groups.title': 'Rum',
  'groups.loading': 'Indlæser grupper…',
  'groups.error': 'Kunne ikke indlæse grupper',
  'groups.empty': 'Ingen grupper endnu.',
  'groups.createGroup': 'Opret gruppe',
  'groups.form.name': 'Navn',
  'groups.form.description': 'Beskrivelse',
  'groups.form.category': 'Kategori',
  'groups.form.paid': 'Betalt rum',
  'groups.mode.explore': 'Udforsk rum',
  'groups.mode.mine': 'Mine rum',
  'groups.search': 'Søg i rum',
  'groups.category': 'Kategori',
  'groups.category.all': 'Alle kategorier',
  'groups.create.title': 'Opret et rum',
  'groups.form.desc': 'Beskrivelse (valgfri)',
  'groups.form.create': 'Opret rum',
  'groups.view': 'Vis',
  'groups.join': 'Bliv en del af rummet',
  'groups.empty.hint': 'Prøv at ændre filtre eller opret et nyt rum.',
  loading: 'Loading…',
  'error.generic': 'Something went wrong.',
  'pagination.prev': 'Forrige',
  'pagination.next': 'Næste',
  notifications_load_more: 'Indlæs mere',
  'groups.subtitle': 'Hvad vil du gerne tale om i dag?',
  'groups.categories.label': 'Kategorier',
  'groups.mine.filters.sub': 'Filtrér rum efter din rolle.',
  'groups.mine.filter.all': 'Alle',
  'groups.mine.filter.led': 'Ledet af dig',
  'groups.mine.filter.member': 'Medlem',
  'groups.mine.filter.pending': 'Afventer',
  'groups.mine.section.led': 'Rum du leder',
  'groups.mine.section.led.sub': 'Rum hvor du er ejer eller admin.',
  'groups.mine.section.member': 'Rum du er med i',
  'groups.mine.section.member.sub': 'Rum hvor du er aktivt medlem.',
  'groups.mine.section.pending': 'Ventende forespørgsler',
  'groups.mine.section.pending.sub': 'Rum hvor din forespørgsel eller invitation stadig afventer.',
  'groups.mine.empty.title': 'Ingen rum i denne sektion endnu',
  'groups.mine.empty.hint': 'Skift filter eller udforsk rum at deltage i.',
  'groups.mine.empty.cta': 'Udforsk rum',
  'groups.mine.empty.all.title': 'Du er ikke med i nogen rum endnu',
  'groups.mine.empty.all.hint': 'Udforsk rum eller opret et for at komme i gang.',
  'groups.mine.overview.title': 'Dine rum',
  'groups.mine.overview.sub': 'Rum du leder, deltager i eller venter på at blive medlem af.',
  'groups.mine.load_error.title': 'Dine rum kunne ikke indlæses',
  'groups.mine.load_error.text': 'Prøv igen om et øjeblik.',
  'groups.mine.retry': 'Prøv igen',
  'groups.mine.search_empty.title': 'Ingen rum matcher din søgning',
  'groups.mine.search_empty.text': 'Prøv et andet rumnavn eller ryd søgningen.',
  'groups.mine.search_empty.clear': 'Ryd søgning',
  'groups.mine.feed.error.title': 'Seneste aktivitet kunne ikke indlæses',
  'groups.mine.feed.error.text': 'Dine rum er stadig tilgængelige ovenfor.',
  'groups.sidebar.mine.title': 'Dine seneste rum',
  'groups.sidebar.mine.sub': 'Hurtig adgang til rum du allerede følger.',
  'groups.category_name.local': 'Lokalt',
  'groups.category_name.science_and_tech': 'Videnskab og teknologi',
  'groups.category_name.education': 'Uddannelse',
  'groups.category_name.health': 'Sundhed',
  'groups.category_name.lifestyle': 'Livsstil',
  'groups.category_name.travel': 'Rejser',
  'groups.category_name.sports': 'Sport',
  'groups.category_name.technology': 'Teknologi',
  'groups.category_name.family': 'Familie',
  'groups.category_name.grief_and_loss': 'Sorg og tab',
  'groups.category_name.spirituality': 'Religion og tro',
  'groups.category_name.relationships': 'Relationer',
  'groups.category_name.life_choices': 'Livsvalg',
  'groups.category_name.existence': 'Eksistens',
  'groups.category_name.guidance': 'Vejledning',
  'groups.create.cta': 'Opret rum',
  'groups.empty.title': 'Ingen rum fundet',
  'groups.empty.hint': 'Der findes ingen rum, der matcher din søgning lige nu.',
  'groups.empty.initial.title': 'Ingen åbne rum endnu',
  'groups.empty.initial.hint':
    'Opret det første rum, og inviter mennesker til en meningsfuld samtale.',
  'groups.empty.clear': 'Nulstil søgning og filtre',
  'groups.card.view': 'Åbn',
  'groups.card.owner': 'Rumansvarlig',
  'groups.card.owner.you': 'Dig',
  'create_group.title': 'Opret rum',
  'create_group.name': 'Hvad skal rummet hedde?',
  'create_group.desc': 'Hvad ønsker du, at rummet skal rumme?',
  'create_group.category': 'Vælg retning',
  'create_group.paid': 'Betalt medlemskab',
  'create_group.free': 'Gratis',
  'create_group.submit': 'Opret',
  'create_group.cancel': 'Annuller',
  'create_group.cover.label': 'Rumbillede (valgfrit)',
  'create_group.cover.preview_alt': 'Forhåndsvisning af rumbillede',
  'create_group.cover.empty': 'Intet rumbillede valgt endnu.',
  'create_group.cover.choose': 'Vælg rumbillede',
  'create_group.cover.adjust_crop': 'Juster beskæring',
  'create_group.cover.remove': 'Fjern',
  'create_group.cover.hint':
    'Billedet tilføjes, når rummet oprettes, og kan ændres senere i Indstillinger.',
  'create_group.cover.upload_error':
    'Kunne ikke uploade rumbillede. Du kan tilføje det i Indstillinger.',
  'create_group.cover.image_only': 'Vælg en billedfil.',
  'groups.settings.cover.crop': 'Tilpas rumbilledet',
  'groups.settings.cover.safe_area': 'Hold vigtige detaljer inden for den stiplede ramme.',
  crop_zoom: 'Zoom',
  'gravesHub.title': 'Dine nærmeste',
  'gravesHub.hero.eyebrow': 'Holder tæt på',
  'gravesHub.hero.title': 'Personerne jeg passer på',
  'gravesHub.hero.subtitle':
    'Alt om dem du følger op på ligger her—opdateringer, datoer og hvem der er med.',
  'gravesHub.hero.graveCount':
    'Du følger i øjeblikket {count, plural, one {# person} other {# personer}} i Netgrav.',
  'gravesHub.hero.cta': 'Tilføj en ny',
  'gravesHub.hero.secondary': 'Se invitationer',
  'gravesHub.myGraves': 'Mine grave',
  'gravesHub.myGraves.count': '{count}',
  'gravesHub.create': 'Tilføj en person',
  'gravesHub.myGraves.empty':
    'Ingen her endnu. Tilføj nogen eller accepter en invitation for at komme i gang.',
  'gravesHub.myGraves.emptyAction': 'Tilføj en ny',
  'gravesHub.myGraves.viewInvites': 'Accepter invitation',
  'gravesHub.guest':
    'Her finder du gravene, du hører til. Et sted for nærhed, tilstedeværelse og omsorg over tid. Log ind for at komme i gang.',
  'gravesHub.guest_preview.name_1': 'Lorense Hansen',
  'gravesHub.guest_preview.role_1': 'Bedstemor',
  'gravesHub.guest_preview.name_2': 'Oskar Johansen',
  'gravesHub.guest_preview.role_2': 'Far',
  'gravesHub.guest_preview.name_3': 'Anna Solberg',
  'gravesHub.guest_preview.role_3': 'Familieven',
  'gravesHub.guest_preview.place': 'Vestre gravlund, Oslo',
  'gravesHub.guest_preview.selected_copy':
    'Et sted til at se de grave, du er knyttet til, åbne gravsiden og invitere andre ind, som også er knyttet til graven.',
  'gravesHub.guest_preview.visit': 'Åbn gravsiden',
  'gravesHub.guest_preview.invite': 'Invitér familie',
  'gravesHub.guest_preview.update_author_1': 'Maren delte et opslag',
  'gravesHub.guest_preview.update_time_1': 'For 2 timer siden',
  'gravesHub.guest_preview.update_body_1':
    'Maren er taknemmelig for Lorense Hansen. Et tegn på nærvær, uden at det behøver at være mange ord.',
  'gravesHub.guest_preview.update_author_2': 'Isak delte et opslag',
  'gravesHub.guest_preview.update_time_2': 'I går',
  'gravesHub.guest_preview.update_body_2':
    'Isak savner Lorense Hansen. Opslag, billeder og links fra de nærmeste vises her.',
  'gravesHub.loading.graves': 'Samler personerne du følger op på...',
  'gravesHub.loading.error':
    'Vi kunne ikke hente dine personer lige nu. Genindlæs for at prøve igen.',
  'gravesHub.loading.completed': 'Synkroniseret på {seconds}s',
  'gravesHub.feed.title': 'Gravvæggen',
  'gravesHub.invite': 'Invitér familien til at tage vare på graven',
  'gravesHub.selected.copy': 'Følg med i det, der sker, og tag andre med, du stoler på.',
  'gravesHub.memory.photoOnly': 'Tilføjede et foto til graven',
  'gravesHub.memory.view': 'Læs minde',
  'gravesHub.memory.empty': 'Ingen opdateringer endnu—del en tanke så alle ved, at du var forbi.',
  'gravesHub.memory.loadMore': 'Vis flere opdateringer',
  'gravesHub.visitNamed': 'Besøg {name}s grav',
  'gravesHub.visitFallback': 'Besøg graven',
  'gravesHub.feed.noSelection': 'Vælg en person for at være til stede.',
  'gravesHub.feed.empty': 'Her er det foreløbig stille.',
  'gravesHub.invitations.shortcut':
    '{count, plural, one {# invitation venter} other {# invitationer venter}}',
  'gravesHub.invitations.title': 'Invitationer til fælles omsorg',
  'gravesHub.invitations.manage': 'Administrer',
  'gravesHub.invitations.invitedBy': 'Vil hjælpe dig med at tage vare på graven',
  'gravesHub.invitations.accept': 'Accepter',
  'gravesHub.invitations.decline': 'Afvis',
  'gravesHub.invitations.acceptSuccess': 'Invitationen er accepteret',
  'gravesHub.invitations.declineSuccess': 'Invitationen er afvist',
  'gravesHub.invitations.actionError': 'Noget gik galt. Prøv igen.',
  'gravesHub.gettingStarted.title': 'I dag',
  'gravesHub.gettingStarted.reminders': 'E‑mailpåmindelser',
  'gravesHub.gettingStarted.remindersHint':
    'Få et venligt varsel før vigtige dage eller nye opdateringer.',
  'gravesHub.starter.anniversaries.title': 'Mærkedage',
  'gravesHub.starter.anniversaries.body':
    'Tilføj datoer, der hjælper familien med at huske sammen.',
  'gravesHub.starter.anniversaries.action': 'Tilføj dato',
  'gravesHub.starter.memory.title': 'Billeder',
  'gravesHub.starter.memory.body': 'Tilføj billeder, familien kan ønske at bevare sammen.',
  'gravesHub.starter.memory.action': 'Tilføj billeder',
  'gravesHub.shortcuts.title': 'Genveje',
  'gravesHub.shortcuts.invite': 'Invitér familien til at hjælpe',
  'gravesHub.shortcuts.invite.copy':
    'Del adgang så familien kan tilføje minder, billeder og sammenhæng.',
  'gravesHub.shortcuts.email': 'E‑mailindstillinger',
  'gravesHub.shortcuts.email.copy': 'Finjuster påmindelser og notifikationer.',
  'gravesHub.shortcuts.open': 'Åbn graven',
  'gravesHub.shortcuts.open.copy':
    'Besøg hele gravsiden for historier, billeder og det, I tager vare på sammen.',
  'gravesHub.tips.title': 'Hold kontakten',
  'home.actions.title': 'Netgrav: Et varigt hjem for vores liv.',
  'home.actions.subtitle': 'Et netværk bygget til sandhed og fællesskab, drevet af varig mening.',
  'home.actions.create.title': 'Opret en Netgrav',
  'home.actions.create.body':
    'Saml familien og skab jeres permanente Netgrav – helt gratis. Del ord, billeder og lys, og bevar historien sammen uanset hvor i verden I er.',
  'home.actions.create.cta': 'Start Netgrav',
  'home.actions.find.title': 'Find en grav',
  'home.actions.find.body':
    'Find den, du savner. Se bekræftede minder og bliv varslet på vigtige dage.',
  'home.actions.find.cta': 'Søg efter grave',
  'home.actions.invite.title': 'Invitér bidragydere',
  'home.actions.invite.body':
    'Invitér bidragydere. Del adgang med dine nærmeste for at bygge livshistorien sammen og holde mindet levende.',
  'home.actions.invite.cta': 'Send invitationer',
  'home.actions.spark.title': 'Tænd din Gnist',
  'home.actions.spark.body':
    'Del det, der er vigtigt for dig nu. Din Gnist er rummet for dine refleksioner og indre sandheder. Del dit lys med verden og skab eftertanke hos andre.',
  'home.actions.spark.cta': 'Skab Gnist',
  'gravesHub.tips.applyFrame.title': 'Gør siden personlig',
  'gravesHub.tips.applyFrame.body':
    'Du har rammer klar. Vil du tilføje en, der passer til {hasName, select, yes {{firstName}} other {dem}}?',
  'gravesHub.tips.applyFrame.cta': 'Brug en ramme',
  'gravesHub.tips.invite.title': 'Invitér nære du stoler på',
  'gravesHub.tips.invite.body': 'Del ansvar og adgang, så historier og omsorg bæres sammen.',
  'gravesHub.tips.invite.cta': 'Send invitation',
  'gravesHub.tips.reminders.title': 'Påmindelse via e-mail',
  'gravesHub.tips.reminders.body': 'Få en påmindelse via e-mail før vigtige begivenheder.',
  'gravesHub.tips.info.title': 'Byg en stabil omsorgsrytme',
  'gravesHub.tips.info.body':
    'Brug påmindelser, opdateringer og delt adgang for at holde omsorgen jævn over tid.',
  'gravesHub.store.title': 'Små handlinger med stor betydning',
  'gravesHub.store.description':
    'Opdag End Of Time Collection – lys og cirkler, der bringer nærværet tilbage.',
  'gravesHub.store.candle.title': 'Tænd lys',
  'gravesHub.store.candle.body': 'En stille handling af kærlighed.',
  'gravesHub.store.candle.cta': 'Hold lyset tændt',
  'gravesHub.store.frame.title': 'Vælg cirkel',
  'gravesHub.store.frame.body': 'Find den, der afspejler forbindelsen.',
  'gravesHub.store.frame.cta': 'Vælg cirkel',
  'gravesHub.store.tree.title': 'Plant et træ',
  'gravesHub.store.tree.body': 'Plant en levende hyldest i deres navn via vores partnere.',
  'gravesHub.store.tree.cta': 'Plant et træ',
  'gravesHub.notifications.updated': 'Påmindelsesindstillinger opdateret',
  'gravesHub.notifications.error': 'Vi kunne ikke opdatere dine påmindelser. Prøv igen.',
  'gravesHub.notifications.noSelection': 'Vælg en person for at fortsætte.',
  'gravesHub.sidePanel.title': 'Støtte og vejledning',
  'gravesHub.sidePanel.empty':
    'Vælg en person for at se tips og værktøjer til at holde siden opdateret.',
  // Efter køb – brug ramme
  'postPurchase.applyFrame.title': 'Brug dit nye køb nu?',
  'postPurchase.applyFrame.body': 'Du kan lægge det, du lige har købt, på en grav med det samme.',
  'postPurchase.applyFrame.select': 'Vælg en person',
  'postPurchase.applyFrame.apply': 'Brug på denne side',
  'postPurchase.applyFrame.inventory': 'Gå til Min samling',
  'postPurchase.applyFrame.skip': 'Spring over nu',
  // Inventar hurtigbrug
  'inventory.applyFrame': 'Brug den nu',
  'inventory.applyFrame.select': 'Vælg en person',
  'inventory.applyFrame.open': 'Åbn siden',
  'inventory.apply.select': 'Vælg en person',
  'inventory.apply.button.frame': 'Brug cirklen nu',
  'inventory.apply.button.candle': 'Tænd lyset nu',
  'inventory.apply.button.default': 'Brug dette nu',
  'inventory.apply.title.frame': 'Hvem skal have cirklen?',
  'inventory.apply.title.candle': 'Hvem tænder du lyset for?',
  'inventory.apply.title.default': 'Brug dit køb med det samme',
  'inventory.apply.link.store': 'Find et nyt lys i butikken',
  'inventory.buyMore.frame': 'Find en ny cirkel',
  'inventory.buyMore.candle': 'Find et nyt lys',
  'inventory.buyMore.default': 'Find noget nyt',
  grave_candles_light_now: 'Tænd lyset for {name}',
  grave_candles_browse_store: 'Find et nyt lys',
  cover_photo_adjust_hint: 'Juster billedet til det føles rigtigt',
  cover_photo_drag_hint: 'Træk for at justere',
  cover_photo_reset: 'Nulstil udsnit',
  frame_apply_success: 'Ramme anvendt',
  frame_apply_failed: 'Kunne ikke anvende rammen',
  remove_grave_frame: 'Fjern profilramme',
  frame_remove_success: 'Rammen blev fjernet',
  frame_remove_failed: 'Kunne ikke fjerne rammen',
  'create_group.invite.title': 'Invite friends (optional)',
  'create_group.invite.placeholder_name': 'Enter name or email',
  'create_group.invite.placeholder_msg': 'Write message',
  loading: 'Loading…',
  'per_page.label': 'Per page',
  'notifications.group_invite.eyebrow': 'Gruppeinvitation',
  'notifications.group_invite.title': '{inviterName} inviterede dig til {groupName}',
  'notifications.group_invite.body': 'Accepter invitationen for at deltage i gruppesamtalen.',
  'notifications.group_invite.accepted': 'Gruppeinvitationen er accepteret.',
  'notifications.group_invite.declined': 'Gruppeinvitationen er afvist.',
  'notifications.group_invite.action_error': 'Kunne ikke opdatere gruppeinvitationen.',
  'notifications.group_join_request.eyebrow': 'Anmodning om gruppemedlemskab',
  'notifications.group_join_request.title':
    '{requesterName} anmodede om at blive medlem af {groupName}',
  'notifications.group_join_request.accepted': 'Anmodningen om gruppemedlemskab er godkendt.',
  'notifications.group_join_request.declined': 'Anmodningen om gruppemedlemskab er afvist.',
  'notifications.group_join_request.action_error':
    'Kunne ikke opdatere anmodningen om gruppemedlemskab.',
  'groups.accept.working': 'Accepting your invitation…',
  'groups.accept.ok': 'You’ve joined the group.',
  'groups.accept.view': 'Go to group',
  'groups.accept.fail': 'Invite is invalid or expired.',
  'groups.accept.back': 'Back to groups',
  'groups.accept.title': 'Gruppeinvitation',
  'groups.accept.loading': 'Indlæser invitation...',
  'groups.accept.auth_required': 'Log ind eller opret en konto for at se gruppeinvitationen.',
  'groups.accept.member_count': '{count, plural, one {# medlem} other {# medlemmer}}',
  'groups.accept.invite_label': 'Gruppeinvitation',
  'groups.members.label': 'Dem der er med: {count}',
  'groups.confirm.delete': 'Delete this group?',
  'groupDetails.loading': 'Loading group…',
  'groupDetails.error': 'Error loading group',
  'groupDetails.edit': 'Rediger rum',
  'groups.banner.join': 'Bliv medlem',
  'groups.banner.request_join': 'Anmod om at deltage',
  'groups.banner.joined': 'Medlem',
  'groups.files.empty': 'Ingen filer endnu.',
  'groups.join.unavailable': 'At blive medlem kræver invitation eller ejerens godkendelse.',
  'groups.join.success': 'Du er blevet en del af rummet.',
  'groups.leave': 'Forlad rummet',
  'groups.leave.confirm': 'Forlad denne gruppe?',
  'groups.leave.success': 'Du har forladt rummet.',
  'groups.leave.unavailable': 'Kunne ikke forlade gruppen.',
  'groupDetails.form.name': 'Name',
  'groupDetails.form.description': 'Description',
  'groupDetails.form.category': 'Category',
  'groupDetails.addMember.title': 'Invitér til rum',
  'groupDetails.addMember.searchLabel': 'Invitér person (søg på navn)',
  'groupDetails.addMember.placeholder': 'Search users…',
  'groupDetails.addMember.selected': 'Selected',
  'groupDetails.addMember.selectedId': 'Selected user ID:',
  'groupDetails.addMember.role': 'Role',
  'groupDetails.addMember.status': 'Status',
  'groupDetails.addMember.submit': 'Invitér',
  'groupDetails.addMember.loadMore': 'Load more',
  'groupDetails.members.title': 'Members',
  'groupDetails.members.empty': 'No members yet.',
  'groupDetails.members.table.id': 'ID',
  'groupDetails.members.table.user': 'User',
  'groupDetails.members.table.role': 'Role',
  'groupDetails.members.table.status': 'Status',
  'groupDetails.members.table.actions': 'Actions',
  'groupDetails.members.remove': 'Remove',
  'groupDetails.confirm.remove': 'Remove member?',
  'groupDetails.categoryPrefix': 'Category: {name}',
  'groupDetails.fallbackTitle': 'Group #{id}',
  create_grave_validation_full_date_required: 'Vælg år, måned og dag',
  create_grave_date_help: 'Vælg år, derefter måned og dag',
  'nav.sparks': 'Skab Gnist',
  'nav.my_family': 'Familietræ',
  'nav.home': 'Hjem',
  'nav.groups': 'Rum',
  'rooms.navigation.unread_label':
    'Rum, {count, plural, one {# ulæst besked} other {# ulæste beskeder}}',
  'rooms.mine.navigation.unread_label':
    'Mine rum, {count, plural, one {# ulæst besked} other {# ulæste beskeder}}',
  'rooms.inbox.muted': 'Notifikationer er slået fra',
  'rooms.inbox.room_unread_label':
    '{count, plural, one {# ulæst besked} other {# ulæste beskeder}}',
  'nav.familyTree': 'Stamtræ',
  'nav.graves': 'Mine grave',
  'nav.store': 'Nærvær',
  'nav.primary': 'Primær navigation',
  'nav.mobile_graves': 'Grave',
  'header.openMessages': 'Åbn beskeder',
  'messenger.searchPlaceholder': 'Søg i samtaler',
  'messenger.newConversation': 'Ny samtale',
  'messenger.loading': 'Indlæser samtaler…',
  'messenger.error': 'Vi kunne ikke indlæse dine beskeder.',
  'messenger.emptyState': 'Ingen samtaler endnu. Start en samtale for at holde kontakten.',
  'messenger.selectThread': 'Vælg en samtale for at se beskeder.',
  'messenger.emptyMessages': 'Ingen beskeder endnu. Sig hej for at komme i gang.',
  'messenger.attach': 'Vedhæft fil',
  'messenger.emoji': 'Indsæt emoji',
  'messenger.send': 'Send',
  'messenger.call': 'Start opkald',
  'messenger.typing': 'Skriver…',
  'messenger.online': 'Online',
  'messenger.status.online': 'Online',
  'messenger.status.offline': 'Offline',
  'messenger.status.lastSeen': 'Sidst set {time}',
  'messenger.status.group': 'Gruppechat',
  'messenger.status.groupCount': '{online} af {total} online',
  'messenger.loadingContacts': 'Indlæser kontakter…',
  'messenger.errorContacts': 'Vi kunne ikke indlæse dine kontakter.',
  'messenger.noContacts':
    'Ingen relationer fundet endnu. Tilføj relationer for at starte en samtale.',
  'messenger.conversations': 'Samtaler',
  'messenger.status.live': 'Live',
  'messenger.status.reconnecting': 'Forbinder igen…',
  'messenger.status.connecting': 'Forbinder…',
  'messenger.loadOlder': 'Hent ældre beskeder',
  'messenger.decryptionFailed': 'Beskeden kunne ikke dekrypteres.',
  'messenger.encryptedPlaceholder': '🔒 Krypteret besked afventer synkronisering…',
  'messenger.mls.syncingEncryption': 'Synkroniserer kryptering… (prøver igen)',
  'messenger.mls.pendingSync': 'Synkroniserer krypterede beskeder…',
  'messenger.mls.notEnabled': 'Denne chat understøtter ikke MLS. Start en ny krypteret samtale.',
  'messages.title': 'Messages',
  'messages.search': 'Search conversations',
  'messages.new.title': 'Start a conversation',
  'messages.new.recipient': 'Recipient ID',
  'messages.new.subject': 'Subject (optional)',
  'messages.new.start': 'Start',
  'messages.empty': 'No conversations yet',
  'messages.empty.hint': 'Start one from the form on the left.',
  'messages.list.unread': 'Unread',
  'messages.list.open': 'Open',
  'messages.thread.title': 'Conversation',
  'messages.thread.loading': 'Loading messages…',
  'messages.thread.error': 'Could not load messages.',
  'messages.thread.placeholder': 'Write a message…',
  'messages.thread.send': 'Send',
  'pagination.prev': 'Forrige',
  'pagination.next': 'Næste',
  'error.generic': 'Something went wrong.',
  'sparks.weeklyQuestion.title': 'Ugens spørgsmål',
  'sparks.weeklyQuestion.body':
    'Hvad hjælper dig med at føle dig mest forbundet med dem, du har mistet?',
  'sparks.weeklyQuestion.answerCta': 'Skab en Gnist',
  'sparks.composer.open': 'Skab en Gnist',
  'sparks.topics.title': 'Emner',
  'sparks.topics.empty': 'Ingen emner endnu.',
  'sparks.highlights.title': 'Højdepunkter',
  'sparks.highlights.empty': 'Ingen højdepunkter endnu.',
  'sparks.feed.empty': 'Ingen gnister endnu.',
  'sparks.filters.title': 'Filtre',
  'sparks.filters.newest': 'Nyeste',
  'sparks.filters.mostActive': 'Mest aktive',
  'sparks.filters.stars': 'Stjerner',
  'sparks.filters.open': 'Filtre og emner',
  'sparks.quote.title': 'En tanke i dag',
  'sparks.quote.loading': 'Finder dagens tanke…',
  'sparks.quote.empty': 'Hvad nu hvis livet handler om at gøre verden lidt bedre for nogen?',
  'sparks.suggestions.title': 'Forslag',
  'sparks.suggestions.empty': 'Ingen forslag endnu.',
  'sparks.rooms.title': 'Rum for det, vi har til fælles',
  'sparks.rooms.body':
    'Mød mennesker, der kan genkende det, som betyder noget for dig. Del erfaringer, find støtte, og udforsk det, I er optaget af.',
  'sparks.rooms.cta': 'Udforsk Rum',
  spark_submit_error: 'Der opstod en fejl under publiceringen. Prøv igen.',
  media_uploaded: 'Upload fuldført',
  search_set_relation_title: 'Find graven for at angive din relation',
  filter_graves: 'Filtrer grave',
  country: 'Land',
  municipality: 'Kommune',
  search_placeholder: 'Søg efter navn',
  clear: 'Ryd',
  set_relation: 'Vælg din relation',
  go_to_grave: 'Gå til graven',
  relation_confirmed: 'Relation bekræftet',
  relation_waiting_for_approval: 'Relation afventer godkendelse',
  relation_modal_title: 'Angiv relation',
  relation_modal_desc: 'Vælg begge sider af relationen. Vi gemmer, når begge er valgt.',
  their_relation_to_you: 'Deres relation til dig',
  your_relation_to_them: 'Din relation til dem',
  optional_note: 'Valgfri note',
  relation_note_placeholder: 'Tilføj en kort note eller et minde (valgfrit)',
  bond_saved_confirmation: 'Relationen gemmes: {a} og {b}.',
  select_both_relations_hint: 'Vælg begge relationer for at fortsætte.',
  save_relation: 'Gem relation',
  cancel: 'Annuller',
  results_count_one: 'Viser {count} resultat',
  results_count_other: 'Viser {count} resultater',
  search_grave_results_one: '{count} grav fundet',
  search_grave_results_other: '{count} resultater',
  search_grave_load_more: 'Vis flere grave',
  spark_feeling_tooltip_reflecting: 'Gå med refleksion i stilhed.',
  spark_feeling_tooltip_freedom: 'Stå med frihed, åben og frygtløs.',
  spark_feeling_tooltip_wonder: 'Se med forundring, øjne åbne og nye.',
  spark_feeling_tooltip_gratitude: 'Lev med taknemmelighed, og nævn det gode.',
  spark_feeling_tooltip_peace: 'Hvil i fred, blødt nærvær for hjertet.',
  spark_feeling_tooltip_hopeful: 'Gå med håb mod det, der kommer.',
  spark_feeling_tooltip_connection: 'Vær med andre i delt bånd.',
  spark_category_question_description: 'Invitér andre til at undre med dig.',
  spark_category_story_description: 'Fortæl et øjeblik, som det skete.',
  spark_category_insight_description: 'Del en sandhed, du har lagt mærke til.',
  spark_category_feeling_description: 'Sæt ord på det, der er levende i dig nu.',
  spark_category_intention_description: 'Noget du planlægger eller ønsker at gøre.',
  'designSystem.timePicker.label.hour': 'Time',
  'designSystem.timePicker.label.minute': 'Minut',
  'designSystem.timePicker.label.period': 'Periode',
  'designSystem.timePicker.placeholder.hour': 'Vælg time',
  'designSystem.timePicker.placeholder.minute': 'Vælg minut',
  'designSystem.timePicker.placeholder.period': 'Vælg periode',
  'designSystem.timePicker.clear': 'Nulstil tidspunkt',
  'designSystem.timePicker.period.am': 'AM',
  'designSystem.timePicker.period.pm': 'PM',
  'designSystem.select.noResults': 'Ingen resultater',
  'designSystem.select.clear': 'Ryd valg',
  'designSystem.select.searchPlaceholder': 'Skriv for at søge',
  aunt_in_law_parent: 'Indgiftet tantes forælder',
  aunt_in_law_sibling: 'Indgiftet tantes søskende',
  aunt_in_law_sibling_daughter: 'Indgiftet tantes søskendes datter',
  aunt_in_law_sibling_daughter_daughter: 'Indgiftet tantes søskendes datters datter',
  brother_in_law_parent: 'Svogerens forælder',
  brother_in_law_sibling: 'Svogerens søskende',
  brother_in_law_sibling_son: 'Svogerens søskendes søn',
  brother_in_law_sibling_son_son: 'Svogerens søskendes søns søn',
  brother_in_law_son: 'Svogerens søn',
  father_in_law_parent: 'Svigerfars forælder',
  father_in_law_sibling: 'Svigerfars søskende',
  father_in_law_sibling_parent: 'Svigerfars søskendes forælder',
  father_in_law_sibling_sibling: 'Svigerfars søskendes søskende',
  father_in_law_sibling_sibling_son: 'Svigerfars søskendes søskendes søn',
  father_in_law_sibling_son: 'Svigerfars søskendes søn',
  father_in_law_sibling_son_son: 'Svigerfars søskendes søns søn',
  father_in_law_son: 'Svigerfars søn',
  father_parent_sibling_sibling: 'Fars forælders søskendes søskende',
  father_sibling_sibling: 'Fars søskendes søskende',
  father_sibling_sibling_son: 'Fars søskendes søskendes søn',
  first_cousin_once_removed_in_law: 'Indgiftet fætter/kusine én generation forskudt',
  grandfather_in_law: 'Svigerbedstefar',
  grandmother_in_law: 'Svigerbedstemor',
  mother_in_law_daughter: 'Svigermors datter',
  mother_in_law_parent: 'Svigermors forælder',
  mother_in_law_sibling: 'Svigermors søskende',
  mother_in_law_sibling_daughter: 'Svigermors søskendes datter',
  mother_in_law_sibling_daughter_daughter: 'Svigermors søskendes datters datter',
  mother_in_law_sibling_parent: 'Svigermors søskendes forælder',
  mother_in_law_sibling_sibling: 'Svigermors søskendes søskende',
  mother_in_law_sibling_sibling_daughter: 'Svigermors søskendes søskendes datter',
  mother_parent_sibling_sibling: 'Mors forælders søskendes søskende',
  mother_sibling_sibling: 'Mors søskendes søskende',
  parent_spouse: 'Forælders ægtefælle',
  sister_in_law_daughter: 'Svigerindens datter',
  sister_in_law_parent: 'Svigerindens forælder',
  sister_in_law_sibling: 'Svigerindens søskende',
  sister_in_law_sibling_daughter: 'Svigerindens søskendes datter',
  sister_in_law_sibling_daughter_daughter: 'Svigerindens søskendes datters datter',
  spouse_daughter: 'Ægtefælles datter',
  spouse_son: 'Ægtefælles søn',
  uncle_in_law_parent: 'Indgiftet onkels forælder',
  uncle_in_law_sibling: 'Indgiftet onkels søskende',
  uncle_in_law_sibling_son: 'Indgiftet onkels søskendes søn',
  uncle_in_law_sibling_son_son: 'Indgiftet onkels søskendes søns søn',
  'home_page.brand_name': 'Netgrav',
  'home_page.hero_title': 'Det, der binder os sammen',
  'home_page.hero_subtitle':
    'Netgrav samler menneskene, værdierne og historierne, der former et liv. Her kan du tage vare på det, der betyder noget, mens livet leves og for dem, der kommer efter.',
  'home_page.cta_my_light': 'Udforsk Mit lys',
  'home_page.cta_search_graves': 'Søg grave',
  'home_page.cta_create_grave': 'Opret en Netgrav',
  'home_page.cta_shop_frames': 'Til mærkedagen',
  'home_page.chip_invite_family': 'Familie',
  'home_page.chip_share_memory': 'Tro',
  'home_page.chip_light_candle': 'Håb',
  'home_page.chip_apply_frame': 'Kærlighed',
  'home_page.hero_pick_grave': 'Vælg en grav',
  'home_page.hero_select_details': 'Vælg for at se detaljer',
  'home_page.chip_anniversary_tomorrow': 'Jubilæum i morgen',
  'home_page.hero_quote': 'Hun lærte os, at kærlighed er noget, man gør, ikke bare føler.',
  'home_page.life_preview_label': 'Mit lys',
  'home_page.life_preview_title': 'Det vigtige fortjener en plads',
  'home_page.life_preview_body':
    'Et sted for det, du står for, menneskene omkring dig og det, du ønsker at give videre.',
  'home_page.life_preview_values_title': 'Det jeg står for',
  'home_page.life_preview_values_body': 'Værdier og ord, der fortæller noget om dig.',
  'home_page.life_preview_compass_title': 'Mit kompas',
  'home_page.life_preview_compass_body': 'Den retning, du ønsker at holde fast i.',
  'home_page.life_preview_people_title': 'Mine mennesker',
  'home_page.life_preview_people_body': 'Relationerne, der former dit liv.',
  'home_page.life_preview_after_title': 'Efter mig',
  'home_page.life_preview_after_body': 'Det, du ønsker, at andre skal vide en dag.',
  'home_page.life_preview_cta': 'Se, hvordan Mit lys fungerer',
  'home_page.btn_light_candle': 'Se lysene',
  'home_page.btn_add_memory': 'Skriv nogle ord',
  'home_page.btn_apply_frame': 'Livscirkler',
  'home_page.btn_invite_family': 'Invitér familie',
  'home_page.nearby_btn_light_candle': 'Besøg graven',
  'home_page.nearby_btn_add_memory': 'Skriv nogle ord',
  'home_page.nearby_btn_apply_frame': 'Livscirkler',
  'home_page.nearby_btn_invite_family': 'Tilføj billede',
  'home_page.graves_hub_title': 'Et gravsted, der altid er nær',
  'home_page.graves_hub_subtitle':
    'Netgrav er gratis for alle familier. Besøg gravstedet, når du vil, og bevar billeder, historier og minder sammen.',
  'home_page.people_care_for': 'Personer jeg bryder mig om',
  'home_page.people_add': '+ Tilføj',
  'home_page.placeholder_name': 'Ingeborg Larsen',
  'home_page.tag_new_memory': 'Nyt minde',
  'home_page.pick_grave': 'Vælg en grav',
  'home_page.select_to_view': 'Vælg for at se detaljer',
  'home_page.birthday_soon': 'Fødselsdag snart',
  'home_page.recent_updates': 'Seneste opdateringer',
  'home_page.updates_placeholder': 'Opdateringer eller påmindelser vises her.',
  'home_page.memorial_title': 'Hver person har en historie.',
  'home_page.memorial_subtitle':
    'På gravvæggen kan familie og venner samle billeder, ord og oplevelser. Sådan kan flere bidrage til historien om det menneske, graven repræsenterer.',
  'home_page.select_grave': 'Vælg en grav',
  'home_page.add_guardian': 'Tilføj værge',
  'home_page.invite_family_contribute': 'Invitér familien til at bidrage',
  'home_page.share_memory_prompt':
    'Del et billede, skriv nogle ord, eller vis at du har været her.',
  'home_page.btn_share_memory': 'Skriv på gravvæggen',
  'home_page.from_family': 'Fra familien',
  'home_page.family_quote':
    '“Hun lod altid lysene brænde om vinteren, så huset føltes varmt, når vi kom ind.”',
  'home_page.added_days_ago': 'Tilføjet for 3 dage siden',
  'home_page.explore_memorial': 'Udforsk {name}',
  'home_page.this_memorial': 'dette minde',
  'home_page.social_title': 'Bygget til livet mellem mennesker',
  'home_page.social_subtitle':
    'Netgrav samler samtaler, fællesskaber og det, vi ønsker at dele, på ét sted. For relationerne, vi bygger, mens vi lever, og nærheden, vi tager vare på gennem hele livet.',
  'home_page.social_chat_title': 'Samtaler, der holder mennesker nær',
  'home_page.social_chat_body':
    'Skriv, ring eller mød hinanden på video. Tal privat én til én, eller saml familie og venner i en gruppe.',
  'home_page.social_chat_security': 'Ende-til-ende-krypteret med hybrid post-kvantebeskyttelse.',
  'home_page.social_chat_cta': 'Åbn Chat',
  'home_page.social_rooms_title': 'Rum for det, vi har til fælles',
  'home_page.social_rooms_body':
    'Mød mennesker med erfaringer, interesser eller spørgsmål, der berører noget af det samme.',
  'home_page.social_rooms_cta': 'Udforsk Rum',
  'home_page.social_sparks_title': 'Skab Gnist',
  'home_page.social_sparks_body':
    'Del en tanke, en erfaring eller et spørgsmål. Noget lille for dig kan betyde meget for andre.',
  'home_page.social_sparks_cta': 'Udforsk Gnister',
  'home_page.store_title': 'Til en, du tænker på',
  'home_page.store_subtitle':
    'På Netgraven kan lys og cirkler give din tanke et personligt udtryk.',
  'home_page.store_description':
    'Vælg et lys til en mærkedag eller en cirkel, der fortæller noget om mennesket.',
  'home_page.store_quote':
    'En Netgrav rummer mere end navne og datoer. Den kan også fortælle om mennesket, relationerne og det, der stadig betyder noget.',
  'home_page.store_frames': 'Cirkler for livet',
  'home_page.store_candles': 'Lys til mærkedage',
  'home_page.store_view': 'Vis',
  'home_page.store_visit': 'Udforsk Nærvær',
  'home_page.reminders_title': 'Mærkedage, på din måde',
  'home_page.reminders_subtitle':
    'Netgrav samler mærkedagene for dem, du holder af, og hjælper dig med at være til stede, når det føles rigtigt.',
  'home_page.reminder_label_tomorrow': 'I morgen',
  'home_page.reminder_title_birthday': 'Ingeborgs fødselsdag',
  'home_page.reminder_body_birthday': 'En anledning til at mindes, på din egen måde.',
  'home_page.reminder_label_next_week': 'Næste uge',
  'home_page.reminder_title_visit': 'Tid til et besøg',
  'home_page.reminder_body_visit': 'Når det føles rigtigt at være til stede.',
  'home_page.reminder_action_visit': 'Tilpas tidspunktet, så det passer dig',
  'home_page.reminder_label_new': 'Nyt',
  'home_page.reminder_title_memory': 'Nyt billede fra Line',
  'home_page.reminder_body_memory':
    'Et nyt billede er delt. Når det tilføjes til graven, bliver det en del af historien, der varer.',
  'home_page.reminder_action_memory': 'Se minde',
  'home_page.family_title': 'Vi hører sammen gennem generationer',
  'home_page.family_subtitle':
    'Se relationerne mellem mennesker, bevar familiehistorien, og giv næste generation et sted at finde den.',
  'home_page.family_grandparents': 'Bedsteforældre',
  'home_page.family_linked_graves': 'I sammenhæng',
  'home_page.family_children': 'Børn',
  'home_page.family_living': 'I live og ihukommet',
  'home_page.family_open': 'Se familiesammenhængen',
  'home_page.family_beta': 'Beta',
  'home_page.why_title': 'Et menneske er mere end et navn på en grav',
  'home_page.why_subtitle':
    'Netgrav giver minder, relationer og historier et sted at leve videre. Gratis for alle familier.',
  'home_page.why_secure_title': 'For alle familier',
  'home_page.why_secure_body':
    'Alle skal kunne give dem, de har mistet, et meningsfuldt gravsted uanset økonomi eller bopæl.',
  'home_page.why_secure_item1': '',
  'home_page.why_secure_item2': '',
  'home_page.why_secure_item3': '',
  'home_page.why_connected_title': 'Bygget til nærhed',
  'home_page.why_connected_body':
    'Bevar minder sammen, hold kontakt med mennesker, og find fællesskab, når du har brug for det.',
  'home_page.why_connected_item1': '',
  'home_page.why_connected_item2': '',
  'home_page.why_connected_item3': '',
  'home_page.why_tools_title': 'Historien bliver',
  'home_page.why_tools_body':
    'Det, I samler i dag, giver kommende generationer et sted at finde menneskerne og historierne før dem.',
  'home_page.why_tools_item1': '',
  'home_page.why_tools_item2': '',
  'home_page.why_tools_item3': '',
  'home_page.why_footer_quote':
    '“Vi arbejder mod vores egen irrelevans — og det er det mest meningsfulde, vi ved at gøre.”',
  'home_page.why_footer_source': 'End of Time Center — forskning i liv, død og det, der varer',
  circle_description1:
    'Cirklerne bærer profilbilledet og giver et stille udtryk for personens værdier, personlighed og nærvær.',
  presence_description1: 'Du vælger graven, og lyset tændes dér.',
  presence_description2: 'For mange er lys en god måde at vise håb og møde tanker på.',
  new_home_page_store_description:
    'Netgrav er <link>End of Time Care</link> i praksis: omsorg, der ikke slutter, men fortsætter i de handlinger, vi gør for hinanden.',
  Mandag: 'Mandag',
  Tirsdag: 'Tirsdag',
  Onsdag: 'Onsdag',
  Torsdag: 'Torsdag',
  Fredag: 'Fredag',
  administrator: 'Administrator',
  administrator_access: 'Administratortilgang',
  auth_toNettgrav: 'til netgrav.dk',
  invited_person_name: 'Inviteret persons navn',
  relation_to_grave: 'Den inviteredes relation til {graveName}',
  relation_to_person: '{graveName}s relation til den inviterede',
  select_role: 'Vælg rolle',
  select_role_error: 'Vælg brugerrollen',
  user_name: 'Brugernavn',
  remove_members_warring:
    'Fjern {remainingNumber} flere medlemmer eller annuller deres invitationer (eller begge dele).',
  normal: 'Normal',
  invite_coming_soon: 'Invitationer kommer snart',
  family_tree_relation_kind_blood: 'Blodsbånd',
  family_tree_relation_kind_spouse: 'Ægtefælle',
  family_tree_relation_kind_in_law: 'Indgiftet',
  family_tree_relation_kind_step: 'Stedfamilie',
  family_tree_relation_kind_other: 'Andet',
  family_tree_relation_confidence_explicit: 'Eksplicit',
  family_tree_spouses_label: 'Ægtefæller',
  family_tree_sources_label: 'Kilder',
  family_tree_no_root: 'Vælg en person for at se relationerne.',
  family_tree_error: 'Vi kunne ikke indlæse dette slægtstræ. Prøv igen.',
  family_tree_self_label: 'Fokusperson',
  family_tree_no_self: 'Ingen fokusperson',
  family_tree_group_descendants: 'Efterkommere',
  family_tree_group_in_laws: 'Indgiftede',
  family_tree_group_empty: 'Intet at vise endnu.',
  family_tree_meta_summary: '{count} personer • radius {radius}',
  theme_name_familie: 'Familie',
  theme_name_skole: 'Skole',
  theme_name_arbeid: 'Arbejde',
  theme_name_kjaerlighet: 'Kærlighed',
  theme_name_minne: 'Minde',
  theme_name_natur: 'Natur',
  theme_name_tro: 'Tro/Håb',
  theme_name_fellesskap: 'Fællesskab',
  theme_name_annet: 'Andet',
  'groups.sidebar.quick': 'Rum du måske vil synes om',
  'groups.sidebar.quick.sub': 'Rum som er åbne og i brug.',
  'groups.categories.sub': 'Gennemse kategorier for at finde relevante rum hurtigere.',
  'groups.section.top': 'Udforsk rum',
  'groups.section.top.sub': 'Åbne rum du kan gå ind i nu.',
  'groups.section.mine.sub': 'Grupper du ejer eller deltager i.',
  'groups.section.suggested': 'Foreslået til dig',
  'groups.section.suggested.sub': 'Grupper der matcher din søgning og dine filtre.',
  'groups.section.new': 'Nye grupper',
  'groups.section.new.sub': 'Nyligt oprettede grupper du kan blive medlem af.',
  'groups.rules.placeholder': 'Én regel pr. linje',
  'groups.rules.empty': 'Ingen egne retningslinjer er tilføjet.',
  'groups.members.creator': 'Rumansvarlig',
  'groups.members.co_creators': 'Medansvarlige',
  'groups.members.send_message': 'Send besked',
  'groups.members.message_soon': 'Direkte beskeder fra rum kommer snart i End of Time-chatten.',
  'groups.members.make_creator': 'Gør til rumansvarlig',
  'groups.members.remove_from_group': 'Fjern fra rummet',
  'groups.members.turn_on_post_approval': 'Slå indlægs-godkendelse til',
  'groups.members.turn_off_post_approval': 'Slå indlægs-godkendelse fra',
  'groups.members.change_to_member_only': 'Skift til kun medlem',
  'groups.members.leave_group': 'Forlad rummet',
  'groups.members.cancel_at_period_end': 'Afsluttes ved slutningen af perioden',
  'groups.members.period_end_info':
    'Når fornyelse stoppes, beholder personen adgang indtil slutningen af den aktuelle periode.',
  'groups.members.make_creator.success': 'Rumansvarlig opdateret.',
  'groups.members.action_error': 'Kunne ikke opdatere medlem.',
  'groups.files.photos': 'Billeder',
  'groups.files.videos': 'Videoer',
  'groups.files.documents': 'Dokumenter',
  'groups.files.upload_photo': 'Upload billede',
  'groups.files.upload_video': 'Upload video',
  'groups.files.upload_document': 'Upload dokument',
  'groups.files.upload_success': 'Fil uploadet.',
  'groups.files.upload_error': 'Kunne ikke uploade fil.',
  'groups.files.upload_too_large': 'Filen er for stor. Maksimal størrelse er {size}.',
  'groups.files.delete_error': 'Kunne ikke slette fil.',
  'groups.files.delete_success': 'Filen er slettet.',
  'groups.files.type_tabs': 'Filtyper',
  'groups.files.open_photo': 'Åbn {name}',
  'groups.files.play_video': 'Afspil {name}',
  'groups.files.load_error.title': 'Filerne kunne ikke indlæses',
  'groups.files.load_error.text': 'Prøv igen om et øjeblik.',
  'groups.files.retry': 'Prøv igen',
  'groups.files.delete_confirm.title': 'Slet filen?',
  'groups.files.delete_confirm.text': '{name} fjernes permanent fra rummet.',
  'groups.files.loading': 'Indlæser filer...',
  'groups.files.photos.empty': 'Ingen billeder endnu.',
  'groups.files.videos.empty': 'Ingen videoer endnu.',
  'groups.files.documents.empty': 'Ingen dokumenter endnu.',
  'groups.files.sort': 'Sorter dokumenter',
  'groups.files.sort.newest': 'Nyeste',
  'groups.files.sort.name': 'Navn',
  'groups.files.view': 'Vis',
  'groups.files.download': 'Download',
  'groups.files.details': 'Detaljer',
  'groups.files.delete': 'Slet',
  'groups.files.action.view': 'Visning kommer snart.',
  'groups.files.action.download': 'Download bliver tilgængelig snart.',
  'groups.files.action.details': '{name} · {size} KB',
  'groups.subscribe.saved_methods': 'Gemte betalingsmetoder',
  'groups.subscribe.saved_methods.loading': 'Indlæser gemte metoder...',
  'groups.subscribe.saved_methods.none': 'Ingen gemte betalingsmetoder fundet.',
  'groups.subscribe.saved_methods.use_other': 'Brug en anden metode',
  'groups.subscribe.saved_methods.default': 'Standard',
  'groups.subscribe.next_step.saved':
    'Næste: vi bruger din gemte metode og fortsætter til sikker bekræftelse.',
  'groups.subscribe.next_step.vipps': 'Næste: du fortsætter i Vipps for at bekræfte medlemskabet.',
  'groups.subscribe.next_step.card': 'Næste: du fortsætter i Stripe for at bekræfte medlemskabet.',
  'groups.composer.placeholder': 'Del noget i rummet…',
  'groups.preview.author': 'Rumansvarlig',
  'groups.preview.just_now': 'lige nu',
  'groups.cta.post': 'Del',
  'groups.join.toPost': 'Bliv en del af rummet for at dele.',
  'groups.see_comments': 'Se samtalen',
  'groups.comments.create_error': 'Kunne ikke dele svaret.',
  'groups.comments.update_error': 'Kunne ikke opdatere svaret.',
  'groups.comments.delete_error': 'Kunne ikke slette svaret.',
  'groups.comments.delete.confirm': 'Slette svaret?',
  'groups.comments.delete.title': 'Slet svar',
  'groups.comments.delete.body': 'Svaret fjernes fra samtalen. Dette kan ikke fortrydes.',
  'groups.comments.placeholder': 'Skriv et svar...',
  'groups.comments.empty': 'Ingen svar endnu.',
  'groups.comments.post': 'Del',
  'groups.hide_comments': 'Skjul samtalen',
  'groups.post.pending': 'Deler...',
  'groups.post.awaiting_approval': 'Afventer godkendelse',
  'groups.post.create_error': 'Kunne ikke publicere indlægget. Prøv igen.',
  'groups.post.update_error': 'Kunne ikke opdatere indlægget.',
  'groups.post.delete.confirm': 'Slette indlægget?',
  'groups.post.delete_error': 'Kunne ikke slette indlægget.',
  'groups.post.delete.title': 'Slet indlæg',
  'groups.post.delete.body': 'Indlægget og svarene fjernes fra rummet. Dette kan ikke fortrydes.',
  'groups.post.share': 'Del',
  'groups.post.share_success': 'Linket til indlægget er kopieret.',
  'groups.post.share_error': 'Kunne ikke dele indlægget.',
  'groups.day.today': 'I dag',
  'groups.day.yesterday': 'I går',
  'groups.day.unknown': 'Tidligere',
  'groups.tabs.members': 'Dem der er med',
  'groups.tabs.requests': 'Forespørgsler',
  'groups.tabs.settings': 'Indstillinger',
  'groups.invite.sent': 'Invitation sendt.',
  'groups.banner.subscribe': 'Bliv en del af rummet',
  'groups.banner.support_with_price': 'Støt rummet - {price} NOK / md.',
  'groups.banner.supported_badge': 'Støttet rum',
  'groups.banner.supported_subtitle': 'Dette rum bæres af dem, der vælger at støtte det.',
  'groups.subscribe.title': 'Bliv en del af rummet',
  'groups.subscribe.header': 'Bliv en del af rummet',
  'groups.subscribe.cta': 'Bliv en del af rummet',
  'groups.subscribe.success': 'Adgangen er aktiv. Du er nu med i rummet.',
  'groups.framework.title': 'Sådan fungerer Rum',
  'groups.framework.subtitle': 'Netgrav-rammen gælder for alle rum.',
  'groups.framework.principle_1.title': 'Værdighed',
  'groups.framework.principle_1.body':
    'Vi møder hinanden med respekt. Ingen rangering. Ingen angreb.',
  'groups.framework.principle_2.title': 'Menneskelighed',
  'groups.framework.principle_2.body':
    'Vi skriver som mennesker. Ikke som roller. Ikke som brands.',
  'groups.framework.principle_3.title': 'Stilhed',
  'groups.framework.principle_3.body': 'Stilhed er tilladt. Ingen forventning om svar.',
  'groups.framework.principle_4.title': 'Ansvar',
  'groups.framework.principle_4.body':
    'Rumansvarlig holder rummet trygt, men ejer det ikke som magt.',
  'groups.suggested_members': 'Forslag til hvem du kan invitere',
  'groups.paid.why.body':
    'Rum giver mennesker mulighed for at bruge deres erfaring og viden til at støtte andre og skabe bæredygtighed i det arbejde.',
  'groups.subscribe.saved_method.invalid':
    'Den gemte betalingsmetode er ikke længere gyldig. Vælg en anden metode og prøv igen.',
  'admin.group_moderation.approve': 'Godkend',
  'admin.group_moderation.category.paid': 'Godkendelse af betalt værelse',
  'admin.group_moderation.category.report': 'Rapporteret værelse',
  'admin.group_moderation.empty': 'Der er ikke flere.',
  'admin.group_moderation.filter.all': 'Alle sammen.',
  'admin.group_moderation.filter.paid': 'Betalte godkendelser',
  'admin.group_moderation.filter.reports': '- Bestyrelsesformand Wesker. - Status? Javel.',
  'admin.group_moderation.filter.unread': 'Ulæst',
  'admin.group_moderation.mark_read': 'Markér som læst',
  'admin.group_moderation.mark_unread': 'Markér som ulæst',
  'admin.group_moderation.meta.group': 'ROM',
  'admin.group_moderation.meta.reason': 'Årsag',
  'admin.group_moderation.meta.reporter': 'Whistleblower',
  'admin.group_moderation.note_placeholder': 'Valgfri note (påkrævet i tilfælde af afvisning).',
  'admin.group_moderation.open_group': 'Åbne rum',
  'admin.group_moderation.refresh': 'Opdater',
  'admin.group_moderation.reject': 'Afslået',
  'admin.group_moderation.reject_note_required': 'Tilføj en afvisningsbesked, før du afviser.',
  'admin.group_moderation.resolution.at': 'Tidspunkt',
  'admin.group_moderation.resolution.by': 'AV',
  'admin.group_moderation.resolution.note': 'Bemærk: %d (dags dato).',
  'admin.group_moderation.resolution.placeholder': 'Løsningsnotat (valgfrit).',
  'admin.group_moderation.search': 'Søg efter rum, årsag eller advarsler',
  'admin.group_moderation.state.pending': '- Vi holder os klar.',
  'admin.group_moderation.state.resolved': '- Når det ikke er sat op.',
  'admin.group_moderation.subtitle': 'Administrer rapporter og godkendelser for betalte værelser.',
  'admin.group_moderation.summary.total': 'I alt',
  'admin.group_moderation.summary.unread': 'Ulæst',
  'admin.group_moderation.summary.visible': 'Synlig',
  'admin.group_moderation.nav': 'Rummoderering',
  'admin.group_moderation.title': 'Rummoderering',
  'create_group.intro': 'Åbn et rum med en tydelig retning.',
  'create_group.audience.label': 'Hvem er dette rum til?',
  'create_group.audience.placeholder': 'Beskriv hvem der skal føle sig hjemme i dette rum.',
  'create_group.audience.required': 'Tilføj hvem rummet er til.',
  'create_group.safety_intent.label': 'Hvordan vil du holde rummet trygt?',
  'create_group.safety_intent.placeholder': 'Skriv et par linjer om tone, grænser og omsorg.',
  'create_group.safety_intent.hint':
    'Til din egen afklaring, når du åbner rummet. Dette vises ikke offentligt.',
  'create_group.life_category.grief': 'Sorg',
  'create_group.life_category.life_choices': 'Livsvalg',
  'create_group.life_category.relationships': 'Relationer',
  'create_group.life_category.health': 'Sundhed',
  'create_group.life_category.existence': 'Eksistens',
  'create_group.life_category.guidance': 'Vejledning',
  'create_group.life_category.other': 'Andet',
  'create_group.invite.info': 'Inviter nogen ind i rummet',
  'create_group.invite.sent_count': '{count} invitationer sendt',
  'create_group.tip.name': 'Giv rummet et tydeligt navn',
  'create_group.tip.visibility': 'Hvem kan se rummet?',
  'create_group.visibility': 'Synlighed',
  'create_group.visibility.closed': 'Lukket rum',
  'create_group.visibility.closed_desc':
    'Rummet er synligt, men du skal inviteres eller godkendes for at blive medlem.',
  'create_group.visibility.private': 'Privatkabinet?',
  'create_group.visibility.private_desc':
    'Rummet er skjult for andre. Kun inviterede medlemmer kan se og deltage.',
  'create_group.visibility.public': 'Åbent rum',
  'groupDetails.confirm.remove.ok': 'Fjern',
  'groupDetails.confirm.remove.title': 'Fjern fra rummet',
  'groupDetails.unavailable': '- Ikke ledigt.',
  'groups.about.empty': 'Ingen beskrivelse',
  'groups.aria.invite_name': 'Inviter {name}',
  'groups.banner.members': '{count, number} medlemmer · {posts, number} indlæg/dag',
  'groups.composer.helper': 'Del nogle ord, et billede eller en video i rummet.',
  'groups.section.about.title': 'Om rummet',
  'groups.section.about.text': 'Se beskrivelsen, rammerne og hvem der holder rummet.',
  'groups.section.members.title': 'Mennesker i rummet',
  'groups.section.members.text': 'Se hvem der er med, og invitér flere når det passer.',
  'groups.section.files.title': 'Billeder, videoer og dokumenter',
  'groups.section.files.text': 'Alt der er delt i rummet, samlet ét sted.',
  'groups.section.requests.title': 'Ventende anmodninger',
  'groups.section.requests.text': 'Gennemgå medlems- og indlægsanmodninger her.',
  'groups.section.settings.title': 'Rumindstillinger',
  'groups.section.settings.text': 'Juster synlighed, rammer og hvordan rummet fungerer.',
  'groups.tabs.mobile_nav': 'Rumsektion',
  phone_number: 'Telefonnummer',
  'groups.banner.members_only': '{count, number} medlemmer',
  'groups.banner.default_subtitle': 'Et rum til rolige samtaler.',
  'groups.banner.held_by': 'Holdes af {name}',
  'groups.comments.load_more': 'Vis mere',
  'groups.cta.invite': 'Invitér',
  'groups.edit.name_required': 'Værelsesnavn er påkrævet.',
  'groups.edit.no_changes': 'Ingen ændringer',
  'groups.edit.save_error': 'Kunne ikke gemme rumoplysninger.',
  'groups.edit.saved': 'Rumoplysninger gemt.',
  'groups.invite': 'Invitér',
  'groups.invite.subtitle': 'Inviter folk ind i dette rum',
  'groups.invite.title': 'Inviter medlemmer',
  'groups.join.request_sent': 'Anmodning sendt. Afventer godkendelse.',
  'groups.joined': 'Du er kommet ind i rummet.',
  'groups.quiet.cta': 'Sæt rummet i stille tilstand',
  'groups.quiet.active': 'Rummet er stille',
  'groups.quiet.confirm': 'Sætte dette rum i stille tilstand for nu?',
  'groups.quiet.enabled': 'Rummet er nu stille i en periode.',
  'groups.quiet.notice': 'Rummet er stille for nu.',
  'groups.members': 'Dem, der er med',
  'groups.members.empty': 'Ingen medlemmer endnu.',
  'groups.members.no_results': 'Ingen medlemmer matcher din søgning.',
  'groups.members.actions': 'Medlemshandlinger',
  'groups.members.owner_admin': 'Ejer/administrator',
  'groups.members.see_all': 'Se alle',
  'groups.mine.feed.empty': 'Ingen samtaler endnu.',
  'groups.mine.feed.sub': 'Nye opslag fra rum, du er en del af.',
  'groups.mine.feed.title': 'Seneste aktivitet',
  'groups.paid.approval.approve': 'Godkend',
  'groups.paid.approval.approved': 'Betalt værelse godkendt.',
  'groups.paid.approval.note_placeholder': 'Bemærk (vist til rumansvarlig/administrator).',
  'groups.paid.approval.reject': 'Afslået',
  'groups.paid.approval.reject_note': 'Tilføj først en afvisningsnotat.',
  'groups.paid.approval.rejected': 'Betalt værelse afvist.',
  'groups.paid.approval.request': 'Anmod om en gennemgang',
  'groups.paid.approval.requested': 'Betalt værelsesvurdering er blevet sendt.',
  'groups.paid.awaiting_approval': 'Afventer godkendelse',
  'groups.paid.connect_cta': 'Forbind til betalinger',
  'groups.paid.connect_hint': 'Opret forbindelse til betalinger for at aktivere betalt plads.',
  'groups.paid.connect_required':
    'Opret forbindelse til betalinger, før du aktiverer betalt plads.',
  'groups.paid.details.audience': 'Målgruppe:',
  'groups.paid.details.audience.hint': 'Hvem er dette rum til?',
  'groups.paid.details.audience.placeholder':
    'For personer, der ønsker struktureret støtte og ugentlig opfølgning.',
  'groups.paid.details.benefits': 'Fordele',
  'groups.paid.details.benefits.hint': 'Hvad får medlemmerne?',
  'groups.paid.details.benefits.placeholder':
    'Månedlige live-udsendelser, praktiske øvelser, direkte feedback...',
  'groups.paid.details.refund': 'Refusion ',
  'groups.paid.details.refund.hint': 'Beskriv refusionspolitikker',
  'groups.paid.details.refund.placeholder':
    'Slut når som helst. Adgang gælder i den betalte periode.',
  'groups.paid.details.title': 'Detaljer om betalte værelser',
  'groups.paid.details_required':
    'Tilføj medlemsfordele og hvem rummet er til, før du opretter et betalt rum.',
  'groups.paid.enabled_hint': 'Sæt en månedlig pris fra {min} til {max} NOK.',
  'groups.paid.enabled_hint_currency': 'Sæt en månedlig pris fra {min} til {max} {currency}.',
  'groups.paid.onboarding_note': 'Betalte værelser bliver synlige efter godkendelse.',
  'groups.paid.preview.net': 'Net til rumadministrator',
  'groups.paid.preview.platform': 'Netto gravandel',
  'groups.paid.preview.price': 'Pris',
  'groups.paid.preview.stripe': 'Stripe-gebyr',
  'groups.paid.preview.title': 'Prisoversigt',
  'groups.paid.price_range': 'Prisen skal være mellem {min} og {max} NOK.',
  'groups.paid.price_range_currency': 'Prisen skal være mellem {min} og {max} {currency}.',
  'groups.paid.why.cta': 'Læs mere om betalte værelser',
  'groups.paid.why.point_1': 'Sæt en månedlig pris, der passer til din målgruppe.',
  'groups.paid.why.point_2': 'Giv medlemmerne klare fordele og opfølgning.',
  'groups.paid.why.point_3': 'Foretag sikre betalinger med Vipps eller kort.',
  'groups.paid.why.title': 'Hvorfor betalte værelser?',
  'groups.payout_mode': 'Udbetalingstilstand',
  'groups.payout_mode.automatic': 'Automatisk via Stripe',
  'groups.payout_mode.automatic.hint':
    'Kræver Stripe Connect. Udbetaling går automatisk til din konto.',
  'groups.payout_mode.manual': 'Manuel via Netgrav',
  'groups.payout_mode.manual.hint':
    'Du behøver ikke Stripe. Netgrav opkræver betaling og udbetaler månedligt.',
  'groups.photos.recent': 'Nylige billeder',
  'groups.photos.see_all': 'Se alle',
  'groups.photos.add': 'Tilføj billede',
  'groups.photos.loading': 'Indlæser billeder...',
  'groups.photos.load_error': 'Billederne kunne ikke indlæses.',
  'groups.photos.empty': 'Der er endnu ikke delt nogen billeder.',
  'groups.invite.search_label': 'Søg efter personer',
  'groups.invite.search_hint': 'Skriv mindst to tegn for at søge.',
  'groups.invite.searching': 'Søger...',
  'groups.invite.no_results': 'Ingen personer fundet.',
  'groups.post.upload_error': 'Mediematerialet kunne ikke uploades. Prøv igen.',
  'groups.posting': 'Indlæg',
  'groups.report.cta': 'Rapportér',
  'groups.report.details': 'Detaljer (valgfrit)',
  'groups.report.details.placeholder':
    'Tilføj kontekst, der hjælper administratoren med at vurdere hurtigt.',
  'groups.report.reason': 'Årsag',
  'groups.report.reason.abuse': 'Chikane eller misbrug',
  'groups.report.reason.illegal': 'Ulovligt indhold',
  'groups.report.reason.other': 'Andet',
  'groups.report.reason.spam': 'Spam eller svindel',
  'groups.report.submit': 'Send rapport',
  'groups.report.success': 'Tak. Din rapport er modtaget.',
  'groups.report.title': 'Rapportér rum',
  'groups.post.report': 'Rapportér opslag',
  'groups.post.report.title': 'Rapportér opslag',
  'groups.requests.action_error': 'Anmodningen kunne ikke opdateres.',
  'groups.requests.confirm': 'Godkend',
  'groups.requests.decline': 'Afvis',
  'groups.requests.member_empty': 'Ingen medlemsanmodninger.',
  'groups.requests.member_title': 'Medlemsanmodninger',
  'groups.requests.post_empty': 'Ingen opslag venter på godkendelse.',
  'groups.requests.post_title': 'Anmodninger om indlæg',
  'groups.requests.load_error.title': 'Anmodningerne kunne ikke indlæses',
  'groups.requests.load_error.text': 'Prøv igen om et øjeblik.',
  'groups.requests.retry': 'Prøv igen',
  'groups.requests.member.requested': 'Anmodede om adgang {time}',
  'groups.requests.attachment': 'Åbn vedhæftet fil',
  'groups.requests.member.approve_success': 'Medlemsanmodningen er godkendt.',
  'groups.requests.member.decline_success': 'Medlemsanmodningen er afvist.',
  'groups.requests.post.approve_success': 'Opslaget er godkendt.',
  'groups.requests.post.decline_success': 'Opslaget er afvist.',
  'groups.requests.member.decline_title': 'Afvis medlemsanmodningen?',
  'groups.requests.post.decline_title': 'Afvis opslaget?',
  'groups.requests.member.decline_text': 'Anmodningen fra {name} bliver afvist.',
  'groups.requests.post.decline_text': 'Opslaget fra {name} bliver ikke offentliggjort.',
  'groups.read_more': 'Læs mere',
  'groups.show_less': 'Vis mindre',
  'groups.rules': 'Regler',
  'groups.settings.chat.admins': 'Kun administrator',
  'groups.settings.chat.members': 'Medlemmer og administratorer',
  'groups.settings.chat_permissions': 'Rumchatrettigheder',
  'groups.settings.chat.readonly_note': 'Rettigheder for rumchat er faste i denne version.',
  'groups.settings.membership.admins': 'Kun rumadministrator og medadministratorer',
  'groups.settings.membership.anyone': 'Alle i rummet',
  'groups.settings.membership_approval': 'Godkendelse af medlemskab',
  'groups.settings.membership.readonly_note':
    'Godkendelse af medlemskab følger rummets synlighed og invitationsflow.',
  'groups.settings.post_approval': 'Godkendelse af opslag',
  'groups.settings.post_approval.none': 'Ingen godkendelse',
  'groups.settings.post_approval.require': 'Alle opslag skal godkendes.',
  'groups.settings.posting.admins': 'Kun administrator',
  'groups.settings.posting.anyone': 'Alle i rummet',
  'groups.settings.posting_permissions': 'Rettigheder til offentliggørelse',
  'groups.settings.privacy': 'Privatliv',
  'groups.settings.cover': 'Rumbillede',
  'groups.settings.cover.empty': 'Intet rumbillede endnu.',
  'groups.settings.cover.upload': 'Upload rumbillede',
  'groups.settings.cover.remove': 'Fjern rumbillede',
  'groups.settings.cover.instant_save': 'Ændringer af rumbillede gemmes med det samme.',
  'groups.settings.cover.upload_success': 'Rumbilledet er opdateret.',
  'groups.settings.cover.upload_error': 'Kunne ikke uploade rumbillede.',
  'groups.settings.cover.remove_success': 'Rumbilledet er fjernet.',
  'groups.settings.cover.remove_error': 'Kunne ikke fjerne rumbillede.',
  'groups.settings.save_error': 'Indstillingerne kunne ikke gemmes.',
  'groups.settings.saved': 'Indstillinger gemt.',
  'groups.settings.room_status': 'Rumstatus',
  'groups.settings.room_status.active': 'Rummet er aktivt.',
  'groups.settings.unsaved.confirm':
    'Du har ændringer, der ikke er gemt. Vil du forlade siden uden at gemme?',
  'groups.settings.categories.loading': 'Indlæser kategorier...',
  'groups.settings.categories.empty': 'Ingen kategorier er tilgængelige.',
  'groups.settings.categories.error': 'Kategorierne kunne ikke indlæses.',
  'groups.settings.categories.retry': 'Prøv igen',
  'groups.settings.current_rules': 'Sådan fungerer rummet',
  'groups.settings.current_rules.hint': 'En oversigt over de regler, der gælder i rummet nu.',
  'groups.settings.membership.public': 'Alle kan deltage',
  'groups.settings.membership.closed': 'Rumansvarlige godkender anmodninger',
  'groups.settings.membership.private': 'Kun via invitation',
  'groups.quiet.reactivate': 'Gør rummet aktivt',
  'groups.quiet.reactivate_confirm': 'Vil du gøre rummet aktivt igen?',
  'groups.quiet.disabled': 'Rummet er aktivt igen.',
  'groups.quiet.update_error': 'Rummets status kunne ikke opdateres.',
  'groups.subscribe.benefit_1': 'Eksklusivt indhold og opfølgning',
  'groups.subscribe.benefit_2': 'Trygt fællesskab med klare grænser',
  'groups.subscribe.benefit_3': 'Direkte støtte fra ansvarlige og vejledere',
  'groups.subscribe.breakdown': 'Oversigt',
  'groups.subscribe.card': 'Kort',
  'groups.subscribe.monthly': 'Månedlig støtte',
  'create_group.paid_price_currency': 'Månedlig pris ({currency})',
  'groups.subscribe.pending': 'Betalingen fuldføres. Opdater om et øjeblik.',
  'groups.subscribe.total': 'I alt',
  'groups.subscribe.local_estimate': 'Ca. {amount} i lokal valuta.',
  'groups.subscribe.cancel.cta': 'Afslut deltagelse',
  'groups.subscribe.cancel.success': 'Du er ikke længere med i rummet.',
  'groups.subscribe.vipps_info': 'Du bekræfter betalingen sikkert i Vipps.',
  'groups.subscribe.vipps_currency_note': 'Betaling via Vipps debiteres i NOK.',
  'groups.subscribe.vipps_unavailable_currency':
    'Vipps er ikke tilgængelig for denne valuta. Vælg kort.',
  'groups.tabs.about': 'Om',
  'groups.tabs.files': 'Filer',
  'groups.time.2h': '- Ja, for et øjeblik siden.',
  'admin.group_moderation.approve': 'Godkend',
  'messenger_v2.brand.title': 'End of Time',
  'messenger_v2.brand.beta': 'Beta',
  'messenger_v2.brand.tagline': 'Et sted for sandhed. Altid.',
  'messenger_v2.conversation.title': 'Samtaler',
  'messenger_v2.encryption.title': 'Ende-til-ende-krypteret',
  'messenger_v2.encryption.copy': 'Dine ord bliver mellem jer.',
  'messenger_v2.encryption.learn_more': 'Læs mere',
  'messenger_v2.presence.active_now': 'Aktiv nu',
  'messenger_v2.composer.truth_placeholder': 'Hvad er sandt lige nu?',
  'messenger_v2.message.reaction_failed': 'Reaktionen kunne ikke opdateres.',
  'messenger_v2.message.actions': 'Beskedhandlinger',
  'messenger_v2.message.react_with': 'Reager med {emoji}',
  'messenger_v2.message.reaction_count': '{emoji}, {count} reaktioner',
  'messenger_v2.message.commands': 'Beskedkommandoer',
  'messenger_v2.message.reactions': 'Reaktioner',
  'messenger_v2.message.reaction_all': 'Alle',
  'messenger_v2.message.reaction_details': 'Reaktionsdetaljer',
  'messenger_v2.message.reaction_filters': 'Reaktionsfiltre',
  'messenger_v2.message.reaction_people_unavailable':
    'Reaktionsdetaljer er ikke tilgængelige for denne besked.',
  'messenger_v2.message.click_to_remove': 'Klik for at fjerne',
  'messenger_v2.message.history_loading': 'Indlæser tidligere beskeder.',
  'messenger_v2.attachment.select': 'Vælg {name}',
  'messenger_v2.search.placeholder': 'Søg eller start en samtale',
  'messenger_v2.search.groups_placeholder': 'Søg i grupper',
  'messenger_v2.tabs.aria': 'Beskedsektioner',
  'messenger_v2.tabs.direct': 'Beskeder',
  'messenger_v2.tabs.groups': 'Grupper',
  'messenger_v2.groups.add_action': 'Tilføj',
  'messenger_v2.groups.add_members': 'Tilføj medlemmer',
  'messenger_v2.groups.add_members_short': 'Tilføj',
  'messenger_v2.groups.add_members_title': 'Tilføj medlemmer',
  'messenger_v2.groups.add_description': 'Tilføj gruppebeskrivelse',
  'messenger_v2.groups.contacts_loading': 'Kontakter indlæses.',
  'messenger_v2.groups.create': 'Opret gruppe',
  'messenger_v2.groups.create_action': 'Opret',
  'messenger_v2.groups.create_category_required': 'Gruppekategori er ikke tilgængelig endnu.',
  'messenger_v2.groups.create_name_required': 'Gruppenavn er påkrævet.',
  'messenger_v2.groups.create_new_group': 'Opret ny gruppe',
  'messenger_v2.groups.create_success': 'Gruppe oprettet.',
  'messenger_v2.groups.create_title': 'Opret gruppe',
  'messenger_v2.groups.description_label': 'Beskrivelse',
  'messenger_v2.groups.description_placeholder': 'Valgfrit',
  'messenger_v2.groups.details_updated': 'Gruppeoplysningerne er opdateret.',
  'messenger_v2.groups.edit_description': 'Rediger gruppebeskrivelse',
  'messenger_v2.groups.edit_group_picture': 'Rediger gruppebillede',
  'messenger_v2.groups.edit_name': 'Rediger gruppenavn',
  'messenger_v2.groups.empty': 'Ingen grupper matchede din søgning.',
  'messenger_v2.groups.error': 'Grupper kunne ikke indlæses.',
  'messenger_v2.groups.fallback': 'Gruppe',
  'messenger_v2.groups.choose_photo': 'Vælg foto',
  'messenger_v2.groups.delete_photo': 'Slet foto',
  'messenger_v2.groups.deleting_photo': 'Sletter foto...',
  'messenger_v2.groups.uploading_photo': 'Uploader...',
  'messenger_v2.groups.avatar_crop_failed': 'Billedet kunne ikke beskæres.',
  'messenger_v2.groups.avatar_read_failed': 'Billedet kunne ikke åbnes.',
  'messenger_v2.groups.avatar_owner_only': 'Kun gruppeopretteren kan opdatere gruppebilledet.',
  'messenger_v2.groups.avatar_updated': 'Gruppebilledet er opdateret.',
  'messenger_v2.groups.avatar_update_failed': 'Gruppebilledet kunne ikke opdateres.',
  'messenger_v2.groups.avatar_deleted': 'Gruppebilledet er slettet.',
  'messenger_v2.groups.avatar_delete_failed': 'Gruppebilledet kunne ikke slettes.',
  'messenger_v2.groups.loading': 'Grupper indlæses.',
  'messenger_v2.groups.update_failed': 'Gruppeoplysningerne kunne ikke opdateres.',
  'messenger_v2.groups.members_added': 'Medlemmer tilføjet.',
  'messenger_v2.groups.members_count': '{count} medlemmer',
  'messenger_v2.groups.members_label': 'Medlemmer',
  'messenger_v2.groups.leave_group': 'Forlad',
  'messenger_v2.groups.exit_group': 'Forlad gruppe',
  'messenger_v2.groups.exit_group_title': 'Forlad gruppe: "{name}"?',
  'messenger_v2.groups.exit_group_notice':
    'Kun administratorer får besked, når du forlader en gruppe.',
  'messenger_v2.groups.exit_and_delete_for_me': 'Forlad og slet for mig',
  'messenger_v2.groups.delete_group': 'Slet gruppe',
  'messenger_v2.groups.deleting_group': 'Sletter gruppe...',
  'messenger_v2.groups.delete_group_title': 'Slet gruppe "{name}"?',
  'messenger_v2.groups.delete_group_warning_body':
    'Denne gruppe fjernes fra din chatliste, og din lokale historik ryddes.',
  'messenger_v2.groups.group_deleted': 'Gruppen blev slettet fra din chatliste.',
  'messenger_v2.groups.delete_group_failed': 'Gruppen kunne ikke slettes.',
  'messenger_v2.groups.exiting_group': 'Forlader gruppe...',
  'messenger_v2.groups.left_group': 'Du forlod gruppen.',
  'messenger_v2.groups.left_group_notice':
    'Du forlod denne gruppe. Du kan se tidligere beskeder, men du kan ikke sende nye beskeder.',
  'messenger_v2.groups.member_removed': '{name} blev fjernet fra gruppen.',
  'messenger_v2.groups.member_remove_failed': 'Medlemmet kunne ikke fjernes.',
  'messenger_v2.groups.remove_member': 'Fjern',
  'messenger_v2.groups.removed_notice':
    '{actor} fjernede dig fra denne gruppe. Du kan se tidligere beskeder, men du kan ikke sende nye beskeder.',
  'messenger_v2.groups.access_removed_notice':
    'Du er ikke længere medlem af denne gruppe. Du kan se tidligere beskeder, men du kan ikke sende nye beskeder.',
  'messenger_v2.groups.removing_member': 'Fjerner...',
  'messenger_v2.groups.name_label': 'Navn',
  'messenger_v2.groups.name_placeholder': 'Familieopdateringer',
  'messenger_v2.groups.no_contacts': 'Ingen kontakter tilgængelige.',
  'messenger_v2.groups.no_contacts_to_add': 'Ingen kontakter tilgængelige at tilføje.',
  'messenger_v2.groups.no_messages': 'Ingen beskeder endnu',
  'messenger_v2.groups.save_failed': 'Gruppen kunne ikke gemmes.',
  'messenger_v2.groups.saving': 'Gemmer...',
  'messenger_v2.groups.select_member_required': 'Vælg mindst ét medlem.',
  'messenger_v2.groups.selected_count': '{count} valgt',
  'messenger_v2.groups.selected_fraction': '{selected}/{total}',
  'messenger_v2.groups.search_name_or_number': 'Søg efter navn eller nummer',
  'messenger_v2.groups.members_can_add': 'Alle medlemmer kan føje andre til denne gruppe.',
  'messenger_v2.groups.edit_group_permissions': 'Rediger gruppetilladelser.',
  'messenger_v2.groups.group_permissions': 'Gruppetilladelser',
  'messenger_v2.groups.invite_via_link': 'Inviter via link',
  'messenger_v2.groups.invite_via_link_qr': 'Inviter via link eller QR-kode',
  'messenger_v2.groups.frequently_contacted': 'Ofte kontaktet',
  'messenger_v2.groups.scroll_more_contacts': 'Rul for at indlæse flere',
  'messenger_v2.groups.remove_selected_member': 'Fjern {name}',
  'messenger_v2.groups.group_link': 'Gruppelink',
  'messenger_v2.groups.group_chat_invite': 'Gruppechatinvitation',
  'messenger_v2.groups.open_invite_link': 'Åbn dette link for at deltage i {name}.',
  'messenger_v2.groups.join_group': 'Deltag i gruppe',
  'messenger_v2.groups.invite_link_checking': 'Kontrollerer link...',
  'messenger_v2.groups.invite_link_expired': 'Linket er udløbet',
  'messenger_v2.groups.invite_link_unavailable': 'Gruppen er ikke tilgængelig',
  'messenger_v2.groups.invite_link_full': 'Gruppen er fuld',
  'messenger_v2.groups.invite_link_status_expired': 'Dette invitationslink er udløbet.',
  'messenger_v2.groups.invite_link_status_unavailable':
    'Denne gruppeinvitation er ikke længere tilgængelig.',
  'messenger_v2.groups.invite_link_status_full': 'Denne gruppe er fuld.',
  'messenger_v2.groups.view_group': 'Vis gruppe',
  'messenger_v2.groups.invite_link_loading': 'Indlæser link...',
  'messenger_v2.groups.invite_link_copied': 'Invitationslink kopieret.',
  'messenger_v2.groups.invite_link_copy_failed': 'Invitationslinket kunne ikke kopieres.',
  'messenger_v2.groups.invite_link_failed': 'Invitationslinket kunne ikke indlæses.',
  'messenger_v2.groups.invite_share_text': 'Deltag i {name}',
  'messenger_v2.groups.invite_share_text_with_link': 'Deltag i {name}: {url}',
  'messenger_v2.groups.share_via_chat': 'Del via chat',
  'messenger_v2.groups.send_to': 'Send til',
  'messenger_v2.groups.send_action': 'Send',
  'messenger_v2.groups.select_chat_recipients': 'Vælg chats',
  'messenger_v2.groups.invite_link_sent': 'Invitationslink sendt.',
  'messenger_v2.groups.invite_link_send_failed': 'Invitationslinket kunne ikke sendes.',
  'messenger_v2.groups.share_link': 'Del link',
  'messenger_v2.groups.share_link_short': 'Del',
  'messenger_v2.groups.copy_link': 'Kopiér link',
  'messenger_v2.groups.qr_code': 'QR-kode',
  'messenger_v2.groups.manage_permissions': 'Administrer tilladelser',
  'messenger_v2.groups.invite_approval_not_required':
    'Administratorgodkendelse er ikke nødvendig for at deltage. Medlemmer har adgang til dette link her.',
  'messenger_v2.groups.permissions_members_can': 'Medlemmer kan',
  'messenger_v2.groups.permission_edit_settings': 'Redigere gruppeindstillinger',
  'messenger_v2.groups.permission_edit_settings_desc':
    'Dette inkluderer gruppens navn, ikon, beskrivelse og avanceret chatprivatliv.',
  'messenger_v2.groups.permission_send_messages': 'Sende nye beskeder',
  'messenger_v2.groups.permission_add_members': 'Tilføje andre medlemmer',
  'messenger_v2.groups.permission_send_history': 'Sende beskedhistorik',
  'messenger_v2.groups.permission_send_history_desc':
    'Tillad medlemmer at sende tidligere beskeder til nye medlemmer.',
  'messenger_v2.groups.permission_invite_link': 'Invitere via link',
  'messenger_v2.groups.permissions_turning_off_hint':
    'Når disse indstillinger slås fra, kan kun gruppeadministratorer udføre handlingen.',
  'messenger_v2.groups.permissions_admins_can': 'Administratorer kan',
  'messenger_v2.groups.permission_approve_new_members': 'Godkende nye medlemmer',
  'messenger_v2.groups.permission_approve_new_members_desc':
    'Når dette er slået til, skal administratorer godkende alle, der vil deltage i gruppen.',
  'messenger_v2.groups.group_admins': 'Gruppeadministratorer',
  'messenger_v2.groups.edit_admins': 'Rediger administratorer',
  'messenger_v2.groups.admin': 'Admin',
  'messenger_v2.groups.available_member': 'Tilgængeligt medlem',
  'messenger_v2.groups.make_group_admin': 'Gør til gruppeadministrator',
  'messenger_v2.groups.dismiss_as_admin': 'Fjern som administrator',
  'messenger_v2.groups.remove_from_group': 'Fjern fra gruppe',
  'messenger_v2.groups.no_members_to_manage': 'Ingen medlemmer at administrere.',
  'messenger_v2.groups.admins_updated': 'Gruppeadministratorer opdateret.',
  'messenger_v2.groups.admin_update_failed': 'Administratorrollen kunne ikke opdateres.',
  'messenger_v2.groups.member_made_admin': '{name} er nu gruppeadministrator.',
  'messenger_v2.groups.member_dismissed_admin': '{name} er ikke længere gruppeadministrator.',
  'messenger_v2.groups.permissions_updated': 'Gruppetilladelser opdateret.',
  'messenger_v2.groups.permissions_update_failed': 'Gruppetilladelser kunne ikke opdateres.',
  'messenger_v2.groups.no_longer_member_status': 'Ikke længere medlem',
  'messenger_v2.info.member_options': 'Medlemsindstillinger',
  'messenger_v2.common.search': 'Søg',
  'messenger_v2.conversation.group_fallback': 'Gruppesamtale',
  'messenger_v2.conversation.direct_fallback': 'Direkte samtale',
  'messenger_v2.conversation.new_message': 'Ny besked',
  'messenger_v2.conversation.no_content': 'Intet indhold',
  'messenger_v2.conversation.connection': 'Forbindelse',
  'messenger_v2.conversation.connections': 'Forbindelser',
  'messenger_v2.conversation.open': 'Åbn',
  'messenger_v2.conversation.open_failed': 'Samtalen kunne ikke åbnes.',
  'messenger_v2.conversation.opening': 'Åbner...',
  'messenger_v2.conversation.contacts_loading': 'Kontakter indlæses.',
  'messenger_v2.conversation.no_contacts_matched': 'Ingen kontakter matchede din søgning.',
  'messenger_v2.conversation.bootstrap_loading': 'Messenger starter.',
  'messenger_v2.conversation.none_yet': 'Ingen samtaler endnu. Start en fra kontaktlisten.',
  'messenger_v2.conversation.select_title': 'Vælg en samtale',
  'messenger_v2.conversation.select_copy':
    'Åbn en tråd fra venstre side, eller start en ny samtale med plusknappen.',
  'messenger_v2.conversation.show_contacts': 'Vis kontakter',
  'messenger_v2.conversation.show_conversations': 'Vis samtaler',
  'messenger_v2.presence.offline': 'Ikke online',
  'messenger_v2.presence.online': 'På nettet',
  'messenger_v2.presence.ready': 'Klar',
  'messenger_v2.presence.not_ready_yet': 'Ikke klar endnu',
  'messenger_v2.presence.group_online': '{onlineCount} af {totalCount} er på nettet',
  'messenger_v2.presence.last_seen_today_at': 'Sidst set i dag kl. {time}',
  'messenger_v2.presence.last_seen_yesterday_at': 'Sidst set i går kl. {time}',
  'messenger_v2.presence.last_seen_date_at': 'Sidst set {date} kl. {time}',
  'messenger_v2.timeline.today': 'I dag',
  'messenger_v2.timeline.yesterday': 'I går',
  'messenger_v2.message.edited': 'Redigeret',
  'messenger_v2.message.edited_time': 'Redigeret {time}',
  'messenger_v2.message.read_more': 'Læs mere',
  'messenger_v2.message.show_less': 'Vis mindre',
  'messenger_v2.message.upload_failed': 'Upload mislykkedes',
  'messenger_v2.message.preparing_upload': 'Forbereder…',
  'messenger_v2.message.upload_progress': 'Uploader {progress} %',
  'messenger_v2.message.upload_paused_progress': 'Upload sat på pause ved {progress} %',
  'messenger_v2.message.retry_upload': 'Prøv upload igen',
  'messenger_v2.message.retry_send': 'Prøv at sende beskeden igen',
  'messenger_v2.message.retry_reaction': 'Prøv at sende reaktionen igen',
  'messenger_v2.message.retry_failed': 'Beskeden kunne ikke sendes. Prøv igen.',
  'messenger_v2.message.reaction_retry_failed': 'Reaktionen kunne ikke sendes. Prøv igen.',
  'messenger_v2.message.pause_upload': 'Sæt upload på pause',
  'messenger_v2.message.pause': 'Pause',
  'messenger_v2.message.resume_upload': 'Fortsæt upload',
  'messenger_v2.message.resume': 'Fortsæt',
  'messenger_v2.attachment.upload_paused': 'Upload sat på pause: {name}',
  'messenger_v2.message.failed': 'Mislykkedes',
  'messenger_v2.message.read': 'Læst',
  'messenger_v2.message.delivered': 'Leveret',
  'messenger_v2.message.sent': 'Sendt',
  'messenger_v2.message.delete': 'Slet besked',
  'messenger_v2.message.delete_title': 'Slet besked?',
  'messenger_v2.message.delete_from': 'Slet besked fra {name}?',
  'messenger_v2.message.delete_everyone': 'Slet for alle',
  'messenger_v2.message.delete_me': 'Slet for mig',
  'messenger_v2.message.copy': 'Kopiér besked',
  'messenger_v2.attachment.copy': 'Kopiér vedhæftet fil',
  'messenger_v2.clipboard.copied': 'Kopieret',
  'messenger_v2.clipboard.retry': 'Prøv igen',
  'messenger_v2.message.edit': 'Rediger besked',
  'messenger_v2.message.clear_selection': 'Ryd markering',
  'messenger_v2.message.open_menu': 'Åbn beskedmenu',
  'messenger_v2.message.scroll_latest': 'Rul til nyeste besked',
  'messenger_v2.message.thread_loading': 'Trådhistorik indlæses.',
  'messenger_v2.conversation.unavailable_title': 'Samtalen er utilgængelig',
  'messenger_v2.conversation.unavailable_copy': 'Du har ikke længere adgang til denne samtale.',
  'messenger_v2.message.thread_empty': 'Der er endnu ikke indlæst beskeder i denne tråd.',
  'messenger_v2.message.thread': 'Samtaletråd',
  'messenger_v2.message.timeline': 'Beskeder i samtalen',
  'messenger_v2.message.encrypted_pending': 'Krypteret MLS-besked venter på, at runtime er klar.',
  'messenger_v2.message.edit_resolve_error':
    'Beskeden, der redigeres, kunne ikke findes. Åbn redigeringstilstand igen, og prøv igen.',
  'messenger_v2.message.reply': 'Svar',
  'messenger_v2.message.forward': 'Videresend',
  'messenger_v2.message.forwarded': 'Videresendt',
  'messenger_v2.forward.title': 'Videresend til',
  'messenger_v2.forward.preview_label': 'Videresender',
  'messenger_v2.forward.message_preview': 'Besked',
  'messenger_v2.forward.search': 'Søg i chats og forbindelser',
  'messenger_v2.forward.add_message': 'Tilføj en besked',
  'messenger_v2.forward.add_message_placeholder': 'Tilføj en besked...',
  'messenger_v2.forward.selected': 'Valgt',
  'messenger_v2.forward.not_selected': 'Ikke valgt',
  'messenger_v2.forward.loading': 'Indlæser chats og forbindelser...',
  'messenger_v2.forward.chats': 'Chats',
  'messenger_v2.forward.connections': 'Forbindelser',
  'messenger_v2.forward.no_targets': 'Ingen chats eller forbindelser fundet.',
  'messenger_v2.forward.loading_message': 'Indlæser besked...',
  'messenger_v2.forward.message_unavailable': 'Denne besked er ikke tilgængelig.',
  'messenger_v2.forward.send_failed': 'Beskeden kunne ikke videresendes.',
  'messenger_v2.forward.unavailable': 'Denne besked kan ikke videresendes endnu.',
  'messenger_v2.forward.sending_progress': 'Sender {completed} af {total}',
  'messenger_v2.forward.failed_count': '{count} mislykkedes',
  'messenger_v2.forward.selected_count': '{count} valgt',
  'messenger_v2.forward.retry_failed': 'Prøv mislykkede igen',
  'messenger_v2.forward.sent_count': 'Videresendt til {count} chats.',
  'messenger_v2.message.react': 'Reager',
  'messenger_v2.message.cancel_reply': 'Annuller svar',
  'messenger_v2.message.open_replied_message': 'Åbn besvaret besked',
  'messenger_v2.reply.photo': 'Billede',
  'messenger_v2.reply.photos_count': '{count} billeder',
  'messenger_v2.reply.video': 'Video',
  'messenger_v2.reply.videos_count': '{count} videoer',
  'messenger_v2.reply.audio': 'Lyd',
  'messenger_v2.reply.media_count': '{count} medier',
  'messenger_v2.reply.pages_count': '{count} sider',
  'messenger_v2.common.cancel': 'Annuller',
  'messenger_v2.common.back': 'Tilbage',
  'messenger_v2.common.close': 'Luk',
  'messenger_v2.common.done': 'Færdig',
  'messenger_v2.common.save': 'Gem',
  'messenger_v2.common.someone': 'Nogen',
  'messenger_v2.common.you': 'Dig',
  'messenger_v2.common.messenger': 'Messenger',
  'messenger_v2.chat.back': 'Tilbage til samtaler',
  'messenger_v2.chat.more': 'Mere',
  'messenger_v2.chat.more_actions': 'Flere handlinger',
  'messenger_v2.notifications.enabled': 'Desktopnotifikationer aktiveret',
  'messenger_v2.notifications.enabled_message': 'Desktopnotifikationer er aktiveret.',
  'messenger_v2.notifications.reaction_body': 'Reagerede med {emoji} på din besked.',
  'messenger_v2.conversation.reaction_preview': 'Reagerede {emoji} på “{message}”',
  'messenger_v2.conversation.reaction_preview_unknown': 'Reagerede {emoji} på en besked',
  'messenger_v2.notifications.reaction_body_with_preview':
    'Reagerede med {emoji} på din besked: “{message}”',
  'messenger_v2.notifications.blocked': 'Desktopnotifikationer blokeret',
  'messenger_v2.notifications.blocked_message':
    'Desktopnotifikationer er blokeret i browserindstillingerne.',
  'messenger_v2.notifications.unsupported':
    'Desktopnotifikationer understøttes ikke i denne browser.',
  'messenger_v2.notifications.enable': 'Aktivér desktopnotifikationer',
  'messenger_v2.typing.preview': 'Skriver...',
  'messenger_v2.typing.preview_named': '{name} skriver...',
  'messenger_v2.typing.aria': '{name} skriver',
  'messenger_v2.info.open': 'Åbn samtaleinfo',
  'messenger_v2.info.title': 'Samtaleinfo',
  'messenger_v2.info.close': 'Luk samtaleinfo',
  'messenger_v2.info.contact': 'Kontakt',
  'messenger_v2.info.creator': 'Opretter',
  'messenger_v2.info.direct_chat': 'Direkte chat',
  'messenger_v2.info.message_action': 'Besked',
  'messenger_v2.info.block': 'Bloker',
  'messenger_v2.info.block_failed': 'Brugeren kunne ikke blokeres.',
  'messenger_v2.info.block_user': 'Bloker {name}',
  'messenger_v2.info.block_user_confirm':
    'Denne bruger vil ikke se din avatar eller status, og nye beskeder eller opkald fra dem når ikke frem til dig.',
  'messenger_v2.info.block_user_title': 'Bloker "{name}"?',
  'messenger_v2.info.blocking_user': 'Blokerer...',
  'messenger_v2.info.chat_cleared': 'Chat ryddet.',
  'messenger_v2.info.clear_all_messages': 'Ryd alle beskeder',
  'messenger_v2.info.clear_chat': 'Ryd chat',
  'messenger_v2.info.clear_chat_confirm': 'Gamle beskeder fjernes kun for dig.',
  'messenger_v2.info.clear_chat_failed': 'Chatten kunne ikke ryddes.',
  'messenger_v2.info.clear_chat_title': 'Ryd chat?',
  'messenger_v2.info.clear_chat_warning_body':
    'Denne chat bliver tom, men forbliver i din chatliste.',
  'messenger_v2.info.clear_chat_warning_title': 'Ryd alle beskeder fra "{name}"?',
  'messenger_v2.info.chat_deleted': 'Chat slettet.',
  'messenger_v2.info.delete_chat': 'Slet chat',
  'messenger_v2.info.delete_chat_failed': 'Chatten kunne ikke slettes.',
  'messenger_v2.info.delete_chat_warning_body':
    'Denne chat fjernes fra din chatliste. Hvis du starter chatten igen, vises gamle beskeder ikke.',
  'messenger_v2.info.delete_chat_warning_title': 'Slet chat med "{name}"?',
  'messenger_v2.info.clearing_chat': 'Rydder chat...',
  'messenger_v2.info.info': 'Info',
  'messenger_v2.info.media': 'Medier',
  'messenger_v2.info.links': 'Links',
  'messenger_v2.info.docs': 'Dokumenter',
  'messenger_v2.info.media_links_docs': 'Medier, links og dokumenter',
  'messenger_v2.info.starred': 'Stjernemarkeret',
  'messenger_v2.info.encryption': 'Kryptering',
  'messenger_v2.info.members': 'Medlemmer',
  'messenger_v2.info.groups_in_common': 'Fælles grupper',
  'messenger_v2.info.no_media': 'Der er endnu ikke delt medier i denne samtale.',
  'messenger_v2.info.no_links': 'Der er endnu ikke delt links i denne samtale.',
  'messenger_v2.info.no_docs': 'Der er endnu ikke delt dokumenter i denne samtale.',
  'messenger_v2.info.no_common_groups': 'Ingen fælles grupper endnu.',
  'messenger_v2.info.unblock': 'Fjern blokering',
  'messenger_v2.info.unblock_failed': 'Blokeringen kunne ikke fjernes.',
  'messenger_v2.info.unblock_user': 'Fjern blokering af {name}',
  'messenger_v2.info.unblock_user_confirm': 'Denne bruger kan kontakte dig igen.',
  'messenger_v2.info.unblock_user_title': 'Fjern blokering af "{name}"?',
  'messenger_v2.info.unblocking_user': 'Fjerner blokering...',
  'messenger_v2.info.user_blocked': '{name} er blokeret.',
  'messenger_v2.info.user_unblocked': '{name} er ikke længere blokeret.',
  'messenger_v2.info.no_members': 'Ingen medlemmer at vise endnu.',
  'messenger_v2.info.pending_invitations': 'Inviteret - afventer svar',
  'messenger_v2.info.invitation_pending': 'Invitationen afventer svar',
  'messenger_v2.info.document_fallback': 'Dokument',
  'messenger_v2.info.encryption_detail': 'Beskeder er beskyttet i denne samtale.',
  'messenger_v2.info.starred_empty': 'Ingen stjernemarkerede beskeder endnu.',
  'messenger_v2.info.member': 'Medlem',
  'messenger_v2.info.you_label': '{name} (Du)',
  'messenger_v2.info.last_week': 'Sidste uge',
  'messenger_v2.info.this_month': 'Denne måned',
  'messenger_v2.info.date_unknown': 'Tidligere',
  'messenger_v2.composer.add_note': 'Tilføj en note',
  'messenger_v2.composer.add_more_attachments': 'Tilføj flere vedhæftninger',
  'messenger_v2.composer.open_attachments': 'Åbn vedhæftninger',
  'messenger_v2.composer.send': 'Send',
  'messenger_v2.composer.sending': 'Sender',
  'messenger_v2.composer.draft': 'Kladde',
  'messenger_v2.voice.record': 'Optag talebesked',
  'messenger_v2.voice.recording': 'Optager talebesked',
  'messenger_v2.voice.recording_preview': 'Optager talebesked...',
  'messenger_v2.voice.paused': 'Taleoptagelsen er sat på pause',
  'messenger_v2.voice.ready': 'Talebeskeden er klar',
  'messenger_v2.voice.sending': 'Sender talebesked',
  'messenger_v2.voice.pause': 'Sæt optagelsen på pause',
  'messenger_v2.voice.pause_short': 'Pause',
  'messenger_v2.voice.resume': 'Fortsæt optagelsen',
  'messenger_v2.voice.resume_short': 'Fortsæt',
  'messenger_v2.voice.cancel': 'Slet taleoptagelsen',
  'messenger_v2.voice.send': 'Send talebesked',
  'messenger_v2.voice.unsupported': 'Browseren understøtter ikke taleoptagelse.',
  'messenger_v2.voice.permission_denied':
    'Adgang til mikrofonen blev afvist. Tillad mikrofonen, og prøv igen.',
  'messenger_v2.voice.microphone_unavailable': 'Der blev ikke fundet en tilgængelig mikrofon.',
  'messenger_v2.voice.too_short': 'Talebeskeden er for kort. Optag den igen.',
  'messenger_v2.voice.send_failed':
    'Talebeskeden kunne ikke sættes i kø. Tryk på send for at prøve igen.',
  'messenger_v2.voice.recording_failed': 'Talebeskeden kunne ikke optages.',
  'messenger_v2.voice.retry_playback': 'Prøv talebeskeden igen',
  'messenger_v2.voice.pause_playback': 'Sæt talebeskeden på pause',
  'messenger_v2.voice.play': 'Afspil talebesked',
  'messenger_v2.voice.seek': 'Spol i talebeskeden',
  'messenger_v2.voice.uploading': 'Uploader {progress} %',
  'messenger_v2.voice.speed': 'Afspilningshastighed {rate}x',
  'messenger_v2.composer.send_attachments': 'Send vedhæftninger',
  'messenger_v2.composer.sending_attachments': 'Sender vedhæftninger',
  'messenger_v2.composer.file': 'Fil',
  'messenger_v2.composer.image_or_video': 'Billede eller video',
  'messenger_v2.composer.document': 'Dokument',
  'messenger_v2.composer.preview_unavailable':
    'Forhåndsvisning er ikke tilgængelig. Du kan stadig sende det rene link.',
  'messenger_v2.link_preview.error': 'Linkforhåndsvisning er ikke tilgængelig.',
  'messenger_v2.link_preview.remove': 'Fjern linkforhåndsvisning',
  'messenger_v2.attachment.image': 'Billede',
  'messenger_v2.attachment.video': 'Video',
  'messenger_v2.attachment.audio': 'Lyd',
  'messenger_v2.attachment.document': 'Dokument',
  'messenger_v2.attachment.file': 'Fil',
  'messenger_v2.attachment.file_upper': 'FIL',
  'messenger_v2.attachment.attachment': 'Vedhæftning',
  'messenger_v2.attachment.fallback_name': 'Vedhæftning {index}',
  'messenger_v2.attachment.attachments_selected': '{count} vedhæftninger valgt',
  'messenger_v2.attachment.add_attachments': 'Tilføj vedhæftninger',
  'messenger_v2.attachment.edit_image': 'Rediger billede',
  'messenger_v2.attachment.prepare_failed':
    'Den redigerede vedhæftning kunne ikke klargøres. Dine ændringer er stadig her – prøv igen.',
  'messenger_v2.attachment.edit_render_failed':
    'Det redigerede billede kunne ikke oprettes. Dine ændringer er stadig her – prøv igen.',
  'messenger_v2.attachment.encryption_failed':
    'Vedhæftningen kunne ikke krypteres på denne enhed. Prøv igen.',
  'messenger_v2.attachment.storage_warning':
    'Enhedens lager er fuldt. Hold appen åben, mens vedhæftningerne uploades.',
  'messenger_v2.attachment.upload_failed':
    'Den sikre upload blev afbrudt. Kontrollér forbindelsen, og prøv igen.',
  'messenger_v2.attachment.send_failed':
    'Vedhæftningerne kunne ikke sættes i kø. Dine ændringer er stadig her – prøv igen.',
  'messenger_v2.attachment.preparing_progress': 'Forbereder vedhæftninger ({completed}/{total})',
  'messenger_v2.image_editor.close': 'Tilbage',
  'messenger_v2.image_editor.crop': 'Beskær',
  'messenger_v2.image_editor.done': 'Færdig',
  'messenger_v2.image_editor.draw': 'Tegn',
  'messenger_v2.image_editor.emoji': 'Emoji',
  'messenger_v2.image_editor.redo': 'Gentag',
  'messenger_v2.image_editor.text': 'Tekst',
  'messenger_v2.image_editor.title': 'Rediger billede',
  'messenger_v2.image_editor.undo': 'Fortryd',
  'messenger_v2.attachment.drop_files_here': 'Slip filerne her',
  'messenger_v2.attachment.drop_files_hint': 'De føjes til din vedhæftningskladde.',
  'messenger_v2.attachment.no_attachments_selected_title': 'Ingen vedhæftninger valgt endnu',
  'messenger_v2.attachment.no_attachments_selected_text':
    'Vælg filer fra vedhæftningsmenuen for at starte kladden.',
  'messenger_v2.attachment.no_files_selected_title': 'Ingen filer valgt endnu',
  'messenger_v2.attachment.no_files_selected_text':
    'Vælg billeder, videoer, dokumenter eller en fil for at bygge beskedkladden.',
  'messenger_v2.attachment.preview_unavailable': 'Forhåndsvisning er ikke tilgængelig',
  'messenger_v2.attachment.unable_open': 'Denne vedhæftning kunne ikke åbnes. Prøv igen.',
  'messenger_v2.attachment.unable_download': 'Denne vedhæftning kunne ikke downloades. Prøv igen.',
  'messenger_v2.attachment.no_selected': 'Ingen vedhæftning valgt',
  'messenger_v2.attachment.play_video_preview': 'Afspil videoforhåndsvisning',
  'messenger_v2.attachment.close_composer': 'Luk vedhæftningskomponisten',
  'messenger_v2.attachment.close_preview': 'Luk forhåndsvisning af vedhæftning',
  'messenger_v2.attachment.previous': 'Forrige vedhæftning',
  'messenger_v2.attachment.next': 'Næste vedhæftning',
  'messenger_v2.attachment.previous_selected': 'Vis forrige valgte vedhæftning',
  'messenger_v2.attachment.next_selected': 'Vis næste valgte vedhæftning',
  'messenger_v2.attachment.scroll_left': 'Rul vedhæftninger til venstre',
  'messenger_v2.attachment.scroll_right': 'Rul vedhæftninger til højre',
  'messenger_v2.attachment.scroll_selected_left': 'Rul valgte vedhæftninger til venstre',
  'messenger_v2.attachment.scroll_selected_right': 'Rul valgte vedhæftninger til højre',
  'messenger_v2.attachment.remove': 'Fjern {name}',
  'messenger_v2.attachment.open': 'Åbn {name}',
  'messenger_v2.attachment.view': 'Vis {name}',
  'messenger_v2.attachment.download': 'Hent {name}',
  'messenger_v2.attachment.download_action': 'Hent',
  'messenger_v2.attachment.zoom_in': 'Zoom ind på billedet',
  'messenger_v2.attachment.reset_zoom': 'Nulstil billedzoom',
  'messenger_v2.attachment.uploading': 'Uploader {name}',
  'messenger_v2.call.audio': 'Lyd',
  'messenger_v2.call.remote_audio': 'Lyd fra opkaldet',
  'messenger_v2.call.video': 'Video',
  'messenger_v2.call.start_voice': 'Start taleopkald',
  'messenger_v2.call.start_video': 'Start videoopkald',
  'messenger_v2.call.direct_only': 'Opkald er tilgængelige i direkte krypterede chats.',
  'messenger_v2.call.group_needs_members': 'Tilføj et andet medlem for at starte et gruppeopkald.',
  'messenger_v2.call.unavailable': 'Opkald er ikke tilgængelige for denne chat.',
  'messenger_v2.call.blocked_unavailable': 'Opkald er ikke tilgængelige for denne chat.',
  'messenger_v2.call.start_failed': 'Kunne ikke starte taleopkald.',
  'messenger_v2.call.start_video_failed': 'Kunne ikke starte videoopkald.',
  'messenger_v2.call.recipient_device_unavailable':
    'Modtageren skal åbne Netgrav Chat på sin enhed, før du kan ringe krypteret.',
  'messenger_v2.call.accept_failed': 'Kunne ikke besvare taleopkald.',
  'messenger_v2.call.incoming': 'Indgående taleopkald',
  'messenger_v2.call.incoming_video': 'Indgående videoopkald',
  'messenger_v2.call.calling': 'Ringer...',
  'messenger_v2.call.ringing': 'Ringer...',
  'messenger_v2.call.connecting': 'Opretter forbindelse...',
  'messenger_v2.call.reconnecting': 'Opretter forbindelse igen...',
  'messenger_v2.call.active': 'Taleopkald',
  'messenger_v2.call.active_video': 'Videoopkald',
  'messenger_v2.call.accept': 'Besvar opkald',
  'messenger_v2.call.decline': 'Afvis opkald',
  'messenger_v2.call.open': 'Åbn',
  'messenger_v2.call.join': 'Deltag',
  'messenger_v2.call.ignore': 'Ignorer',
  'messenger_v2.call.minimize': 'Minimer opkald',
  'messenger_v2.call.encrypted': 'Ende-til-ende-krypteret',
  'messenger_v2.call.open_chat': 'Åbn chat',
  'messenger_v2.call.change_audio_output': 'Skift lydudgang',
  'messenger_v2.call.mute': 'Slå lyd fra',
  'messenger_v2.call.unmute': 'Slå lyd til',
  'messenger_v2.call.camera_on': 'Slå kamera til',
  'messenger_v2.call.camera_off': 'Slå kamera fra',
  'messenger_v2.call.background_blur_on': 'Slør baggrund',
  'messenger_v2.call.background_blur_off': 'Slå baggrundssløring fra',
  'messenger_v2.call.background_blur_failed': 'Kunne ikke ændre baggrundssløring.',
  'messenger_v2.call.enter_fullscreen': 'Vis fuld skærm',
  'messenger_v2.call.exit_fullscreen': 'Afslut fuld skærm',
  'messenger_v2.call.end': 'Afslut opkald',
  'messenger_v2.call.participant': 'Deltager',
  'messenger_v2.call.you_label': '{name} (dig)',
  'messenger_v2.call.pin_participant': 'Fastgør {name}',
  'messenger_v2.call.unpin_participant': 'Frigør {name}',
  'messenger_v2.call.screen_sharing': 'Skærmdeling',
  'messenger_v2.call.peer_muted': '{name} slog lyden fra i opkaldet',
  'messenger_v2.call.you_muted': 'Du slog lyden fra i opkaldet',
  'messenger_v2.call.history_call': 'Taleopkald',
  'messenger_v2.call.history_video_call': 'Videoopkald',
  'messenger_v2.call.history_group_call': 'Gruppeopkald',
  'messenger_v2.call.history_group_video_call': 'Gruppevideoopkald',
  'messenger_v2.call.history_participants': '{count} medlemmer',
  'messenger_v2.call.members_title': 'Opkaldsmedlemmer',
  'messenger_v2.call.history_missed': 'Ubesvaret taleopkald',
  'messenger_v2.call.history_video_missed': 'Ubesvaret videoopkald',
  'messenger_v2.call.history_declined': 'Taleopkald afvist',
  'messenger_v2.call.history_video_declined': 'Videoopkald afvist',
  'messenger_v2.call.history_cancelled': 'Taleopkald annulleret',
  'messenger_v2.call.history_video_cancelled': 'Videoopkald annulleret',
  'messenger_v2.call.history_failed': 'Taleopkald mislykkedes',
  'messenger_v2.call.history_video_failed': 'Videoopkald mislykkedes',
  'messenger_v2.call.duration_seconds': '{seconds} sek',
  'messenger_v2.call.duration_minutes': '{minutes} min',
  'messenger_v2.call.duration_minutes_seconds': '{minutes} min {seconds} sek',
  'messenger_v2.call.duration_hours': '{hours} t',
  'messenger_v2.call.duration_hours_minutes': '{hours} t {minutes} min',
  'messenger_v2.discard.title': 'Kassér ændringer?',
  'messenger_v2.discard.content': 'Er du sikker på, at du vil kassere dine ændringer?',
  'messenger_v2.discard.confirm': 'Kassér',
  'messenger_v2.discard.cancel': 'Fortsæt redigering',
  'emojiPicker.emojiPicker': 'Emoji-vælger',
  'emojiPicker.reactionPicker': 'Reaktionsvælger',
  'emojiPicker.searchEmoji': 'Søg efter emoji',
  'emojiPicker.searchReactions': 'Søg efter reaktioner',
  'emojiPicker.findEmoji': 'Find den perfekte emoji',
  'emojiPicker.findReaction': 'Find den perfekte reaktion',
  'emojiPicker.categories': 'Emoji-kategorier',
  'emojiPicker.category.frequent': 'Ofte brugt',
  'emojiPicker.category.smileys': 'Smileys og følelser',
  'emojiPicker.category.people': 'Mennesker og krop',
  'emojiPicker.category.animals': 'Dyr og natur',
  'emojiPicker.category.food': 'Mad og drikke',
  'emojiPicker.category.travel': 'Rejser og steder',
  'emojiPicker.category.activities': 'Aktiviteter',
  'emojiPicker.category.objects': 'Genstande',
  'emojiPicker.category.symbols': 'Symboler',
  'emojiPicker.category.flags': 'Flag',
  'emojiPicker.searchResults': 'Søgeresultater',
  'emojiPicker.noResults': 'Ingen emojis matcher din søgning.',
  'emojiPicker.noFrequentlyUsed': 'Dine ofte brugte emojis vises her.',
  'emojiPicker.skinTone': 'Hudtone',
  'emojiPicker.skinTone.default': 'Standardhudtone',
  'emojiPicker.skinTone.light': 'Lys hudtone',
  'emojiPicker.skinTone.mediumLight': 'Mellemlys hudtone',
  'emojiPicker.skinTone.medium': 'Mellem hudtone',
  'emojiPicker.skinTone.mediumDark': 'Mellemmørk hudtone',
  'emojiPicker.skinTone.dark': 'Mørk hudtone',
  'messenger_v2.composer.choose_emoji': 'Vælg emoji',
  'messenger_v2.message.add_reaction': 'Tilføj reaktion',
  'pwa.onboarding.install_title': 'Installér Nettgrav',
  'pwa.onboarding.install_body':
    'Hav Nettgrav kun ét tryk væk, og få en mere pålidelig appoplevelse på denne enhed.',
  'pwa.onboarding.install_action': 'Installér Nettgrav',
  'pwa.onboarding.install_manual_action': 'Jeg forstår',
  'pwa.onboarding.not_now': 'Ikke nu',
  'pwa.onboarding.benefit_messages': 'Beskednotifikationer i baggrunden',
  'pwa.onboarding.benefit_calls': 'Advarsler om indgående opkald',
  'pwa.onboarding.benefit_badge': 'Antal ulæste på appikonet',
  'pwa.onboarding.ios_steps':
    'Tryk på Del i browseren, vælg Føj til hjemmeskærm, og åbn derefter Nettgrav fra det nye ikon.',
  'pwa.onboarding.mac_steps':
    'I Safari skal du vælge Arkiv → Føj til Dock og derefter åbne Nettgrav fra Dock eller Programmer.',
  'pwa.onboarding.notifications_title': 'Gå aldrig glip af en besked eller et opkald',
  'pwa.onboarding.notifications_body':
    'Tillad Nettgrav at give dig besked om nye krypterede beskeder og indgående opkald, selv når appen er lukket.',
  'pwa.onboarding.notifications_action': 'Tillad notifikationer',
  'pwa.onboarding.notifications_denied':
    'Notifikationer er blokeret. Aktivér dem for Nettgrav i browserens eller enhedens notifikationsindstillinger, og prøv igen.',
  'rooms.invite.auth_required': 'Log ind eller opret en konto for at se ruminvitationen.',
  'rooms.invite.back': 'Tilbage til rum',
  'rooms.invite.fail': 'Invitationen er ugyldig eller udløbet.',
  'rooms.invite.join': 'Deltag i rummet',
  'rooms.invite.label': 'Ruminvitation',
  'rooms.invite.loading': 'Indlæser invitation...',
  'rooms.invite.member_count': '{count, plural, one {# medlem} other {# medlemmer}}',
  'rooms.invite.title': 'Ruminvitation',
  'rooms.invite.view': 'Vis rum',
  'rooms.navigation.label': 'Rumsektioner',
  'rooms.state.archived': 'Dette rum er arkiveret.',
  'rooms.state.error': 'Rummet kunne ikke indlæses.',
  'rooms.state.loading': 'Indlæser rum…',
  'rooms.state.removed': 'Dette rum er fjernet.',
  'rooms.state.retry': 'Prøv igen',
  'rooms.tabs.members_chat': 'Medlemschat',
  'rooms.members_chat.title': 'Krypteret medlemschat',
  'rooms.members_chat.description':
    'En privat, end-to-end-krypteret samtale for aktive medlemmer af rummet.',
  'rooms.members_chat.loading': 'Klargør rumchatten…',
  'rooms.members_chat.locked_title': 'Samtale kun for medlemmer',
  'rooms.members_chat.locked':
    'Bliv medlem af rummet for at åbne den krypterede medlemschat. Beskeder og forhåndsvisninger er skjult, indtil dit medlemskab er aktivt.',
  'rooms.members_chat.error': 'Medlemschatten kunne ikke indlæses.',
  'rooms.state.unavailable': 'Rummet findes ikke, eller du har ikke adgang.',
  'rooms.provisioning.action_required': 'Rumchatten kræver opmærksomhed, før den kan bruges.',
  'rooms.provisioning.pending': 'Rumchatten klargøres.',
  'groups.reactions.error': 'Din reaktion kunne ikke opdateres.',
  'groups.media.uploading': 'Uploader medier…',
  'groups.post.published': 'Slået op.',
  retry: 'Prøv igen',
};

export default DAN;
